import HolidayUniIcon from 'components/Logo/HolidayUniIcon'
import { SVGProps } from 'components/Logo/UniIcon'
import styled from 'lib/styled-components'

function Logo({ onClick }: { onClick?: () => void }) {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="20"
    //   height="22"
    //   viewBox="0 0 20 22"
    //   fill="none"
    //   onClick={onClick}
    //   cursor="pointer"
    // >
    //   <path
    //     d="M6.04898 1.5328C5.77502 1.49053 5.76347 1.48557 5.89239 1.46587C6.13945 1.42808 6.72283 1.47958 7.12484 1.57466C8.06336 1.79654 8.91735 2.36494 9.82894 3.37442L10.0711 3.64261L10.4176 3.58721C11.8771 3.35393 13.3619 3.53933 14.6038 4.10994C14.9454 4.26692 15.4841 4.5794 15.5514 4.6597C15.5728 4.6853 15.6122 4.85003 15.6389 5.02582C15.7311 5.63398 15.6849 6.10014 15.4979 6.44831C15.3962 6.63778 15.3905 6.69782 15.4589 6.85997C15.5135 6.98936 15.6658 7.08513 15.8166 7.08492C16.1252 7.08451 16.4574 6.58831 16.6113 5.89789L16.6724 5.62364L16.7935 5.76009C17.4579 6.5087 17.9796 7.52962 18.0693 8.25631L18.0926 8.44578L17.981 8.27353C17.7888 7.97714 17.5957 7.77537 17.3484 7.61264C16.9027 7.31931 16.4314 7.21948 15.1833 7.15406C14.056 7.09498 13.418 6.99921 12.7854 6.79404C11.709 6.445 11.1664 5.98015 9.88789 4.31174C9.31999 3.57068 8.96899 3.16067 8.61984 2.83048C7.82646 2.08022 7.04689 1.68675 6.04898 1.5328Z"
    //     fill="#FC74FE"
    //   />
    //   <path
    //     d="M15.8056 3.1874C15.834 2.69082 15.9017 2.36329 16.0379 2.06417C16.0917 1.94577 16.1422 1.84887 16.15 1.84887C16.1578 1.84887 16.1344 1.93626 16.0979 2.04305C15.999 2.33335 15.9827 2.73041 16.0509 3.19236C16.1374 3.77851 16.1866 3.86308 16.8095 4.49624C17.1017 4.79322 17.4415 5.16778 17.5647 5.32859L17.7887 5.62099L17.5647 5.41202C17.2908 5.15648 16.6608 4.65812 16.5216 4.58688C16.4283 4.5391 16.4145 4.53992 16.3569 4.5969C16.3039 4.6494 16.2927 4.72829 16.2853 5.10123C16.2739 5.68248 16.1942 6.05556 16.002 6.4286C15.898 6.63037 15.8816 6.58731 15.9757 6.35957C16.046 6.18953 16.0531 6.11478 16.0526 5.55209C16.0515 4.42152 15.9165 4.14972 15.1251 3.68412C14.9247 3.56616 14.5943 3.39606 14.3911 3.30608C14.1878 3.2161 14.0264 3.13773 14.0322 3.13187C14.0547 3.10969 14.8265 3.33374 15.1371 3.45259C15.5992 3.62938 15.6754 3.65229 15.7316 3.63096C15.7692 3.61667 15.7874 3.5077 15.8056 3.1874Z"
    //     fill="#FC74FE"
    //   />
    //   <path
    //     d="M6.58113 5.12149C6.02497 4.35993 5.68086 3.19229 5.75536 2.31943L5.77839 2.04932L5.90499 2.0723C6.14272 2.11543 6.55263 2.26718 6.74457 2.38313C7.2713 2.7013 7.49933 3.12019 7.73132 4.19585C7.79928 4.51092 7.88843 4.86746 7.92946 4.98817C7.9955 5.18246 8.24507 5.63629 8.44797 5.93103C8.59412 6.1433 8.49704 6.24389 8.17398 6.21488C7.68059 6.17058 7.01227 5.71183 6.58113 5.12149Z"
    //     fill="#FC74FE"
    //   />
    //   <path
    //     d="M15.1311 10.7894C12.532 9.74852 11.6165 8.84507 11.6165 7.32069C11.6165 7.09636 11.6243 6.91281 11.6338 6.91281C11.6432 6.91281 11.7438 6.98684 11.8572 7.07734C12.3843 7.49779 12.9745 7.67736 14.6083 7.91444C15.5698 8.05396 16.1109 8.16664 16.61 8.33127C18.1963 8.85454 19.1778 9.91646 19.4119 11.3629C19.4799 11.7831 19.44 12.5713 19.3297 12.9867C19.2427 13.3147 18.977 13.9061 18.9066 13.9288C18.8871 13.9351 18.8679 13.8606 18.8629 13.7593C18.8361 13.2162 18.5602 12.6874 18.0968 12.2913C17.5699 11.841 16.862 11.4825 15.1311 10.7894Z"
    //     fill="#FC74FE"
    //   />
    //   <path
    //     d="M13.3064 11.2218C13.2738 11.029 13.2174 10.7829 13.1809 10.6748L13.1146 10.4782L13.2377 10.6158C13.4082 10.8061 13.5429 11.0496 13.6571 11.3739C13.7442 11.6215 13.754 11.6951 13.7534 12.0973C13.7527 12.4922 13.7418 12.575 13.6614 12.7978C13.5345 13.1492 13.377 13.3983 13.1128 13.6657C12.638 14.1463 12.0276 14.4124 11.1468 14.5228C10.9937 14.5419 10.5474 14.5743 10.1551 14.5945C9.16633 14.6457 8.51558 14.7514 7.93085 14.9556C7.84678 14.985 7.77172 15.0028 7.7641 14.9952C7.74044 14.9718 8.13855 14.7358 8.46739 14.5782C8.93106 14.3561 9.39262 14.2348 10.4268 14.0636C10.9376 13.9789 11.4652 13.8763 11.5991 13.8354C12.8642 13.4496 13.5145 12.454 13.3064 11.2218Z"
    //     fill="#FC74FE"
    //   />
    //   <path
    //     d="M14.4979 13.3263C14.1525 12.588 14.0732 11.8751 14.2624 11.2103C14.2827 11.1392 14.3152 11.0811 14.3348 11.0811C14.3544 11.0811 14.4359 11.1249 14.5159 11.1784C14.675 11.285 14.9941 11.4644 15.8444 11.9255C16.9054 12.5009 17.5104 12.9464 17.9218 13.4554C18.2821 13.9012 18.505 14.4089 18.6123 15.028C18.6731 15.3787 18.6375 16.2225 18.547 16.5757C18.2617 17.6891 17.5987 18.5637 16.6531 19.0741C16.5145 19.1488 16.3901 19.2102 16.3767 19.2105C16.3632 19.2108 16.4137 19.0831 16.4889 18.9268C16.807 18.2654 16.8432 17.622 16.6027 16.9059C16.4554 16.4674 16.1552 15.9324 15.5489 15.0282C14.8441 13.9768 14.6713 13.6971 14.4979 13.3263Z"
    //     fill="#FC74FE"
    //   />
    //   <path
    //     d="M4.73535 17.3101C5.69986 16.5001 6.89994 15.9246 7.9931 15.748C8.46422 15.6719 9.24904 15.7021 9.68529 15.8132C10.3846 15.9912 11.0101 16.3898 11.3355 16.8648C11.6534 17.329 11.7898 17.7336 11.9318 18.6336C11.9878 18.9887 12.0488 19.3453 12.0672 19.426C12.1739 19.8924 12.3814 20.2653 12.6386 20.4526C13.0471 20.7499 13.7505 20.7684 14.4424 20.5C14.5598 20.4544 14.6618 20.4229 14.669 20.43C14.694 20.4548 14.3456 20.6868 14.0998 20.8089C13.7691 20.9732 13.5061 21.0367 13.1566 21.0367C12.5229 21.0367 11.9967 20.7161 11.5577 20.0623C11.4713 19.9336 11.2771 19.5482 11.1262 19.2059C10.6626 18.1543 10.4337 17.834 9.89554 17.4834C9.42717 17.1784 8.82312 17.1237 8.3687 17.3453C7.77179 17.6364 7.60525 18.3951 8.03277 18.8759C8.20269 19.067 8.51955 19.2318 8.77865 19.2639C9.26337 19.3239 9.67993 18.9571 9.67993 18.4703C9.67993 18.1543 9.5578 17.9739 9.25033 17.8359C8.83039 17.6475 8.379 17.8678 8.38116 18.2601C8.3821 18.4274 8.45535 18.5325 8.62398 18.6084C8.73216 18.6571 8.73467 18.6609 8.64646 18.6427C8.26115 18.5632 8.17088 18.1012 8.48068 17.7945C8.85263 17.4263 9.62176 17.5888 9.88587 18.0914C9.99684 18.3025 10.0097 18.7229 9.91297 18.9768C9.69646 19.545 9.06517 19.8438 8.42476 19.6812C7.98875 19.5705 7.81122 19.4506 7.28553 18.9121C6.37207 17.9762 6.01745 17.7949 4.70055 17.5904L4.44819 17.5512L4.73535 17.3101Z"
    //     fill="#FC74FE"
    //   />
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M0.44926 0.55979C3.4998 4.24228 5.60086 5.76161 5.83435 6.0826C6.02713 6.34765 5.95457 6.58593 5.62431 6.77268C5.44065 6.87651 5.06307 6.98171 4.87401 6.98171C4.66018 6.98171 4.58677 6.89967 4.58677 6.89967C4.46279 6.78271 4.39296 6.80317 3.75628 5.67912C2.87236 4.31495 2.13263 3.18331 2.11245 3.16437C2.06579 3.12055 2.06659 3.12203 3.66615 5.96862C3.92459 6.56192 3.71756 6.7797 3.71756 6.86421C3.71756 7.03611 3.67041 7.12646 3.4572 7.36299C3.10178 7.75736 2.9429 8.20047 2.82821 9.11753C2.69963 10.1455 2.33809 10.8717 1.33613 12.1146C0.749626 12.8421 0.653656 12.9754 0.505663 13.2687C0.319254 13.6379 0.267998 13.8447 0.247224 14.311C0.225267 14.804 0.268031 15.1225 0.419469 15.5939C0.552047 16.0065 0.690435 16.279 1.04422 16.824C1.34953 17.2944 1.52533 17.6439 1.52533 17.7806C1.52533 17.8894 1.54621 17.8895 2.01931 17.7833C3.15151 17.529 4.07085 17.0817 4.58791 16.5337C4.9079 16.1944 4.98303 16.0071 4.98547 15.5422C4.98707 15.2381 4.97631 15.1745 4.89367 14.9995C4.75914 14.7148 4.51424 14.4781 3.97447 14.1111C3.26721 13.6302 2.96514 13.2431 2.88169 12.7107C2.81325 12.2738 2.89265 11.9656 3.28391 11.15C3.68888 10.3058 3.78924 9.94602 3.85713 9.09507C3.90097 8.5453 3.96169 8.32848 4.12051 8.15445C4.28614 7.97297 4.43525 7.91151 4.84517 7.85581C5.51345 7.765 5.93898 7.59304 6.28876 7.27246C6.5922 6.99435 6.71917 6.72638 6.73866 6.32298L6.75345 6.01722L6.58388 5.82059C5.96981 5.10846 0.0380236 0 0.000233728 0C-0.00783924 0 0.194231 0.251923 0.44926 0.55979ZM1.87003 14.8689C2.00887 14.6243 1.9351 14.3099 1.70287 14.1563C1.48343 14.0112 1.14256 14.0795 1.14256 14.2687C1.14256 14.3264 1.17464 14.3684 1.24695 14.4054C1.36871 14.4677 1.37754 14.5378 1.28175 14.681C1.18473 14.826 1.19256 14.9535 1.30384 15.0402C1.48319 15.1799 1.73707 15.103 1.87003 14.8689Z"
    //     fill="#FC74FE"
    //   />
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M7.17519 8.0162C6.86146 8.11204 6.55649 8.44275 6.46209 8.78951C6.4045 9.00105 6.43718 9.37214 6.52344 9.48675C6.6628 9.67184 6.79757 9.72061 7.16249 9.71807C7.87695 9.71311 8.49805 9.40834 8.57025 9.02734C8.62944 8.71503 8.35666 8.28221 7.98092 8.0922C7.78703 7.99419 7.37468 7.9553 7.17519 8.0162ZM8.01039 8.66577C8.12056 8.51006 8.07237 8.34178 7.88498 8.22796C7.52814 8.01124 6.9885 8.19058 6.9885 8.52587C6.9885 8.69277 7.26991 8.87487 7.52786 8.87487C7.69955 8.87487 7.9345 8.77304 8.01039 8.66577Z"
    //     fill="#FC74FE"
    //   />
    // </svg>
    <svg 
    version="1.1" 
    id="Layer_1" 
    xmlns="http://www.w3.org/2000/svg" 
    height="22" 
    width="100%" 
    viewBox="0 0 200 200" 
    fill="none"
    onClick={onClick}
    cursor="pointer"
    >
  <path fill="#C7EFCB" opacity="1.000000" stroke="none" d="
M1.000000,54.000000 
	C1.000000,36.404541 1.000000,18.809080 1.000000,1.000000 
	C19.353676,1.000000 37.708179,1.000000 56.531185,1.248251 
	C56.999687,1.496502 56.999027,1.993004 56.745094,2.272437 
	C54.458267,3.037306 52.315086,3.270499 50.430252,4.094582 
	C49.117603,4.668496 48.159454,6.053206 46.959015,7.326989 
	C46.582611,7.767684 46.290134,7.957111 45.642838,8.082487 
	C44.189163,8.401476 43.090317,8.784514 41.726265,9.127222 
	C41.266785,9.370805 41.072510,9.654716 40.909447,9.946394 
	C40.940659,9.954159 40.918625,9.893566 40.607670,9.908937 
	C39.883705,9.958823 39.470699,9.993337 38.748146,9.891636 
	C30.044912,8.052622 26.080339,15.100520 20.723898,19.075274 
	C17.719774,21.304483 16.108280,25.342833 13.232245,27.829107 
	C9.515862,31.041847 8.819170,34.631554 9.917774,39.296204 
	C9.589032,40.052216 9.289735,40.522457 8.650015,41.079010 
	C6.539231,45.110264 4.768869,49.055210 2.744266,53.116291 
	C1.993349,53.488285 1.496674,53.744141 1.000000,54.000000 
z"/>
  <path fill="#C8EFCB" opacity="1.000000" stroke="none" d="
M145.000000,1.000000 
	C163.587799,1.000000 182.175583,1.000000 201.000000,1.000000 
	C201.000000,16.686768 201.000000,32.374725 200.672699,48.462311 
	C198.565842,47.573479 196.786255,46.285011 194.997787,44.669701 
	C194.984543,43.906910 194.980179,43.470963 194.926117,42.722435 
	C194.256638,41.937069 193.636856,41.464275 193.011108,40.995132 
	C193.005127,40.998787 193.005585,40.993511 193.005951,40.565475 
	C192.368256,36.291683 191.730194,32.445930 191.066467,28.445520 
	C188.929886,28.667946 187.491425,28.817692 186.032181,28.596327 
	C183.603333,20.769312 177.225189,16.568565 171.803162,11.789014 
	C170.416718,10.566854 166.893997,7.114078 163.662201,11.041088 
	C162.927231,10.932642 162.506378,10.877172 161.958313,10.552862 
	C161.204086,9.896382 160.577057,9.508743 159.956573,8.762370 
	C159.641907,7.268912 159.320648,6.134189 159.204468,4.980964 
	C159.616089,4.818189 159.822647,4.673914 160.029205,4.529636 
	C159.908676,4.483089 159.735291,4.361740 159.676819,4.403041 
	C159.432526,4.575602 159.222748,4.797008 158.629028,4.981044 
	C156.457993,4.492633 154.670776,3.966583 152.855515,3.568370 
	C150.247726,2.996305 147.619537,2.517363 145.000031,1.749003 
	C145.000000,1.499335 145.000000,1.000000 145.000000,1.000000 
z"/>
  <path fill="#C8EFCB" opacity="1.000000" stroke="none" d="
M201.000000,153.000000 
	C201.000000,168.926727 201.000000,184.853470 201.000000,201.000000 
	C185.313126,201.000000 169.625214,201.000000 153.481262,200.649872 
	C153.686401,198.875946 154.347595,197.452179 155.349548,195.975021 
	C156.794159,195.618027 157.897995,195.314438 159.275116,195.255798 
	C164.721298,196.124130 171.050095,193.065186 173.001068,188.751099 
	C173.002731,188.502808 173.006180,188.006210 173.357391,187.954376 
	C178.325607,183.556122 183.439240,179.610046 187.381317,174.719589 
	C189.920090,171.570068 194.513489,168.452866 192.053711,162.713348 
	C192.392761,161.949432 192.696686,161.474716 193.333130,160.923859 
	C194.104385,159.889435 194.543106,158.931168 194.983383,157.729614 
	C194.984924,157.486328 195.000610,157.000000 195.340118,156.949921 
	C197.453079,155.599899 199.226532,154.299957 201.000000,153.000000 
z"/>
  <path fill="#C8EFCB" opacity="1.000000" stroke="none" d="
M49.000000,201.000000 
	C33.073269,201.000000 17.146536,201.000000 1.000000,201.000000 
	C1.000000,185.313126 1.000000,169.625214 1.341893,153.558914 
	C3.145843,156.518036 4.490018,159.915283 6.133794,163.160767 
	C6.710373,164.299164 8.022955,165.064774 9.013889,166.358215 
	C10.681788,168.479507 12.335253,170.243210 13.994509,172.252289 
	C14.000299,172.497665 14.009580,172.988464 14.054610,173.339325 
	C15.603335,175.975342 15.829408,179.678238 20.326813,179.011841 
	C21.092936,179.022507 21.530567,179.027267 22.166870,179.174988 
	C22.611465,179.542572 22.793159,179.810715 22.788406,180.416153 
	C21.981945,185.609039 26.331539,186.662369 29.054966,189.351334 
	C32.330799,194.238037 38.461319,196.581467 43.340637,195.053482 
	C44.785614,195.406677 45.888264,195.717758 47.068611,196.362717 
	C47.764210,198.131073 48.382107,199.565536 49.000000,201.000000 
z"/>
  <path fill="#C4EBC9" opacity="1.000000" stroke="none" d="
M8.999455,166.000610 
	C8.022955,165.064774 6.710373,164.299164 6.133794,163.160767 
	C4.490018,159.915283 3.145843,156.518036 1.341893,153.090256 
	C1.000000,120.312439 1.000000,87.624878 1.000000,54.468658 
	C1.496674,53.744141 1.993349,53.488285 2.747616,53.486073 
	C3.674235,54.827209 4.343262,55.914707 5.013453,57.373276 
	C5.342001,59.163059 5.669387,60.581768 5.989288,62.469063 
	C5.958830,87.628906 5.935856,112.320168 5.525232,137.034760 
	C1.823467,140.028275 2.166713,144.525452 5.981656,148.422485 
	C6.994851,152.897446 7.998832,156.946228 9.002251,161.412109 
	C9.000946,163.219696 9.000201,164.610153 8.999455,166.000610 
z"/>
  <path fill="#C2E8C5" opacity="1.000000" stroke="none" d="
M201.000000,152.625000 
	C199.226532,154.299957 197.453079,155.599899 195.336960,156.568390 
	C194.694260,154.814240 194.394226,153.391571 194.130829,151.608566 
	C194.400452,149.817551 194.633453,148.386856 194.900299,146.961609 
	C194.934128,146.967056 194.995758,146.997086 195.324326,146.915283 
	C195.466110,145.551102 195.279327,144.268738 195.081085,142.590256 
	C195.107697,141.140091 195.145752,140.086044 195.578934,138.992676 
	C196.647156,137.812225 197.901749,136.674042 197.907516,135.529572 
	C198.022919,112.574593 198.038300,89.618591 197.874710,66.664207 
	C197.865891,65.424988 196.113098,64.198189 195.129379,62.520882 
	C195.041992,59.389297 194.997360,56.702435 194.975891,53.680565 
	C195.004501,52.898079 195.009933,52.450603 195.251251,51.744308 
	C195.326981,49.322506 195.166824,47.159523 195.006683,44.996544 
	C196.786255,46.285011 198.565842,47.573479 200.672699,48.930969 
	C201.000000,80.354225 201.000000,111.708458 200.649963,143.632294 
	C198.517380,146.378006 197.857361,148.418579 201.000000,150.000000 
	C201.000000,150.750000 201.000000,151.500000 201.000000,152.625000 
z"/>
  <path fill="#C4EAC8" opacity="1.000000" stroke="none" d="
M49.468658,201.000000 
	C48.382107,199.565536 47.764210,198.131073 47.451561,196.352997 
	C49.174294,195.688629 50.591778,195.367874 52.422188,195.042175 
	C54.209667,195.085861 55.584217,195.134491 56.992973,195.558884 
	C59.931873,196.955643 62.822315,198.809906 65.743622,198.859879 
	C82.365685,199.144272 98.995102,198.998734 115.622025,198.997818 
	C122.937859,198.997421 130.262466,199.198441 137.565063,198.886337 
	C140.352646,198.767212 144.179855,199.562714 145.242859,195.042465 
	C145.465866,194.972198 145.920914,194.864517 146.263885,194.914246 
	C147.067719,194.963486 147.528549,194.962967 148.324127,194.986038 
	C149.106018,195.022888 149.553177,195.036133 150.280762,195.289948 
	C152.043732,195.696487 153.526260,195.862442 155.008789,196.028412 
	C154.347595,197.452179 153.686401,198.875946 153.012604,200.649872 
	C118.645775,201.000000 84.291542,201.000000 49.468658,201.000000 
z"/>
  <path fill="#C9EBD0" opacity="1.000000" stroke="none" d="
M144.531342,1.000000 
	C145.000000,1.000000 145.000000,1.499335 144.531357,1.751538 
	C115.041481,2.000162 86.020256,1.996583 56.999027,1.993004 
	C56.999027,1.993004 56.999687,1.496502 56.999844,1.248251 
	C86.020897,1.000000 115.041786,1.000000 144.531342,1.000000 
z"/>
  <path fill="#C8EFCB" opacity="1.000000" stroke="none" d="
M201.000000,149.571533 
	C197.857361,148.418579 198.517380,146.378006 200.649963,144.100952 
	C201.000000,145.714355 201.000000,147.428711 201.000000,149.571533 
z"/>
  <path fill="#BEE8BE" opacity="1.000000" stroke="none" d="
M56.745094,2.272437 
	C86.020256,1.996583 115.041481,2.000162 144.531372,2.001206 
	C147.619537,2.517363 150.247726,2.996305 152.855515,3.568370 
	C154.670776,3.966583 156.457993,4.492633 158.628876,4.980789 
	C159.000000,5.000000 158.999390,4.999466 158.999390,4.999466 
	C159.320648,6.134189 159.641907,7.268912 159.574478,8.706057 
	C154.806763,8.297717 150.427704,7.586957 145.973175,6.632620 
	C145.568619,6.013031 145.239532,5.637019 144.644821,4.940696 
	C143.257156,4.414572 142.135376,4.030503 141.013092,4.029072 
	C114.421318,3.995142 87.829468,3.987383 61.237770,4.043970 
	C59.826672,4.046973 58.416866,4.657266 56.670658,5.179319 
	C53.892189,5.955520 51.449516,6.537247 48.683311,7.048914 
	C47.920830,7.011143 47.481888,7.043432 47.042942,7.075721 
	C48.159454,6.053206 49.117603,4.668496 50.430252,4.094582 
	C52.315086,3.270499 54.458267,3.037306 56.745094,2.272437 
z"/>
  <path fill="#BEE2C2" opacity="1.000000" stroke="none" d="
M9.947218,39.010441 
	C8.819170,34.631554 9.515862,31.041847 13.232245,27.829107 
	C16.108280,25.342833 17.719774,21.304483 20.723898,19.075274 
	C26.080339,15.100520 30.044912,8.052622 38.664749,10.158306 
	C38.585251,10.762405 38.279606,10.963622 37.712738,11.137705 
	C37.254734,11.389165 37.057949,11.667757 36.917931,11.953510 
	C36.974697,11.960671 36.970589,11.846314 36.649063,11.902449 
	C35.839069,12.289904 35.350601,12.621226 34.544147,12.975063 
	C33.467331,13.619884 32.708500,14.242190 31.637877,15.002460 
	C29.220425,17.152918 27.114761,19.165411 24.673729,21.216421 
	C22.559584,23.161930 20.780811,25.068922 18.712437,27.089523 
	C17.931583,28.096758 17.440332,28.990383 16.702618,29.970526 
	C16.360207,30.361526 16.264261,30.666008 16.048281,31.253628 
	C15.558547,32.018478 15.188851,32.500191 14.486301,33.050838 
	C12.751369,35.083328 11.349294,37.046883 9.947218,39.010441 
z"/>
  <path fill="#27225F" opacity="1.000000" stroke="none" d="
M31.949665,14.864496 
	C32.708500,14.242190 33.467331,13.619884 34.858925,12.952707 
	C35.984653,12.553995 36.477619,12.200154 36.970589,11.846314 
	C36.970589,11.846314 36.974697,11.960671 37.133812,11.868836 
	C37.576107,11.635430 37.803120,11.431376 37.973961,11.164837 
	C38.279606,10.963622 38.585251,10.762405 38.974293,10.294519 
	C39.470699,9.993337 39.883705,9.958823 40.541355,10.199816 
	C42.016682,11.748612 43.247368,13.021904 44.478054,14.295195 
	C44.984589,14.001058 45.491127,13.706921 45.997662,13.412783 
	C45.997662,11.657368 45.997662,9.901953 45.997662,8.146538 
	C46.290134,7.957111 46.582611,7.767684 46.959015,7.326990 
	C47.481888,7.043432 47.920830,7.011143 48.667877,7.423820 
	C49.354664,9.867025 49.054054,12.887611 50.237843,13.674179 
	C53.973972,16.156654 54.075672,17.819365 50.355709,20.220974 
	C49.275200,20.918550 48.740047,22.460848 47.810856,23.827833 
	C45.553402,22.347715 43.003345,21.389851 41.549767,19.560663 
	C39.180447,16.579090 37.463276,13.193062 32.991253,16.375753 
	C32.644058,15.872001 32.296860,15.368248 31.949665,14.864496 
z"/>
  <path fill="#BEE3C2" opacity="1.000000" stroke="none" d="
M5.012290,57.002201 
	C4.343262,55.914707 3.674235,54.827209 3.001858,53.369934 
	C4.768869,49.055210 6.539231,45.110264 8.651715,41.462082 
	C8.651669,44.173038 8.309498,46.587234 8.071428,49.220043 
	C8.348632,49.713181 8.552376,49.962685 8.849749,50.408070 
	C8.912736,50.628971 9.041089,51.070087 8.978640,51.315887 
	C8.853669,51.718773 8.791149,51.875862 8.361544,52.042912 
	C7.332560,53.709042 6.670662,55.365204 5.759603,57.018784 
	C5.510442,57.016201 5.012290,57.002201 5.012290,57.002201 
z"/>
  <path fill="#B1D1B6" opacity="1.000000" stroke="none" d="
M7.967328,49.001434 
	C8.309498,46.587234 8.651669,44.173038 8.992138,41.375771 
	C9.289735,40.522457 9.589032,40.052216 9.917774,39.296204 
	C11.349294,37.046883 12.751369,35.083328 14.562527,33.416981 
	C13.707917,36.823669 12.444227,39.933144 10.989250,43.383167 
	C10.495473,45.478825 10.192983,47.233932 9.926481,48.992878 
	C9.962470,48.996712 9.957441,48.924503 9.746170,48.950256 
	C9.534899,48.976013 9.115434,49.052017 8.828516,49.036903 
	C8.350175,49.015011 8.158751,49.008224 7.967328,49.001434 
z"/>
  <path fill="#201C55" opacity="1.000000" stroke="none" d="
M45.642838,8.082487 
	C45.997662,9.901953 45.997662,11.657368 45.997662,13.412783 
	C45.491127,13.706921 44.984589,14.001058 44.478054,14.295195 
	C43.247368,13.021904 42.016682,11.748612 40.852310,10.184444 
	C40.918625,9.893566 40.940659,9.954159 41.129356,9.873050 
	C41.596039,9.641531 41.820511,9.433401 41.991467,9.167551 
	C43.090317,8.784514 44.189163,8.401476 45.642838,8.082487 
z"/>
  <path fill="#27225F" opacity="1.000000" stroke="none" d="
M41.726265,9.127222 
	C41.820511,9.433401 41.596039,9.641531 41.098145,9.865284 
	C41.072510,9.654716 41.266785,9.370805 41.726265,9.127222 
z"/>
  <path fill="#211B58" opacity="1.000000" stroke="none" d="
M146.048660,6.876197 
	C150.427704,7.586957 154.806763,8.297717 159.567902,9.064791 
	C160.577057,9.508743 161.204086,9.896382 161.847961,10.837631 
	C163.253448,13.269233 164.642105,15.147224 165.694305,17.088617 
	C162.614792,19.321341 159.871765,21.490660 157.128738,23.659981 
	C157.553696,24.241243 157.978668,24.822508 158.403625,25.403770 
	C161.270691,23.598179 164.137756,21.792585 167.347061,20.000086 
	C169.125702,20.675976 170.562119,21.338774 172.203613,21.874535 
	C172.665115,21.542387 172.861237,21.290373 173.032867,20.702318 
	C173.371063,19.934879 173.673508,19.456573 174.092926,19.114634 
	C174.488342,19.130316 174.766800,19.009630 175.334137,19.027327 
	C176.036331,19.649942 176.449631,20.134178 176.503235,20.777695 
	C174.429276,22.290434 172.714996,23.643894 170.750366,24.998409 
	C170.333145,24.999771 170.166260,25.000076 169.595169,25.003016 
	C163.128113,27.337238 157.065277,29.668825 150.711060,31.869209 
	C149.612915,31.492004 148.806152,31.246002 147.777817,30.811581 
	C147.370422,30.082617 147.184601,29.542070 147.413208,29.001013 
	C150.412842,28.363760 152.998047,27.727020 155.583267,27.090281 
	C155.499466,26.576046 155.415680,26.061811 155.331879,25.547577 
	C151.416122,25.547577 147.500366,25.547577 143.682281,25.547577 
	C143.976624,26.318880 144.488312,27.659708 144.921829,29.327229 
	C143.301865,29.604092 141.155396,30.173147 140.341705,29.378117 
	C138.538742,27.616510 137.404999,25.169979 136.342651,23.048468 
	C137.709000,22.980083 138.731003,22.865986 139.753021,22.751888 
	C138.429443,20.813108 137.105881,18.874327 135.448181,16.446114 
	C140.366501,15.008093 145.598679,13.398404 146.048660,6.876197 
z"/>
  <path fill="#BDDFC2" opacity="1.000000" stroke="none" d="
M176.862915,20.618416 
	C176.449631,20.134178 176.036331,19.649942 175.254852,18.786339 
	C174.589737,18.319345 174.292847,18.231716 173.698334,17.970476 
	C170.259247,15.562596 167.117767,13.328329 163.976303,11.094063 
	C166.893997,7.114078 170.416718,10.566854 171.803162,11.789014 
	C177.225189,16.568565 183.603333,20.769312 185.814377,28.737480 
	C185.405518,29.518635 185.193695,29.787529 184.662781,29.925819 
	C181.850113,26.736282 179.356506,23.677349 176.862915,20.618416 
z"/>
  <path fill="#B3D2B9" opacity="1.000000" stroke="none" d="
M194.997787,44.669701 
	C195.166824,47.159523 195.326981,49.322506 195.016754,51.533375 
	C193.746872,50.709782 192.947372,49.838303 192.080978,48.640144 
	C191.954803,47.873260 191.895523,47.433056 191.793610,46.633617 
	C189.833908,41.516266 187.916824,36.758148 186.350143,32.041443 
	C188.802231,35.053078 190.903900,38.023296 193.005585,40.993515 
	C193.005585,40.993511 193.005127,40.998787 193.065002,41.304585 
	C193.741867,42.085258 194.358856,42.560135 194.975830,43.035011 
	C194.980179,43.470963 194.984543,43.906910 194.997787,44.669701 
z"/>
  <path fill="#2A2565" opacity="1.000000" stroke="none" d="
M163.662201,11.041086 
	C167.117767,13.328329 170.259247,15.562596 173.694946,18.179056 
	C173.989166,18.561249 173.975967,18.978271 173.975967,18.978270 
	C173.673508,19.456573 173.371063,19.934879 172.825928,20.827274 
	C172.325165,21.446169 172.130249,21.699572 171.998520,22.001574 
	C170.562119,21.338774 169.125702,20.675976 167.215027,19.713528 
	C166.504105,18.617655 166.267441,17.821434 166.030777,17.025215 
	C164.642105,15.147224 163.253448,13.269233 161.975159,11.106473 
	C162.506378,10.877172 162.927231,10.932642 163.662201,11.041086 
z"/>
  <path fill="#BFE6C1" opacity="1.000000" stroke="none" d="
M193.005951,40.565475 
	C190.903900,38.023296 188.802231,35.053078 186.073105,31.926149 
	C185.291061,31.198435 185.136459,30.627428 184.981857,30.056419 
	C185.193695,29.787529 185.405518,29.518635 185.835159,29.108589 
	C187.491425,28.817692 188.929886,28.667946 191.066467,28.445520 
	C191.730194,32.445930 192.368256,36.291683 193.005951,40.565475 
z"/>
  <path fill="#C2E8C5" opacity="1.000000" stroke="none" d="
M194.926117,42.722435 
	C194.358856,42.560135 193.741867,42.085258 193.070984,41.300934 
	C193.636856,41.464275 194.256638,41.937069 194.926117,42.722435 
z"/>
  <path fill="#BEE8BE" opacity="1.000000" stroke="none" d="
M159.000153,5.000255 
	C159.222748,4.797008 159.432526,4.575602 159.676819,4.403041 
	C159.735291,4.361740 159.908676,4.483089 160.029205,4.529636 
	C159.822647,4.673914 159.616089,4.818189 159.204468,4.980965 
	C158.999390,4.999466 159.000000,5.000000 159.000153,5.000255 
z"/>
  <path fill="#B0D3B3" opacity="1.000000" stroke="none" d="
M194.094193,151.968903 
	C194.394226,153.391571 194.694260,154.814240 194.997467,156.618454 
	C195.000610,157.000000 194.984924,157.486328 194.655228,157.813293 
	C193.883896,159.093521 193.442261,160.046753 193.000610,161.000000 
	C192.696686,161.474716 192.392761,161.949432 191.789062,162.930267 
	C187.805939,169.009460 186.618347,176.573563 179.030884,178.701569 
	C179.017227,177.912704 179.013687,177.462341 179.215454,176.745483 
	C180.969818,174.574799 182.876404,172.856064 183.983307,170.722473 
	C185.601654,167.602997 186.646317,164.185883 187.979279,160.529312 
	C188.741898,158.115158 189.460724,156.067337 190.509949,154.005341 
	C191.924957,153.317078 193.009583,152.642990 194.094193,151.968903 
z"/>
  <path fill="#C0E5C3" opacity="1.000000" stroke="none" d="
M179.040985,179.040070 
	C186.618347,176.573563 187.805939,169.009460 191.753922,163.219482 
	C194.513489,168.452866 189.920090,171.570068 187.381317,174.719589 
	C183.439240,179.610046 178.325607,183.556122 173.351379,187.948135 
	C172.994171,187.993744 172.983383,187.982208 173.039978,187.648987 
	C174.053528,185.863205 175.010513,184.410675 176.048492,182.637726 
	C177.100006,181.224915 178.070496,180.132492 179.040985,179.040070 
z"/>
  <path fill="#C4EAC8" opacity="1.000000" stroke="none" d="
M172.999390,188.999390 
	C171.050095,193.065186 164.721298,196.124130 159.276428,194.925293 
	C159.010239,193.909500 159.016006,193.469147 159.432678,193.021088 
	C162.891556,192.006088 165.939545,190.998825 169.330811,189.948212 
	C170.782516,189.603027 171.890961,189.301208 172.999390,188.999390 
z"/>
  <path fill="#B7DBBA" opacity="1.000000" stroke="none" d="
M159.021790,193.028809 
	C159.016006,193.469147 159.010239,193.909500 159.003143,194.680328 
	C157.897995,195.314438 156.794159,195.618027 155.349548,195.975021 
	C153.526260,195.862442 152.043732,195.696487 150.287048,194.958725 
	C150.035873,193.947815 150.058838,193.508713 150.402191,193.064911 
	C151.149414,193.041687 151.576233,193.023163 152.438950,193.004303 
	C154.912872,192.998016 156.950882,192.992035 158.996826,192.996170 
	C159.004761,193.006287 159.021790,193.028809 159.021790,193.028809 
z"/>
  <path fill="#C2E8C5" opacity="1.000000" stroke="none" d="
M193.333130,160.923859 
	C193.442261,160.046753 193.883896,159.093521 194.653687,158.056580 
	C194.543106,158.931168 194.104385,159.889435 193.333130,160.923859 
z"/>
  <path fill="#C0E5C3" opacity="1.000000" stroke="none" d="
M173.001068,188.751099 
	C171.890961,189.301208 170.782516,189.603027 169.424347,189.605972 
	C170.444214,188.865463 171.713791,188.423843 172.983383,187.982208 
	C172.983383,187.982208 172.994171,187.993744 173.000183,187.999969 
	C173.006180,188.006210 173.002731,188.502808 173.001068,188.751099 
z"/>
  <path fill="#C4EAC8" opacity="1.000000" stroke="none" d="
M42.998302,195.011353 
	C38.461319,196.581467 32.330799,194.238037 29.398111,189.397171 
	C30.795284,189.392044 31.904428,189.692230 33.247913,190.258972 
	C36.647274,191.360916 39.812298,192.196320 42.982700,193.361572 
	C42.991489,194.131393 42.994896,194.571365 42.998302,195.011353 
z"/>
  <path fill="#A1C3A5" opacity="1.000000" stroke="none" d="
M22.910629,180.122391 
	C22.793159,179.810715 22.611465,179.542572 22.167538,178.819000 
	C21.315208,176.877258 20.660885,175.434464 20.347546,174.034286 
	C21.783907,174.392944 22.879286,174.709000 24.043991,175.358902 
	C26.398088,177.806274 28.682861,179.919785 31.082275,182.281006 
	C31.464336,182.999786 31.731754,183.470886 31.794220,184.160797 
	C30.049574,183.937881 28.509878,183.496170 26.692705,182.881226 
	C25.247026,181.846115 24.078827,180.984253 22.910629,180.122391 
z"/>
  <path fill="#B4D8B7" opacity="1.000000" stroke="none" d="
M20.006563,173.991684 
	C20.660885,175.434464 21.315208,176.877258 21.968864,178.676025 
	C21.530567,179.027267 21.092936,179.022507 20.256977,178.682526 
	C17.908958,176.561050 15.959270,174.774750 14.009581,172.988464 
	C14.009580,172.988464 14.000299,172.497665 13.999256,171.846466 
	C14.014573,170.113770 14.030933,169.032257 14.339539,168.123199 
	C16.067698,168.873184 17.503614,169.450714 18.974022,170.257935 
	C19.008516,170.487625 19.118467,170.938934 19.093456,171.275070 
	C19.381153,172.404694 19.693859,173.198196 20.006563,173.991684 
z"/>
  <path fill="#C0E5C4" opacity="1.000000" stroke="none" d="
M14.047293,167.950745 
	C14.030933,169.032257 14.014573,170.113770 13.993465,171.601105 
	C12.335253,170.243210 10.681788,168.479507 9.013891,166.358215 
	C9.000201,164.610153 9.000946,163.219696 9.328904,161.414490 
	C10.091666,161.007248 10.527214,161.014786 10.983068,161.382477 
	C12.018013,163.811996 13.032653,165.881378 14.047293,167.950745 
z"/>
  <path fill="#C0E5C4" opacity="1.000000" stroke="none" d="
M22.788406,180.416153 
	C24.078827,180.984253 25.247026,181.846115 26.755661,183.220581 
	C29.068590,185.819595 31.041086,187.906006 33.013577,189.992432 
	C31.904428,189.692230 30.795284,189.392044 29.342995,189.046021 
	C26.331539,186.662369 21.981945,185.609039 22.788406,180.416153 
z"/>
  <path fill="#B7DBBA" opacity="1.000000" stroke="none" d="
M43.340637,195.053482 
	C42.994896,194.571365 42.991489,194.131393 42.996574,193.342407 
	C43.005066,192.993393 43.032501,192.956192 43.387424,192.964920 
	C44.829033,192.670624 45.915714,192.367584 47.320847,192.069656 
	C48.062710,192.089630 48.486118,192.104507 48.998711,192.426117 
	C50.061680,193.504272 51.035469,194.275711 52.009262,195.047134 
	C50.591778,195.367874 49.174294,195.688629 47.373859,196.019104 
	C45.888264,195.717758 44.785614,195.406677 43.340637,195.053482 
z"/>
  <path fill="#C0E5C4" opacity="1.000000" stroke="none" d="
M14.054611,173.339325 
	C15.959270,174.774750 17.908958,176.561050 19.928482,178.676636 
	C15.829408,179.678238 15.603335,175.975342 14.054611,173.339325 
z"/>
  <path fill="#A5C7A7" opacity="1.000000" stroke="none" d="
M5.912882,137.011429 
	C5.935856,112.320168 5.958830,87.628906 6.235051,62.214024 
	C6.658865,60.327087 6.829433,59.163773 7.200511,57.771202 
	C7.966853,57.342457 8.532685,57.142971 9.167123,56.840569 
	C9.235728,56.737656 9.453516,56.855228 9.370529,57.192768 
	C9.345380,57.754700 9.403218,57.979095 9.452161,58.531384 
	C9.449631,59.515118 9.455998,60.170963 9.316437,61.288742 
	C9.282478,69.602615 9.394447,77.454559 9.473971,85.676895 
	C9.559301,87.016296 9.677078,87.985298 9.672456,89.234177 
	C9.526547,89.920166 9.503037,90.326263 9.321393,91.198837 
	C9.108638,93.494164 9.020601,95.322731 9.004742,97.151924 
	C8.889336,110.462334 8.788460,123.772865 8.337516,137.084930 
	C7.298988,137.061478 6.605935,137.036453 5.912882,137.011429 
z"/>
  <path fill="#BEE3C2" opacity="1.000000" stroke="none" d="
M5.525232,137.034760 
	C6.605935,137.036453 7.298988,137.061478 8.464891,137.364410 
	C9.073124,137.795853 9.208508,137.949356 9.290281,138.478409 
	C9.261494,139.862274 9.286317,140.870575 9.156991,142.148193 
	C8.992707,142.623535 8.982573,142.829590 8.960075,143.282684 
	C8.947711,143.529739 9.009947,144.020538 8.970804,144.265137 
	C8.931662,144.509720 8.972216,145.003433 8.737720,145.172974 
	C8.296838,146.545654 8.090451,147.748764 7.646841,148.829132 
	C6.930558,148.469681 6.451500,148.232986 5.972442,147.996292 
	C2.166713,144.525452 1.823467,140.028275 5.525232,137.034760 
z"/>
  <path fill="#B3D6B5" opacity="1.000000" stroke="none" d="
M5.981656,148.422485 
	C6.451500,148.232986 6.930558,148.469681 7.745212,149.208984 
	C9.041459,153.481827 10.002111,157.252060 10.962763,161.022308 
	C10.527214,161.014786 10.091666,161.007248 9.329464,160.997360 
	C7.998832,156.946228 6.994851,152.897446 5.981656,148.422485 
z"/>
  <path fill="#ADCFB0" opacity="1.000000" stroke="none" d="
M7.000001,58.000458 
	C6.829433,59.163773 6.658865,60.327087 6.242536,61.745441 
	C5.669387,60.581768 5.342001,59.163059 5.013453,57.373276 
	C5.012290,57.002201 5.510442,57.016201 5.884327,57.219406 
	C6.460916,57.672421 6.708179,57.865036 7.000001,58.000458 
z"/>
  <path fill="#BBDFBE" opacity="1.000000" stroke="none" d="
M195.172119,62.965607 
	C196.113098,64.198189 197.865891,65.424988 197.874710,66.664207 
	C198.038300,89.618591 198.022919,112.574593 197.907516,135.529572 
	C197.901749,136.674042 196.647156,137.812225 195.328644,138.408447 
	C194.232162,137.151901 193.781128,136.440262 193.381531,135.407410 
	C193.586685,132.978516 193.740402,130.870834 194.252563,128.366959 
	C194.740448,127.647125 194.869934,127.323486 195.005493,126.547791 
	C194.706177,122.428513 194.400803,118.761292 194.305573,114.878326 
	C194.682571,114.093758 194.849396,113.524940 194.923065,112.819313 
	C194.513977,112.464798 194.248093,112.525047 194.013153,112.860718 
	C193.994095,112.858162 193.958252,112.871590 193.780228,112.869591 
	C193.602203,112.867592 193.252457,112.934258 193.204865,112.554138 
	C193.205063,110.105698 193.252869,108.037376 193.602783,105.770859 
	C193.955566,105.113365 194.006226,104.654060 194.058441,104.230545 
	C194.059982,104.266342 193.994980,104.296509 193.923035,104.199844 
	C193.851105,104.103188 193.897934,103.866783 194.209885,103.365402 
	C194.528992,102.092743 194.536163,101.321457 194.552551,100.576859 
	C194.561768,100.603539 194.501373,100.620560 194.603470,100.279114 
	C194.534012,99.273705 194.362442,98.609741 194.153122,97.699326 
	C194.115356,97.452873 194.046158,96.959045 193.965057,96.755661 
	C193.734360,96.286026 193.517288,96.097450 193.167145,95.605095 
	C193.026535,93.939857 192.951477,92.656075 192.919922,91.452652 
	C192.963440,91.533012 192.868423,91.317818 192.959564,90.983383 
	C193.119690,90.428398 193.188675,90.207848 193.380005,89.889091 
	C193.658936,89.467766 193.577652,89.208366 193.177460,88.678284 
	C193.151093,87.891640 193.205750,87.439415 193.382416,86.888870 
	C193.660461,86.467705 193.579239,86.208435 193.156860,85.684052 
	C192.989807,85.134407 192.926636,84.913445 192.965179,84.690735 
	C193.066864,84.688988 193.098892,84.400337 193.098892,84.400337 
	C193.098892,84.400337 192.863403,84.298874 192.936310,83.852448 
	C192.943710,81.607086 192.878220,79.808151 192.899307,77.767303 
	C192.968948,77.354927 192.952011,77.184471 193.328949,76.921036 
	C194.205917,72.207245 194.689011,67.586426 195.172119,62.965607 
z"/>
  <path fill="#9CBAA0" opacity="1.000000" stroke="none" d="
M195.129379,62.520882 
	C194.689011,67.586426 194.205917,72.207245 193.016602,76.766632 
	C192.147110,75.798538 191.983810,74.891861 191.877289,73.521744 
	C191.891663,67.712593 191.849243,62.366894 191.884308,56.645973 
	C192.031982,55.509087 192.102158,54.747417 192.520401,53.990173 
	C193.563232,54.001591 194.257965,54.008583 194.952713,54.015575 
	C194.997360,56.702435 195.041992,59.389297 195.129379,62.520882 
z"/>
  <path fill="#9CBAA0" opacity="1.000000" stroke="none" d="
M193.330109,135.728622 
	C193.781128,136.440262 194.232162,137.151901 194.933502,138.447769 
	C195.145752,140.086044 195.107697,141.140091 195.038208,142.989899 
	C195.003113,144.856140 194.999435,145.926620 194.995758,146.997086 
	C194.995758,146.997086 194.934128,146.967056 194.592133,147.064148 
	C193.225693,148.444809 192.201279,149.728378 191.091095,150.749741 
	C190.944748,150.313889 190.884140,150.140244 190.888824,149.555450 
	C190.923553,147.757721 190.893005,146.371124 190.937943,144.604736 
	C191.268570,142.495804 191.523712,140.766632 191.871094,138.734772 
	C192.418930,137.530930 192.874512,136.629776 193.330109,135.728622 
z"/>
  <path fill="#A4C5A7" opacity="1.000000" stroke="none" d="
M191.176849,151.011948 
	C192.201279,149.728378 193.225693,148.444809 194.558289,147.058716 
	C194.633453,148.386856 194.400452,149.817551 194.130829,151.608566 
	C193.009583,152.642990 191.924957,153.317078 190.522247,153.678955 
	C190.528366,152.581818 190.852615,151.796875 191.176849,151.011948 
z"/>
  <path fill="#A4C5A7" opacity="1.000000" stroke="none" d="
M194.975891,53.680565 
	C194.257965,54.008583 193.563232,54.001591 192.458450,53.575127 
	C192.081573,51.759384 192.114716,50.363106 192.147873,48.966827 
	C192.947372,49.838303 193.746872,50.709782 194.780869,51.792198 
	C195.009933,52.450603 195.004501,52.898079 194.975891,53.680565 
z"/>
  <path fill="#BBDFBE" opacity="1.000000" stroke="none" d="
M195.324326,146.915283 
	C194.999435,145.926620 195.003113,144.856140 195.049667,143.386017 
	C195.279327,144.268738 195.466110,145.551102 195.324326,146.915283 
z"/>
  <path fill="#BEE2C1" opacity="1.000000" stroke="none" d="
M145.019852,195.112732 
	C144.179855,199.562714 140.352646,198.767212 137.565063,198.886337 
	C130.262466,199.198441 122.937859,198.997421 115.622025,198.997818 
	C98.995102,198.998734 82.365685,199.144272 65.743622,198.859879 
	C62.822315,198.809906 59.931873,196.955643 57.287388,195.467102 
	C58.044273,194.430939 58.540951,193.862320 59.395000,193.274277 
	C61.172653,193.507538 62.592937,193.760239 64.241333,194.041718 
	C64.469437,194.070496 64.929070,194.091873 65.293800,194.244812 
	C68.761757,194.286896 71.864983,194.176041 75.310669,194.065475 
	C76.447182,193.725311 77.241241,193.384857 78.009674,193.043472 
	C77.984055,193.042557 78.024048,193.075150 78.251038,193.287003 
	C79.367470,193.864105 80.256920,194.229355 81.510727,194.656509 
	C82.859749,194.754044 83.844429,194.789658 85.288162,194.895294 
	C87.914955,194.920700 90.082687,194.876068 92.685646,194.830872 
	C94.934929,194.829041 96.762619,194.970154 98.560303,194.797974 
	C102.793892,194.392410 107.019241,193.386581 111.236885,193.443359 
	C118.445305,193.540436 125.645256,194.265594 133.261993,194.821396 
	C134.796616,194.903259 135.918030,194.890656 137.481018,194.901855 
	C140.288361,194.988022 142.654099,195.050385 145.019852,195.112732 
z"/>
  <path fill="#93B194" opacity="1.000000" stroke="none" d="
M145.242859,195.042480 
	C142.654099,195.050385 140.288361,194.988022 137.472992,194.568939 
	C137.006332,193.763779 136.989288,193.315353 136.975281,192.519592 
	C137.017258,191.478668 137.056198,190.785080 137.404816,190.091064 
	C138.128067,190.106827 138.541626,190.123032 138.971558,190.453339 
	C139.316895,191.564102 139.645874,192.360779 140.543793,194.535202 
	C140.806595,191.796249 140.924271,190.569809 141.288788,189.240982 
	C141.689423,189.048706 141.843231,188.958832 142.241333,188.950714 
	C142.645554,189.095062 142.805496,189.157654 143.039062,189.518494 
	C144.076569,190.547440 145.040421,191.278137 145.906708,192.245087 
	C145.846405,193.275726 145.883667,194.070114 145.920914,194.864517 
	C145.920914,194.864517 145.465866,194.972198 145.242859,195.042480 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M59.037628,193.293701 
	C58.540951,193.862320 58.044273,194.430939 57.253181,195.091339 
	C55.584217,195.134491 54.209667,195.085861 52.422188,195.042175 
	C51.035469,194.275711 50.061680,193.504272 49.353951,192.397949 
	C51.416058,192.066360 53.212097,192.069702 55.380356,192.069016 
	C56.847595,192.474564 57.942616,192.884140 59.037628,193.293701 
z"/>
  <path fill="#9DBC9E" opacity="1.000000" stroke="none" d="
M146.263885,194.914246 
	C145.883667,194.070114 145.846405,193.275726 146.254150,192.083099 
	C148.474136,191.478912 150.249130,191.272934 152.014038,191.389709 
	C152.003647,192.143173 152.003342,192.573898 152.003052,193.004623 
	C151.576233,193.023163 151.149414,193.041687 150.084351,193.098160 
	C148.960556,193.744888 148.474976,194.353683 147.989395,194.962463 
	C147.528549,194.962967 147.067719,194.963486 146.263885,194.914246 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M148.324127,194.986053 
	C148.474976,194.353683 148.960556,193.744888 149.763962,193.102844 
	C150.058838,193.508713 150.035873,193.947815 150.006607,194.718170 
	C149.553177,195.036133 149.106018,195.022888 148.324127,194.986053 
z"/>
  <path fill="#211B57" opacity="1.000000" stroke="none" d="
M31.637877,15.002460 
	C32.296860,15.368248 32.644058,15.872001 32.991253,16.375753 
	C37.463276,13.193062 39.180447,16.579090 41.549767,19.560663 
	C43.003345,21.389851 45.553402,22.347715 47.810856,23.827833 
	C48.740047,22.460848 49.275200,20.918550 50.355709,20.220974 
	C54.075672,17.819365 53.973972,16.156654 50.237843,13.674179 
	C49.054054,12.887611 49.354664,9.867025 48.991409,7.493881 
	C51.449516,6.537247 53.892189,5.955520 57.100361,5.278875 
	C60.209454,5.222771 62.553040,5.261584 65.024796,5.654452 
	C67.418839,6.331567 69.684723,6.654627 72.197632,7.224781 
	C75.837479,10.989034 79.230286,14.506191 82.450119,17.844030 
	C80.889175,19.034714 79.394478,20.174866 77.899780,21.315018 
	C78.140457,21.865191 78.381142,22.415363 78.621819,22.965536 
	C80.850967,22.544300 83.080109,22.123064 85.715660,21.625032 
	C86.302551,22.367231 87.136620,23.422022 88.613510,25.289738 
	C88.793449,22.845715 88.897964,21.426060 89.335228,20.001722 
	C90.111694,19.993792 90.555405,19.990541 91.219421,20.249119 
	C94.598305,22.449200 97.756882,24.387453 100.897057,26.314411 
	C100.286575,27.125004 99.643806,27.978477 98.611916,28.901939 
	C95.150795,30.376217 92.078789,31.780502 88.714294,33.198242 
	C87.901573,33.778946 87.381340,34.346195 86.901649,34.921082 
	C86.942192,34.928715 86.915634,34.850594 86.549950,34.878853 
	C79.409462,38.904469 72.634659,42.901821 65.900818,46.903961 
	C65.941772,46.908749 65.936661,46.826424 65.599396,46.865719 
	C64.502907,47.255470 63.743683,47.605927 62.660561,48.062386 
	C60.937160,48.794235 59.537663,49.420086 57.849537,49.940536 
	C56.317432,49.747059 55.073956,49.658974 54.639622,49.628208 
	C53.594685,47.402119 52.797424,45.703663 51.981941,43.633263 
	C45.905773,38.765923 49.052219,31.508001 47.494297,25.662004 
	C46.995640,25.732193 46.496979,25.802383 45.998322,25.872572 
	C45.998322,28.248533 45.998322,30.624496 45.600227,32.972267 
	C44.043934,30.099049 42.885738,27.254017 41.969383,25.003046 
	C38.817978,25.003046 35.913074,25.003046 32.776878,24.786673 
	C29.940962,25.368858 27.336332,26.167418 24.410814,27.064356 
	C24.665203,24.561466 24.837151,22.869684 25.009100,21.177902 
	C27.114761,19.165411 29.220425,17.152918 31.637877,15.002460 
z"/>
  <path fill="#241E5B" opacity="1.000000" stroke="none" d="
M145.973175,6.632620 
	C145.598679,13.398404 140.366501,15.008093 135.448181,16.446114 
	C137.105881,18.874327 138.429443,20.813108 139.753021,22.751888 
	C138.731003,22.865986 137.709000,22.980083 136.037262,22.910706 
	C133.592316,23.484924 131.797073,24.242615 129.752426,25.001083 
	C129.503021,25.001862 129.004272,25.005310 129.002213,24.633125 
	C128.667587,22.838816 128.335022,21.416691 128.381393,19.981834 
	C129.804657,18.965868 131.025696,18.076065 131.786407,16.890810 
	C132.016876,16.531715 131.028168,14.725853 130.503067,14.680504 
	C129.304962,14.577033 127.276627,14.827550 126.983604,15.523160 
	C126.451935,16.785309 126.939079,18.476622 126.828690,20.286667 
	C123.799644,22.163809 120.942894,23.743088 118.086136,25.322365 
	C117.692741,24.807600 117.299347,24.292833 116.905952,23.778067 
	C117.785973,22.609779 118.488876,21.232222 119.577744,20.310709 
	C123.548813,16.949942 123.287918,15.733943 118.759186,12.980873 
	C116.215225,11.434366 114.205338,9.009328 112.066269,6.752487 
	C112.469444,6.111460 112.761169,5.698040 113.485809,5.236337 
	C115.945427,5.254198 117.972130,5.320343 120.017868,5.732519 
	C122.588333,8.430278 125.139771,10.782007 127.691208,13.133737 
	C128.128204,12.824986 128.565201,12.516236 129.002197,12.207486 
	C129.002197,9.941113 129.002197,7.674740 129.395706,5.317183 
	C130.858704,5.288094 131.928177,5.350190 132.985077,5.746861 
	C132.865585,7.527400 132.758667,8.973366 132.651749,10.419332 
	C135.580887,8.153329 141.190948,11.076026 141.385620,5.327731 
	C142.815659,5.244844 143.863052,5.252926 144.910461,5.261006 
	C145.239532,5.637019 145.568619,6.013031 145.973175,6.632620 
z"/>
  <path fill="#BDDCCA" opacity="1.000000" stroke="none" d="
M144.644821,4.940696 
	C143.863052,5.252926 142.815659,5.244844 140.948425,5.235979 
	C137.751617,5.294225 135.374634,5.353256 132.997665,5.412287 
	C131.928177,5.350190 130.858704,5.288094 128.953064,5.225287 
	C125.410896,5.278547 122.704872,5.332518 119.998840,5.386489 
	C117.972130,5.320343 115.945427,5.254198 113.043091,5.130723 
	C109.744774,5.143092 107.322083,5.212790 104.469711,5.234411 
	C102.027084,5.252689 100.014130,5.319044 97.557938,5.297433 
	C94.409378,5.272599 91.704048,5.335730 88.540894,5.305091 
	C83.072769,5.234679 78.062469,5.258034 72.609421,5.175077 
	C69.743332,5.145976 67.319984,5.223186 64.896629,5.300397 
	C62.553040,5.261584 60.209454,5.222771 57.436161,5.084402 
	C58.416866,4.657266 59.826672,4.046973 61.237770,4.043970 
	C87.829468,3.987383 114.421318,3.995142 141.013092,4.029072 
	C142.135376,4.030503 143.257156,4.414572 144.644821,4.940696 
z"/>
  <path fill="#1F1A53" opacity="1.000000" stroke="none" d="
M11.180537,43.042622 
	C12.444227,39.933144 13.707917,36.823669 14.895382,33.348049 
	C15.188851,32.500191 15.558547,32.018478 16.224871,31.108791 
	C16.740303,30.456152 16.882830,30.190548 16.949081,29.884007 
	C17.440332,28.990383 17.931583,28.096758 19.046396,27.143320 
	C21.340584,27.718079 23.011209,28.352654 25.983662,29.481716 
	C25.983662,35.683353 25.983662,42.331257 25.738110,48.985584 
	C25.492556,48.992008 25.000988,49.000874 24.644167,48.948467 
	C22.462860,48.413391 20.638376,47.930725 18.813892,47.448055 
	C23.444273,50.190945 23.919056,52.636921 19.503981,55.667736 
	C19.181175,55.889328 19.157471,56.546638 18.665356,57.001213 
	C17.896866,57.001144 17.457727,57.001232 16.654602,57.008945 
	C14.527664,57.678341 12.764714,58.340115 11.000616,58.580551 
	C10.763472,55.788857 10.527476,53.418499 10.195187,51.008167 
	C10.098890,50.968193 9.892312,50.996628 9.937845,50.769859 
	C9.983377,50.543087 9.975044,50.080570 9.980459,49.791172 
	C9.976397,49.309349 9.966919,49.116928 9.957441,48.924503 
	C9.957441,48.924503 9.962470,48.996712 10.201077,48.785217 
	C10.686633,46.730026 10.933585,44.886322 11.180537,43.042622 
z"/>
  <path fill="#26215B" opacity="1.000000" stroke="none" d="
M25.983662,48.979160 
	C25.983662,42.331257 25.983662,35.683353 25.983662,29.481716 
	C23.011209,28.352654 21.340584,27.718079 19.335999,27.029709 
	C20.780811,25.068922 22.559584,23.161930 24.673729,21.216419 
	C24.837151,22.869684 24.665203,24.561466 24.410814,27.064356 
	C27.336332,26.167418 29.940962,25.368858 32.717522,25.135912 
	C27.823059,29.495844 27.733265,34.916485 27.978168,40.493679 
	C28.102306,43.320698 28.005247,46.157433 27.670755,48.991348 
	C26.883434,48.988335 26.433548,48.983746 25.983662,48.979160 
z"/>
  <path fill="#211B57" opacity="1.000000" stroke="none" d="
M36.649063,11.902449 
	C36.477619,12.200154 35.984653,12.553995 35.176907,12.930193 
	C35.350601,12.621226 35.839069,12.289904 36.649063,11.902449 
z"/>
  <path fill="#26215B" opacity="1.000000" stroke="none" d="
M16.702618,29.970526 
	C16.882830,30.190548 16.740303,30.456152 16.344910,30.825655 
	C16.264261,30.666008 16.360207,30.361526 16.702618,29.970526 
z"/>
  <path fill="#211B57" opacity="1.000000" stroke="none" d="
M37.712738,11.137705 
	C37.803120,11.431376 37.576107,11.635430 37.077045,11.861675 
	C37.057949,11.667757 37.254734,11.389165 37.712738,11.137705 
z"/>
  <path fill="#B1D1B6" opacity="1.000000" stroke="none" d="
M7.200511,57.771202 
	C6.708179,57.865036 6.460916,57.672421 6.133489,57.221992 
	C6.670662,55.365204 7.332560,53.709042 8.566301,52.058990 
	C9.138144,52.065102 9.531384,51.952885 9.447865,52.363342 
	C9.275737,54.163696 9.187127,55.553593 9.098517,56.943485 
	C8.532685,57.142971 7.966853,57.342457 7.200511,57.771202 
z"/>
  <path fill="#A5C7A7" opacity="1.000000" stroke="none" d="
M9.975044,50.080570 
	C9.975044,50.080570 9.983377,50.543087 9.726284,50.802391 
	C9.469190,51.061695 9.041089,51.070087 9.041089,51.070087 
	C9.041089,51.070087 8.912736,50.628971 8.930651,50.335190 
	C8.948566,50.041405 9.105822,49.895451 9.323227,49.941261 
	C9.540633,49.987072 9.975044,50.080570 9.975044,50.080570 
z"/>
  <path fill="#65667D" opacity="1.000000" stroke="none" d="
M8.978640,51.315887 
	C9.041089,51.070087 9.469190,51.061695 9.680751,51.029160 
	C9.892312,50.996628 10.098890,50.968193 10.094342,51.182983 
	C9.988744,51.668400 9.802608,51.853436 9.531384,51.952885 
	C9.531384,51.952885 9.138144,52.065102 8.933388,52.049026 
	C8.791149,51.875862 8.853669,51.718773 8.978640,51.315887 
z"/>
  <path fill="#A5C7A7" opacity="1.000000" stroke="none" d="
M8.071428,49.220043 
	C8.158751,49.008224 8.350175,49.015011 8.801340,49.247398 
	C9.061083,49.473007 9.105822,49.895451 9.105822,49.895451 
	C9.105822,49.895451 8.948566,50.041405 8.867663,50.114288 
	C8.552376,49.962685 8.348632,49.713181 8.071428,49.220043 
z"/>
  <path fill="#1D1C43" opacity="1.000000" stroke="none" d="
M10.989250,43.383167 
	C10.933585,44.886322 10.686633,46.730026 10.165087,48.781387 
	C10.192983,47.233932 10.495473,45.478825 10.989250,43.383167 
z"/>
  <path fill="#1D1C43" opacity="1.000000" stroke="none" d="
M9.323227,49.941261 
	C9.105822,49.895451 9.061083,49.473007 9.088259,49.262512 
	C9.115434,49.052017 9.534899,48.976013 9.746170,48.950256 
	C9.966919,49.116928 9.976397,49.309349 9.980459,49.791172 
	C9.975044,50.080570 9.540633,49.987072 9.323227,49.941261 
z"/>
  <path fill="#201A55" opacity="1.000000" stroke="none" d="
M151.002441,32.000412 
	C157.065277,29.668825 163.128113,27.337238 169.595367,25.464619 
	C169.921280,32.378990 171.392334,39.321609 164.376266,43.595238 
	C164.075729,43.778309 164.117218,44.522877 163.981674,45.370529 
	C162.667389,47.617691 161.370804,49.500202 160.600693,50.618328 
	C158.011398,49.981483 156.013031,49.489979 153.651108,48.983528 
	C152.523621,47.980644 151.759674,46.992699 150.997223,45.539810 
	C150.999954,40.716713 151.001190,36.358566 151.002441,32.000412 
z"/>
  <path fill="#1F1955" opacity="1.000000" stroke="none" d="
M130.001831,25.000305 
	C131.797073,24.242615 133.592316,23.484924 135.692947,22.864994 
	C137.404999,25.169979 138.538742,27.616510 140.341705,29.378117 
	C141.155396,30.173147 143.301865,29.604092 145.254974,29.327221 
	C146.110443,29.000853 146.554611,29.001188 146.998779,29.001526 
	C147.184601,29.542070 147.370422,30.082617 147.777771,31.266922 
	C148.334778,36.609180 148.670273,41.307678 148.985443,46.372936 
	C148.080536,47.409187 146.806412,48.849842 146.371063,48.629940 
	C141.547363,46.193432 136.818771,43.558605 132.164688,40.807812 
	C131.509003,40.420261 131.149750,39.149384 131.061905,38.247566 
	C130.632523,33.839218 130.341660,29.417377 130.001831,25.000305 
z"/>
  <path fill="#201A55" opacity="1.000000" stroke="none" d="
M184.662781,29.925817 
	C185.136459,30.627428 185.291061,31.198435 185.722702,31.884739 
	C187.916824,36.758148 189.833908,41.516266 191.503326,46.695980 
	C190.501526,47.737362 189.747391,48.357147 188.950562,48.651169 
	C188.299744,47.414017 187.691620,46.502625 187.083496,45.591232 
	C186.723389,46.058960 186.363266,46.526684 185.635315,46.983841 
	C181.859146,45.056190 178.307556,43.345650 175.108490,41.126854 
	C173.703079,40.152100 172.432510,38.250710 172.120712,36.579731 
	C171.412003,32.781521 171.334671,28.865490 171.000702,24.997353 
	C172.714996,23.643894 174.429276,22.290434 176.503235,20.777697 
	C179.356506,23.677349 181.850113,26.736282 184.662781,29.925817 
M184.915771,41.308434 
	C184.163483,41.429474 183.411179,41.550518 182.658890,41.671558 
	C182.791153,42.074394 182.923431,42.477230 183.055695,42.880066 
	C183.812286,42.493275 184.568863,42.106480 184.915771,41.308434 
z"/>
  <path fill="#26205D" opacity="1.000000" stroke="none" d="
M170.750366,24.998405 
	C171.334671,28.865490 171.412003,32.781521 172.120712,36.579731 
	C172.432510,38.250710 173.703079,40.152100 175.108490,41.126854 
	C178.307556,43.345650 181.859146,45.056190 185.549011,47.324318 
	C184.155090,47.615242 182.275497,48.028980 180.840454,47.410774 
	C175.403717,45.068676 170.354187,40.750458 163.999390,45.005875 
	C164.117218,44.522877 164.075729,43.778309 164.376266,43.595238 
	C171.392334,39.321609 169.921280,32.378990 169.999603,25.461985 
	C170.166260,25.000076 170.333145,24.999771 170.750366,24.998405 
z"/>
  <path fill="#241E5B" opacity="1.000000" stroke="none" d="
M149.005768,46.006176 
	C148.670273,41.307678 148.334778,36.609180 147.999329,31.455341 
	C148.806152,31.246002 149.612915,31.492004 150.711060,31.869211 
	C151.001190,36.358566 150.999954,40.716713 150.665588,45.538609 
	C149.890228,46.003628 149.447998,46.004902 149.005768,46.006176 
z"/>
  <path fill="#241E5B" opacity="1.000000" stroke="none" d="
M147.413208,29.001013 
	C146.554611,29.001188 146.110443,29.000853 145.333130,29.000526 
	C144.488312,27.659708 143.976624,26.318880 143.682281,25.547577 
	C147.500366,25.547577 151.416122,25.547577 155.331879,25.547577 
	C155.415680,26.061811 155.499466,26.576046 155.583267,27.090281 
	C152.998047,27.727020 150.412842,28.363760 147.413208,29.001013 
z"/>
  <path fill="#241E5B" opacity="1.000000" stroke="none" d="
M165.694305,17.088615 
	C166.267441,17.821434 166.504105,18.617655 166.872803,19.700436 
	C164.137756,21.792585 161.270691,23.598179 158.403625,25.403770 
	C157.978668,24.822508 157.553696,24.241243 157.128738,23.659981 
	C159.871765,21.490660 162.614792,19.321341 165.694305,17.088615 
z"/>
  <path fill="#201A55" opacity="1.000000" stroke="none" d="
M174.092926,19.114635 
	C173.975967,18.978271 173.989166,18.561249 173.992554,18.352669 
	C174.292847,18.231716 174.589737,18.319345 174.965942,18.647961 
	C174.766800,19.009630 174.488342,19.130316 174.092926,19.114635 
z"/>
  <path fill="#201A55" opacity="1.000000" stroke="none" d="
M172.203613,21.874535 
	C172.130249,21.699572 172.325165,21.446169 172.790176,21.116409 
	C172.861237,21.290373 172.665115,21.542387 172.203613,21.874535 
z"/>
  <path fill="#292660" opacity="1.000000" stroke="none" d="
M188.993256,48.976936 
	C189.747391,48.357147 190.501526,47.737362 191.545959,47.055214 
	C191.895523,47.433056 191.954803,47.873260 192.080978,48.640144 
	C192.114716,50.363106 192.081573,51.759384 192.110367,53.570705 
	C192.102158,54.747417 192.031982,55.509087 191.580566,56.564964 
	C190.134506,56.236092 189.069702,55.613010 187.968964,54.702568 
	C187.627670,53.944279 187.322296,53.473351 187.017105,52.632980 
	C187.675934,51.168007 188.334595,50.072472 188.993256,48.976936 
z"/>
  <path fill="#151243" opacity="1.000000" stroke="none" d="
M191.091095,150.749741 
	C190.852615,151.796875 190.528366,152.581818 190.191833,153.693115 
	C189.460724,156.067337 188.741898,158.115158 187.695251,160.659927 
	C186.302505,162.133774 185.237595,163.110703 183.834534,163.935959 
	C182.266083,163.708313 180.905579,163.933258 179.841568,163.472916 
	C178.744980,162.998489 177.937103,161.856674 176.819016,160.775146 
	C176.084167,160.359528 175.533188,160.175644 174.990601,159.995331 
	C174.998978,159.998901 175.009781,160.013474 174.964844,159.669830 
	C174.950790,157.548309 174.981689,155.770416 175.005554,153.996216 
	C174.998520,153.999924 174.986801,154.010803 175.283905,153.982025 
	C176.058487,153.633438 176.535980,153.313614 177.006729,152.996887 
	C177.000000,153.000000 177.012817,152.995270 177.387390,152.990311 
	C180.734833,151.705414 183.642441,150.218460 186.713638,149.250534 
	C187.891403,148.879349 189.442551,149.692902 190.823547,149.966583 
	C190.884140,150.140244 190.944748,150.313889 191.091095,150.749741 
z"/>
  <path fill="#96AF9A" opacity="1.000000" stroke="none" d="
M184.172684,164.087616 
	C185.237595,163.110703 186.302505,162.133774 187.651459,161.026245 
	C186.646317,164.185883 185.601654,167.602997 183.983307,170.722473 
	C182.876404,172.856064 180.969818,174.574799 178.956482,176.731918 
	C178.319611,176.976898 178.147003,176.968964 177.971634,176.502899 
	C177.769699,175.148834 177.570511,174.252853 177.592422,173.112732 
	C179.933258,169.941589 182.052979,167.014603 184.172684,164.087616 
z"/>
  <path fill="#A3C5A7" opacity="1.000000" stroke="none" d="
M177.974365,176.960999 
	C178.147003,176.968964 178.319611,176.976898 178.751190,176.998413 
	C179.013687,177.462341 179.017227,177.912704 179.030884,178.701569 
	C178.070496,180.132492 177.100006,181.224915 175.675919,182.647583 
	C174.475449,182.976685 173.728577,182.975555 172.976318,182.718689 
	C172.962784,182.292389 172.954636,182.121857 173.184067,181.733459 
	C174.939209,179.997406 176.456787,178.479202 177.974365,176.960999 
z"/>
  <path fill="#B5D9B8" opacity="1.000000" stroke="none" d="
M172.981689,182.974426 
	C173.728577,182.975555 174.475449,182.976685 175.594910,182.967972 
	C175.010513,184.410675 174.053528,185.863205 173.039978,187.648987 
	C171.713791,188.423843 170.444214,188.865463 169.081085,189.649323 
	C165.939545,190.998825 162.891556,192.006088 159.432678,193.021088 
	C159.021790,193.028809 159.004761,193.006287 159.001038,192.638123 
	C159.016968,191.552628 159.036621,190.835312 159.291199,190.087067 
	C159.526093,190.056137 159.996902,189.997406 160.375275,190.000305 
	C161.867523,189.070267 162.981415,188.137329 164.322113,187.156982 
	C164.548935,187.109558 164.999100,186.999359 165.371643,187.005249 
	C168.156677,185.665573 170.569183,184.320007 172.981689,182.974426 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M159.056274,190.117996 
	C159.036621,190.835312 159.016968,191.552628 158.993103,192.627991 
	C156.950882,192.992035 154.912872,192.998016 152.438950,193.004303 
	C152.003342,192.573898 152.003647,192.143173 152.338409,191.359528 
	C153.106735,190.980042 153.540588,190.953476 154.324921,190.803284 
	C156.135681,190.492416 157.595978,190.305206 159.056274,190.117996 
z"/>
  <path fill="#B4D9B7" opacity="1.000000" stroke="none" d="
M33.247917,190.258957 
	C31.041086,187.906006 29.068590,185.819595 27.033138,183.393829 
	C28.509878,183.496170 30.049574,183.937881 32.025581,184.218628 
	C32.461891,184.057663 32.925663,184.167068 32.961529,184.519302 
	C34.654694,185.923264 36.311989,186.974991 37.986000,188.016434 
	C38.002720,188.006149 37.975971,188.038757 38.057251,188.367798 
	C39.100246,189.122772 40.061966,189.548691 41.311043,190.016296 
	C42.070694,190.367310 42.542988,190.676651 43.011639,191.314789 
	C43.016167,192.081116 43.024334,192.518646 43.032501,192.956192 
	C43.032501,192.956192 43.005066,192.993393 42.991192,193.012573 
	C39.812298,192.196320 36.647274,191.360916 33.247917,190.258957 
z"/>
  <path fill="#86A088" opacity="1.000000" stroke="none" d="
M32.925663,184.167068 
	C32.925663,184.167068 32.461891,184.057663 32.230530,183.999817 
	C31.731754,183.470886 31.464336,182.999786 31.281704,182.050400 
	C31.929914,181.374542 32.493336,181.176971 33.420288,181.009018 
	C38.832314,183.095627 43.880814,185.152603 49.129890,187.483551 
	C50.267921,188.481125 51.205376,189.204712 51.704617,189.949463 
	C47.867100,189.626831 44.467796,189.283020 40.821358,188.714630 
	C39.708134,188.339630 38.842052,188.189194 37.975971,188.038757 
	C37.975971,188.038757 38.002720,188.006149 37.845840,187.713913 
	C36.101200,186.336807 34.513432,185.251938 32.925663,184.167068 
z"/>
  <path fill="#8CA48F" opacity="1.000000" stroke="none" d="
M33.056759,180.979401 
	C32.493336,181.176971 31.929914,181.374542 31.167063,181.802704 
	C28.682861,179.919785 26.398088,177.806274 24.229177,175.170776 
	C24.468262,174.523560 24.591486,174.398285 24.960590,174.448700 
	C25.787636,174.778473 26.368803,174.932571 27.095604,175.385345 
	C29.179745,177.449142 31.118252,179.214279 33.056759,180.979401 
z"/>
  <path fill="#8CA48F" opacity="1.000000" stroke="none" d="
M20.347546,174.034286 
	C19.693859,173.198196 19.381153,172.404694 19.382185,171.244629 
	C20.142874,170.540634 20.589823,170.203201 21.375847,169.954468 
	C22.714853,171.453110 23.714783,172.863068 24.714710,174.273010 
	C24.591486,174.398285 24.468262,174.523560 24.159851,174.836945 
	C22.879286,174.709000 21.783907,174.392944 20.347546,174.034286 
z"/>
  <path fill="#9CBAA0" opacity="1.000000" stroke="none" d="
M10.983068,161.382477 
	C10.002111,157.252060 9.041459,153.481827 7.982435,149.331726 
	C8.090451,147.748764 8.296838,146.545654 8.976515,145.183975 
	C9.449806,145.025421 9.924517,145.077469 9.940579,145.052063 
	C9.956642,145.026642 9.896842,145.025665 9.946573,145.348328 
	C10.068736,146.099380 10.141169,146.527786 10.144512,147.326080 
	C10.731085,149.460602 11.386746,151.225250 12.050253,153.365921 
	C14.774900,158.483093 17.491703,163.224228 20.234028,168.219421 
	C20.284273,168.641876 20.308998,168.810287 20.053871,169.082397 
	C19.495857,169.466812 19.217697,169.747543 18.939533,170.028259 
	C17.503614,169.450714 16.067698,168.873184 14.339538,168.123199 
	C13.032653,165.881378 12.018013,163.811996 10.983068,161.382477 
z"/>
  <path fill="#778B7C" opacity="1.000000" stroke="none" d="
M18.974026,170.257935 
	C19.217697,169.747543 19.495857,169.466812 20.244745,169.158295 
	C20.936575,169.325790 21.043674,169.570877 21.036774,169.865784 
	C20.589823,170.203201 20.142874,170.540634 19.407196,170.908493 
	C19.118467,170.938934 19.008516,170.487625 18.974026,170.257935 
z"/>
  <path fill="#96B599" opacity="1.000000" stroke="none" d="
M41.068493,188.939209 
	C44.467796,189.283020 47.867100,189.626831 51.881489,189.959549 
	C52.496574,189.948471 52.849133,189.912674 53.128761,190.053711 
	C53.941635,190.820847 54.474888,191.446945 55.008137,192.073029 
	C53.212097,192.069702 51.416058,192.066360 49.264774,192.091217 
	C48.486118,192.104507 48.062710,192.089630 47.075645,191.808868 
	C45.346416,191.357315 44.180847,191.171661 43.015274,190.986008 
	C42.542988,190.676651 42.070694,190.367310 41.317047,189.757370 
	C41.046631,189.284241 41.057564,189.111725 41.068493,188.939209 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M43.011635,191.314789 
	C44.180847,191.171661 45.346416,191.357315 46.757195,191.803772 
	C45.915714,192.367584 44.829033,192.670624 43.387428,192.964920 
	C43.024334,192.518646 43.016167,192.081116 43.011635,191.314789 
z"/>
  <path fill="#1C1750" opacity="1.000000" stroke="none" d="
M9.794854,88.954292 
	C9.677078,87.985298 9.559301,87.016296 9.658921,85.625763 
	C9.876317,85.204231 10.217271,85.026833 10.428234,84.671494 
	C10.758068,76.880241 10.876940,69.444336 11.329863,62.005318 
	C12.109218,61.999863 12.554523,61.997513 13.246515,62.241623 
	C16.177719,64.021469 18.529488,64.184540 21.064030,61.788605 
	C22.149963,60.762051 24.310736,60.872513 25.983141,60.466362 
	C26.321980,62.003693 26.859659,63.528786 26.955191,65.081093 
	C27.117083,67.711784 26.999849,70.359657 26.666620,73.073944 
	C23.227568,75.243332 20.121843,77.339073 17.016121,79.434807 
	C17.238289,79.844536 17.460457,80.254272 17.682625,80.664001 
	C18.418194,80.572311 19.357340,80.740334 19.857489,80.348297 
	C24.303837,76.863029 28.685957,77.819672 33.256962,80.119652 
	C34.636604,80.813843 36.409161,80.727158 38.057899,81.354233 
	C40.084850,82.805382 42.055630,83.900475 44.020462,85.396057 
	C44.017357,86.864052 44.020203,87.931572 43.646767,89.010803 
	C39.845562,91.012589 36.420647,93.002670 32.651131,95.006577 
	C31.538090,95.680702 30.769650,96.340988 29.584457,97.001007 
	C27.778574,97.000496 26.389441,97.000244 24.668129,97.000885 
	C23.893156,97.002495 23.450359,97.003235 22.935991,96.672394 
	C19.122452,92.791252 15.781896,88.531448 9.794854,88.954292 
z"/>
  <path fill="#211C56" opacity="1.000000" stroke="none" d="
M9.672456,89.234177 
	C15.781896,88.531448 19.122452,92.791252 22.545074,96.670502 
	C18.488464,95.661507 14.751199,94.322815 10.983866,92.708893 
	C10.695425,91.959549 10.437052,91.485451 10.010086,90.926071 
	C9.841493,90.840805 9.479528,90.732368 9.479528,90.732368 
	C9.503037,90.326263 9.526547,89.920166 9.672456,89.234177 
z"/>
  <path fill="#65667D" opacity="1.000000" stroke="none" d="
M9.321393,91.198837 
	C9.479528,90.732368 9.841493,90.840805 9.948599,91.390076 
	C10.083703,104.272720 10.111703,116.606094 10.100743,129.329926 
	C10.093113,130.504364 10.124442,131.288330 10.105122,132.461914 
	C9.817613,134.601990 9.580752,136.352417 9.343891,138.102859 
	C9.208508,137.949356 9.073124,137.795853 8.810366,137.362854 
	C8.788460,123.772865 8.889336,110.462334 9.004742,97.151924 
	C9.020601,95.322731 9.108638,93.494164 9.321393,91.198837 
z"/>
  <path fill="#1D1C43" opacity="1.000000" stroke="none" d="
M10.995811,62.008427 
	C10.876940,69.444336 10.758068,76.880241 10.377436,84.203323 
	C9.897904,76.335938 9.680135,68.581375 9.462366,60.826805 
	C9.455998,60.170963 9.449631,59.515118 9.584967,58.385258 
	C9.635618,57.559235 9.544567,57.207233 9.453516,56.855228 
	C9.453516,56.855228 9.235728,56.737656 9.167123,56.840569 
	C9.187127,55.553593 9.275737,54.163696 9.447865,52.363342 
	C9.802608,51.853436 9.988744,51.668400 10.190638,51.222961 
	C10.527476,53.418499 10.763472,55.788857 10.998410,58.956223 
	C10.996840,60.504963 10.996325,61.256695 10.995811,62.008427 
z"/>
  <path fill="#65667D" opacity="1.000000" stroke="none" d="
M9.316437,61.288742 
	C9.680135,68.581375 9.897904,76.335938 10.166471,84.558670 
	C10.217271,85.026833 9.876317,85.204231 9.691367,85.255363 
	C9.394447,77.454559 9.282478,69.602615 9.316437,61.288742 
z"/>
  <path fill="#65667D" opacity="1.000000" stroke="none" d="
M9.370529,57.192768 
	C9.544567,57.207233 9.635618,57.559235 9.593863,58.057365 
	C9.403218,57.979095 9.345380,57.754700 9.370529,57.192768 
z"/>
  <path fill="#18173D" opacity="1.000000" stroke="none" d="
M9.290281,138.478409 
	C9.580752,136.352417 9.817613,134.601990 10.331530,132.781250 
	C10.431934,136.125656 10.255282,139.540344 10.056166,143.022736 
	C10.033701,143.090439 9.891672,143.077164 9.898764,142.833954 
	C9.851777,142.232971 9.653539,141.995697 9.311139,141.878891 
	C9.286317,140.870575 9.261494,139.862274 9.290281,138.478409 
z"/>
  <path fill="#9CBAA0" opacity="1.000000" stroke="none" d="
M9.009947,144.020538 
	C9.009947,144.020538 8.947711,143.529739 9.191250,143.267609 
	C9.434789,143.005478 9.891672,143.077164 9.891672,143.077164 
	C9.891672,143.077164 10.033701,143.090439 10.024649,143.260925 
	C10.015595,143.431412 9.974205,143.910202 9.735219,143.955948 
	C9.496233,144.001694 9.009947,144.020538 9.009947,144.020538 
z"/>
  <path fill="#18173D" opacity="1.000000" stroke="none" d="
M8.970804,144.265137 
	C9.009947,144.020538 9.496233,144.001694 9.727201,144.247986 
	C9.946952,144.688675 9.935735,144.883072 9.924517,145.077469 
	C9.924517,145.077469 9.449806,145.025421 9.211011,145.014435 
	C8.972216,145.003433 8.931662,144.509720 8.970804,144.265137 
z"/>
  <path fill="#65667D" opacity="1.000000" stroke="none" d="
M9.898764,142.833954 
	C9.891672,143.077164 9.434789,143.005478 9.203613,143.020554 
	C8.982573,142.829590 8.992707,142.623535 9.156991,142.148193 
	C9.653539,141.995697 9.851777,142.232971 9.898764,142.833954 
z"/>
  <path fill="#1C1750" opacity="1.000000" stroke="none" d="
M188.004898,54.989929 
	C189.069702,55.613010 190.134506,56.236092 191.503052,56.940178 
	C191.849243,62.366894 191.891663,67.712593 191.513824,73.538040 
	C187.364136,74.906357 184.256516,76.612778 182.705612,80.311287 
	C186.074646,79.543938 189.443695,78.776581 192.812729,78.009224 
	C192.878220,79.808151 192.943710,81.607086 192.904663,83.950790 
	C192.800125,84.495567 192.863480,84.692490 192.863480,84.692490 
	C192.926636,84.913445 192.989807,85.134407 193.075775,85.927643 
	C193.152512,86.662346 193.206467,86.824768 193.260406,86.987183 
	C193.205750,87.439415 193.151093,87.891640 193.095520,88.921875 
	C193.148926,89.662346 193.203293,89.824821 193.257675,89.987297 
	C193.188675,90.207848 193.119690,90.428398 192.958710,90.999573 
	C192.866714,91.350197 192.876419,91.372299 192.876419,91.372299 
	C192.951477,92.656075 193.026535,93.939857 193.073196,95.848793 
	C193.071442,96.645973 193.098099,96.818001 193.057251,97.244125 
	C193.032074,97.668320 193.074417,97.838409 193.044235,98.380508 
	C193.039795,99.755348 193.107864,100.758171 193.125580,102.066162 
	C193.349442,102.869820 193.623688,103.368301 193.897934,103.866783 
	C193.897934,103.866783 193.851105,104.103188 193.953400,104.184937 
	C194.055710,104.266678 194.114258,104.203232 193.807312,104.263336 
	C193.509018,104.531792 193.517654,104.740128 193.208450,104.924210 
	C192.254303,104.932266 191.617981,104.964569 190.590042,104.970917 
	C189.466370,103.737778 188.673187,102.562675 188.018494,101.314903 
	C187.282181,99.911552 186.670837,98.442650 185.878418,96.796341 
	C185.547302,96.332321 185.294998,96.135635 184.997711,96.000175 
	C185.000610,96.000000 184.997711,96.006363 184.946075,95.655357 
	C181.256546,93.202599 177.618652,91.100838 173.848206,88.697647 
	C172.808395,85.932907 171.901154,83.469604 170.996796,80.539085 
	C171.001633,76.783348 171.284119,73.464531 170.933044,70.214142 
	C170.513367,66.328453 172.222855,64.081451 175.404327,62.329823 
	C179.661179,59.986111 183.809799,57.445808 188.004898,54.989929 
z"/>
  <path fill="#2B265C" opacity="1.000000" stroke="none" d="
M193.381531,135.407410 
	C192.874512,136.629776 192.418930,137.530930 191.531403,138.608047 
	C191.062653,135.525818 191.025818,132.267609 190.992065,128.635162 
	C189.991791,126.171158 188.988434,124.081406 187.989990,121.751282 
	C187.994934,121.510918 187.954895,121.031754 187.968384,120.695465 
	C187.991577,119.911087 188.001297,119.462997 188.257782,119.008583 
	C188.504562,119.002266 188.998077,118.988373 189.456284,118.977341 
	C190.525497,118.922935 191.136505,118.879562 191.837616,119.201569 
	C192.363113,122.119507 192.798508,124.672066 193.218964,127.536636 
	C193.434067,128.153488 193.664093,128.458328 193.894135,128.763153 
	C193.740402,130.870834 193.586685,132.978516 193.381531,135.407410 
z"/>
  <path fill="#9CBAA0" opacity="1.000000" stroke="none" d="
M193.233917,127.224625 
	C192.798508,124.672066 192.363113,122.119507 191.883698,119.065796 
	C191.887573,118.365311 191.843185,118.189384 191.909851,117.705185 
	C192.492920,115.893761 192.872681,114.414009 193.252457,112.934258 
	C193.252457,112.934258 193.602203,112.867592 193.798370,113.241165 
	C194.028152,114.107849 194.061783,114.600960 194.095413,115.094078 
	C194.400803,118.761292 194.706177,122.428513 194.562881,126.594261 
	C193.820770,127.136734 193.527344,127.180679 193.233917,127.224625 
z"/>
  <path fill="#25205A" opacity="1.000000" stroke="none" d="
M192.899307,77.767303 
	C189.443695,78.776581 186.074646,79.543938 182.705612,80.311287 
	C184.256516,76.612778 187.364136,74.906357 191.457031,74.001488 
	C191.983810,74.891861 192.147110,75.798538 192.622742,76.859612 
	C192.952011,77.184471 192.968948,77.354927 192.899307,77.767303 
z"/>
  <path fill="#2B265C" opacity="1.000000" stroke="none" d="
M193.204865,112.554138 
	C192.872681,114.414009 192.492920,115.893761 191.734833,117.209061 
	C191.234940,115.695961 191.113342,114.347328 190.993835,112.554550 
	C190.991180,109.739227 190.986435,107.368050 190.981689,104.996872 
	C191.617981,104.964569 192.254303,104.932266 193.050507,105.156914 
	C193.240494,105.598915 193.270584,105.783981 193.300674,105.969055 
	C193.252869,108.037376 193.205063,110.105698 193.204865,112.554138 
z"/>
  <path fill="#A4C5A7" opacity="1.000000" stroke="none" d="
M193.175934,101.760994 
	C193.107864,100.758171 193.039795,99.755348 193.313049,98.369476 
	C193.833206,97.972878 194.012039,97.959328 194.190887,97.945778 
	C194.362442,98.609741 194.534012,99.273705 194.599426,100.241447 
	C194.493301,100.545227 194.617569,100.538574 194.252502,100.838692 
	C193.650299,101.346199 193.413132,101.553596 193.175934,101.760994 
z"/>
  <path fill="#A4C5A7" opacity="1.000000" stroke="none" d="
M194.209885,103.365402 
	C193.623688,103.368301 193.349442,102.869820 193.125580,102.066162 
	C193.413132,101.553596 193.650299,101.346199 194.234238,100.876205 
	C194.581024,100.613602 194.543320,100.550179 194.543320,100.550179 
	C194.536163,101.321457 194.528992,102.092743 194.209885,103.365402 
z"/>
  <path fill="#A4C5A7" opacity="1.000000" stroke="none" d="
M194.305573,114.878326 
	C194.061783,114.600960 194.028152,114.107849 193.976379,113.243164 
	C193.958252,112.871590 193.994095,112.858162 194.257675,112.895790 
	C194.521255,112.933418 195.016220,112.956116 195.016220,112.956116 
	C194.849396,113.524940 194.682571,114.093758 194.305573,114.878326 
z"/>
  <path fill="#AFD0B3" opacity="1.000000" stroke="none" d="
M193.380005,89.889091 
	C193.203293,89.824821 193.148926,89.662346 193.176514,89.256279 
	C193.577652,89.208366 193.658936,89.467766 193.380005,89.889091 
z"/>
  <path fill="#A4C5A7" opacity="1.000000" stroke="none" d="
M193.602783,105.770859 
	C193.270584,105.783981 193.240494,105.598915 193.368347,105.181152 
	C193.517654,104.740128 193.509018,104.531792 193.800598,104.281845 
	C194.100815,104.240234 194.056885,104.194756 194.056885,104.194756 
	C194.006226,104.654060 193.955566,105.113365 193.602783,105.770859 
z"/>
  <path fill="#AFD0B3" opacity="1.000000" stroke="none" d="
M193.382416,86.888870 
	C193.206467,86.824768 193.152512,86.662346 193.179657,86.256332 
	C193.579239,86.208435 193.660461,86.467705 193.382416,86.888870 
z"/>
  <path fill="#2B265C" opacity="1.000000" stroke="none" d="
M194.058441,104.230545 
	C194.056885,104.194756 194.100815,104.240234 194.107544,104.221733 
	C194.114258,104.203232 194.055710,104.266678 194.025345,104.281593 
	C193.994980,104.296509 194.059982,104.266342 194.058441,104.230545 
z"/>
  <path fill="#2B265C" opacity="1.000000" stroke="none" d="
M194.552551,100.576859 
	C194.543320,100.550179 194.581024,100.613602 194.599304,100.576088 
	C194.617569,100.538574 194.493301,100.545227 194.497345,100.582893 
	C194.501373,100.620560 194.561768,100.603539 194.552551,100.576859 
z"/>
  <path fill="#9CBAA0" opacity="1.000000" stroke="none" d="
M194.153122,97.699326 
	C194.012039,97.959328 193.833206,97.972878 193.385559,97.997467 
	C193.074417,97.838409 193.032074,97.668320 193.287689,97.239944 
	C193.585678,96.981667 194.046158,96.959045 194.046158,96.959045 
	C194.046158,96.959045 194.115356,97.452873 194.153122,97.699326 
z"/>
  <path fill="#A4C5A7" opacity="1.000000" stroke="none" d="
M193.965057,96.755661 
	C194.046158,96.959045 193.585678,96.981667 193.355225,96.985840 
	C193.098099,96.818001 193.071442,96.645973 193.138763,96.230255 
	C193.517288,96.097450 193.734360,96.286026 193.965057,96.755661 
z"/>
  <path fill="#343160" opacity="1.000000" stroke="none" d="
M192.965179,84.690735 
	C192.863480,84.692490 192.800125,84.495567 192.831757,84.397217 
	C192.863403,84.298874 193.098892,84.400337 193.098892,84.400337 
	C193.098892,84.400337 193.066864,84.688988 192.965179,84.690735 
z"/>
  <path fill="#343160" opacity="1.000000" stroke="none" d="
M192.919922,91.452652 
	C192.876419,91.372299 192.866714,91.350197 192.867569,91.334007 
	C192.868423,91.317818 192.963440,91.533012 192.919922,91.452652 
z"/>
  <path fill="#A4C5A7" opacity="1.000000" stroke="none" d="
M193.218964,127.536636 
	C193.527344,127.180679 193.820770,127.136734 194.556793,127.046326 
	C194.869934,127.323486 194.740448,127.647125 194.252563,128.366959 
	C193.664093,128.458328 193.434067,128.153488 193.218964,127.536636 
z"/>
  <path fill="#AFD0B3" opacity="1.000000" stroke="none" d="
M194.923065,112.819313 
	C195.016220,112.956116 194.521255,112.933418 194.276733,112.898346 
	C194.248093,112.525047 194.513977,112.464798 194.923065,112.819313 
z"/>
  <path fill="#161245" opacity="1.000000" stroke="none" d="
M190.988983,129.009399 
	C191.025818,132.267609 191.062653,135.525818 191.439163,138.910751 
	C191.523712,140.766632 191.268570,142.495804 190.548981,144.607849 
	C184.386017,145.468567 180.890411,149.543823 177.012817,152.995270 
	C177.012817,152.995270 177.000000,153.000000 176.711594,153.029724 
	C175.944397,153.376587 175.465591,153.693695 174.986801,154.010803 
	C174.986801,154.010803 174.998520,153.999924 174.603470,153.982803 
	C173.141907,152.437943 171.332504,150.991348 171.154999,149.366486 
	C170.709412,145.287476 171.001755,141.127838 171.254364,136.787125 
	C175.166672,133.924545 178.992874,131.476349 182.429367,128.567703 
	C185.638123,125.851807 188.280975,126.023750 190.988983,129.009399 
z"/>
  <path fill="#201D50" opacity="1.000000" stroke="none" d="
M177.387390,152.990311 
	C180.890411,149.543823 184.386017,145.468567 190.473495,144.987640 
	C190.893005,146.371124 190.923553,147.757721 190.888824,149.555450 
	C189.442551,149.692902 187.891403,148.879349 186.713638,149.250534 
	C183.642441,150.218460 180.734833,151.705414 177.387390,152.990311 
z"/>
  <path fill="#829C83" opacity="1.000000" stroke="none" d="
M137.095139,190.091507 
	C137.056198,190.785080 137.017258,191.478668 136.612991,192.546906 
	C135.114700,193.523376 133.981735,194.125168 132.848770,194.726959 
	C125.645256,194.265594 118.445305,193.540436 111.236885,193.443359 
	C107.019241,193.386581 102.793892,194.392410 98.560303,194.797974 
	C96.762619,194.970154 94.934929,194.829041 92.785400,194.534912 
	C90.725601,190.962906 88.061050,191.167725 84.829102,194.825287 
	C83.844429,194.789658 82.859749,194.754044 81.486969,194.295456 
	C81.033356,192.613953 80.967857,191.355423 81.378998,190.065521 
	C87.559685,189.762405 93.263725,189.490662 99.357544,189.161743 
	C100.522263,188.978333 101.297203,188.852112 102.308586,188.800507 
	C102.545029,188.875122 103.007240,189.054764 103.209702,189.267303 
	C104.271523,189.342453 105.130882,189.205048 106.316147,188.990295 
	C107.076683,188.814926 107.511314,188.716934 108.293900,188.700745 
	C109.112190,188.728638 109.582512,188.674759 110.288696,188.739716 
	C110.686592,188.927429 110.848625,188.996307 111.245552,189.286285 
	C112.651405,189.355026 113.822365,189.202667 115.225754,188.964951 
	C115.458183,188.879578 115.927689,188.722092 116.282379,188.819977 
	C117.120163,188.860657 117.603241,188.803467 118.314667,188.820587 
	C118.543007,188.894882 118.986778,189.078476 119.319717,189.325211 
	C125.466820,189.745132 131.280975,189.918320 137.095139,190.091507 
z"/>
  <path fill="#829C83" opacity="1.000000" stroke="none" d="
M55.380356,192.069016 
	C54.474888,191.446945 53.941635,190.820847 53.371685,189.752060 
	C54.876854,189.153336 56.418724,188.997314 58.340816,188.915695 
	C59.491234,189.060349 60.261429,189.130585 61.196167,189.363541 
	C61.898354,189.417786 62.435993,189.309296 63.317451,189.152878 
	C64.121254,189.146118 64.581230,189.187286 65.283585,189.417206 
	C66.657784,189.458405 67.789627,189.310837 69.328903,189.121033 
	C70.826485,189.112885 71.916634,189.146988 73.116417,189.292511 
	C73.226044,189.403961 73.664062,189.431992 73.664062,189.431992 
	C73.664062,189.431992 73.997147,189.121735 74.228867,189.021835 
	C74.619263,188.866119 74.777954,188.810287 75.265900,188.867615 
	C76.052620,189.058792 76.510071,189.136810 77.189217,189.399506 
	C77.963509,189.744324 78.516113,189.904449 79.019524,190.380264 
	C78.654900,191.489014 78.339478,192.282089 78.024048,193.075150 
	C78.024048,193.075150 77.984055,193.042557 77.638084,193.008133 
	C76.549370,192.961487 75.806625,192.949265 74.670395,192.875198 
	C71.191032,192.865067 68.105156,192.916794 64.800575,193.089569 
	C64.298584,193.411652 64.109032,193.679077 64.013222,194.012939 
	C62.592937,193.760239 61.172653,193.507538 59.395004,193.274277 
	C57.942616,192.884140 56.847595,192.474564 55.380356,192.069016 
z"/>
  <path fill="#9DBC9E" opacity="1.000000" stroke="none" d="
M65.019279,192.968506 
	C68.105156,192.916794 71.191032,192.865067 74.645203,193.157532 
	C74.998398,193.689529 74.983307,193.877365 74.968208,194.065186 
	C71.864983,194.176041 68.761757,194.286896 65.319214,193.963654 
	C64.993011,193.342545 65.006142,193.155533 65.019279,192.968506 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M85.288162,194.895294 
	C88.061050,191.167725 90.725601,190.962906 92.350174,194.535492 
	C90.082687,194.876068 87.914955,194.920700 85.288162,194.895294 
z"/>
  <path fill="#93B194" opacity="1.000000" stroke="none" d="
M78.251038,193.287003 
	C78.339478,192.282089 78.654900,191.489014 79.324905,190.378998 
	C80.087120,190.073639 80.494736,190.085266 80.902359,190.096878 
	C80.967857,191.355423 81.033356,192.613953 81.122612,194.233551 
	C80.256920,194.229355 79.367470,193.864105 78.251038,193.287003 
z"/>
  <path fill="#9DBC9E" opacity="1.000000" stroke="none" d="
M133.261993,194.821411 
	C133.981735,194.125168 135.114700,193.523376 136.609955,192.894257 
	C136.989288,193.315353 137.006332,193.763779 137.031418,194.545135 
	C135.918030,194.890656 134.796616,194.903259 133.261993,194.821411 
z"/>
  <path fill="#93B194" opacity="1.000000" stroke="none" d="
M75.310669,194.065491 
	C74.983307,193.877365 74.998398,193.689529 75.038681,193.219376 
	C75.806625,192.949265 76.549370,192.961487 77.663712,193.009048 
	C77.241241,193.384857 76.447182,193.725311 75.310669,194.065491 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M64.800575,193.089569 
	C65.006142,193.155533 64.993011,193.342545 64.954483,193.810715 
	C64.929070,194.091873 64.469437,194.070496 64.241333,194.041718 
	C64.109032,193.679077 64.298584,193.411652 64.800575,193.089569 
z"/>
  <path fill="#829C83" opacity="1.000000" stroke="none" d="
M153.974457,190.926926 
	C153.540588,190.953476 153.106735,190.980042 152.348511,191.036774 
	C150.249130,191.272934 148.474136,191.478912 146.351700,191.846863 
	C145.040421,191.278137 144.076569,190.547440 143.333588,189.422424 
	C144.055313,188.731125 144.556152,188.434128 145.428925,188.097687 
	C146.544403,187.986893 147.287933,187.915558 148.359467,187.895599 
	C149.466370,187.571320 150.245316,187.195633 151.272079,186.898163 
	C151.683105,187.034546 151.846283,187.092743 152.081055,187.455200 
	C152.759888,188.815308 153.367172,189.871109 153.974457,190.926926 
z"/>
  <path fill="#1F1A50" opacity="1.000000" stroke="none" d="
M145.056992,188.137115 
	C144.556152,188.434128 144.055313,188.731125 143.259949,189.124176 
	C142.805496,189.157654 142.645554,189.095062 142.042297,188.748062 
	C141.061584,188.299911 140.524216,188.136185 139.821747,187.682709 
	C137.437881,185.923859 135.219131,184.454727 133.000153,182.652313 
	C133.005508,181.874084 133.011108,181.429169 133.367249,181.037445 
	C137.497528,183.439484 141.277267,185.788300 145.056992,188.137115 
z"/>
  <path fill="#7A8B86" opacity="1.000000" stroke="none" d="
M137.404816,190.091064 
	C131.280975,189.918320 125.466820,189.745132 119.782661,189.238190 
	C126.276909,188.961609 132.641159,189.018814 138.998413,189.342072 
	C138.979340,189.785156 138.967255,189.962189 138.955185,190.139221 
	C138.541626,190.123032 138.128067,190.106827 137.404816,190.091064 
z"/>
  <path fill="#829C83" opacity="1.000000" stroke="none" d="
M138.971558,190.453339 
	C138.967255,189.962189 138.979340,189.785156 139.223114,189.250961 
	C139.454834,188.893784 139.918243,188.751129 140.197388,188.902557 
	C140.665009,189.150436 140.853485,189.246902 141.041946,189.343369 
	C140.924271,190.569809 140.806595,191.796249 140.543793,194.535202 
	C139.645874,192.360779 139.316895,191.564102 138.971558,190.453339 
z"/>
  <path fill="#2F364E" opacity="1.000000" stroke="none" d="
M141.288788,189.240982 
	C140.853485,189.246902 140.665009,189.150436 140.205856,188.707245 
	C139.935165,188.360489 139.986847,187.972473 139.986847,187.972473 
	C140.524216,188.136185 141.061584,188.299911 141.798004,188.666290 
	C141.843231,188.958832 141.689423,189.048706 141.288788,189.240982 
z"/>
  <path fill="#19C4F6" opacity="1.000000" stroke="none" d="
M89.006783,33.184788 
	C92.078789,31.780502 95.150795,30.376217 99.037369,28.961712 
	C101.569191,28.922585 103.286446,28.893673 105.351547,28.947346 
	C106.803001,29.409311 107.906593,29.788694 109.008667,30.473665 
	C109.005112,31.186729 109.003067,31.594204 108.634201,32.054012 
	C101.916321,33.020184 100.784531,33.611065 95.984467,38.514362 
	C95.635628,38.870701 95.291649,39.233036 94.925461,39.570969 
	C86.276718,47.552376 77.828773,55.769714 68.877113,63.395748 
	C65.139305,66.580040 60.329510,68.506012 56.005447,70.594276 
	C54.947006,64.358955 60.488697,63.124634 63.183910,59.928600 
	C66.680504,55.782276 72.865509,53.691784 73.212906,46.738564 
	C74.509628,45.718632 75.672340,45.043434 76.657188,44.168114 
	C80.109756,41.099503 83.501060,37.961960 86.915634,34.850594 
	C86.915634,34.850594 86.942192,34.928715 87.211975,34.900791 
	C87.990105,34.310173 88.498444,33.747478 89.006783,33.184788 
M95.788109,32.018730 
	C95.945976,32.200829 96.103844,32.382927 96.261703,32.565022 
	C96.369110,32.456890 96.476517,32.348755 96.583923,32.240627 
	C96.400314,32.084057 96.216713,31.927485 95.788109,32.018730 
z"/>
  <path fill="#241E5B" opacity="1.000000" stroke="none" d="
M105.003708,28.864761 
	C103.286446,28.893673 101.569191,28.922585 99.426483,28.891722 
	C99.643806,27.978477 100.286575,27.125004 100.897057,26.314411 
	C97.756882,24.387453 94.598305,22.449200 91.367264,19.919476 
	C90.735214,17.805077 90.326469,16.187296 89.481621,14.843752 
	C89.323341,14.592038 87.420380,15.437412 86.322540,15.776510 
	C87.215851,17.186476 88.109161,18.596441 89.002472,20.006407 
	C88.897964,21.426060 88.793449,22.845715 88.613510,25.289738 
	C87.136620,23.422022 86.302551,22.367231 85.715660,21.625032 
	C83.080109,22.123064 80.850967,22.544300 78.621819,22.965536 
	C78.381142,22.415363 78.140457,21.865191 77.899780,21.315018 
	C79.394478,20.174866 80.889175,19.034714 82.450119,17.844030 
	C79.230286,14.506191 75.837479,10.989034 72.309113,6.996815 
	C72.466423,6.108299 72.759293,5.694843 73.052162,5.281388 
	C78.062469,5.258034 83.072769,5.234679 88.542908,5.707734 
	C89.156532,8.325400 89.310326,10.446656 89.464127,12.567912 
	C90.024757,12.815287 90.585388,13.062661 91.146019,13.310036 
	C93.431076,10.668491 95.716125,8.026946 98.001175,5.385399 
	C100.014130,5.319044 102.027084,5.252689 104.471230,5.514498 
	C104.939430,6.213811 104.976448,6.584963 104.960739,7.302998 
	C103.754044,9.008064 102.824188,10.689871 101.408569,11.670243 
	C93.980499,16.814491 93.998817,18.847847 101.816216,23.871183 
	C102.371681,24.228115 103.275139,24.346897 103.517982,24.828135 
	C104.159691,26.099762 104.527107,27.509811 105.003708,28.864761 
M85.121765,10.571531 
	C84.816681,9.765386 84.511589,8.959241 84.206505,8.153097 
	C83.674713,8.432240 83.142914,8.711385 82.611122,8.990526 
	C83.241760,9.581824 83.872406,10.173122 85.121765,10.571531 
z"/>
  <path fill="#201A55" opacity="1.000000" stroke="none" d="
M28.008190,48.989773 
	C28.005247,46.157433 28.102306,43.320698 27.978168,40.493679 
	C27.733265,34.916485 27.823059,29.495844 32.948811,25.352285 
	C35.913074,25.003046 38.817978,25.003046 41.969383,25.003046 
	C42.885738,27.254017 44.043934,30.099049 45.600853,33.410934 
	C46.541054,37.928406 45.719673,40.917263 41.188061,42.423038 
	C38.872852,43.192345 37.045509,45.429871 34.998753,47.001816 
	C34.999847,46.999847 35.004143,46.998775 34.695999,47.059937 
	C33.925644,47.745724 33.463436,48.370342 32.846703,49.271797 
	C31.802158,50.033981 30.912140,50.519329 29.954800,50.696671 
	C29.261051,49.922363 28.634621,49.456066 28.008190,48.989773 
z"/>
  <path fill="#1D1852" opacity="1.000000" stroke="none" d="
M30.022121,51.004677 
	C30.912140,50.519329 31.802158,50.033981 33.155045,49.211884 
	C34.079987,48.249683 34.542065,47.624229 35.004143,46.998775 
	C35.004143,46.998775 34.999847,46.999847 35.395267,46.999283 
	C38.421345,46.169571 41.004063,45.080345 43.696091,44.584152 
	C46.407566,44.084373 49.227661,44.173893 52.000164,44.005207 
	C52.797424,45.703663 53.594685,47.402119 54.639622,49.628208 
	C55.073956,49.658974 56.317432,49.747059 57.685913,50.253143 
	C55.268372,53.779079 52.725830,56.887020 50.108501,60.324444 
	C49.955185,61.096516 49.876656,61.539097 49.412094,61.983891 
	C46.017223,61.321369 43.008381,60.656639 39.983116,59.621128 
	C38.658531,53.986362 35.201309,52.133259 30.029293,52.661392 
	C30.023108,51.888252 30.022614,51.446465 30.022121,51.004677 
z"/>
  <path fill="#15CAF6" opacity="1.000000" stroke="none" d="
M50.183289,59.994957 
	C52.725830,56.887020 55.268372,53.779079 57.974541,50.358536 
	C59.537663,49.420086 60.937160,48.794235 62.854122,48.274910 
	C64.226608,47.863102 65.081635,47.344765 65.936661,46.826424 
	C65.936661,46.826424 65.941772,46.908749 66.281769,46.921989 
	C68.746956,46.953999 70.872139,46.972767 72.997330,46.991535 
	C72.865509,53.691784 66.680504,55.782276 63.183910,59.928600 
	C60.488697,63.124634 54.947006,64.358955 56.003616,71.031326 
	C56.002922,73.919014 56.002373,75.959808 56.000381,78.374474 
	C55.998020,79.496063 55.997097,80.243782 55.741627,80.690353 
	C53.843037,78.024612 57.358810,72.542938 51.020348,72.548782 
	C50.735718,68.057220 50.459503,64.026093 50.183289,59.994957 
z"/>
  <path fill="#27215E" opacity="1.000000" stroke="none" d="
M51.981941,43.633263 
	C49.227661,44.173893 46.407566,44.084373 43.696091,44.584152 
	C41.004063,45.080345 38.421345,46.169571 35.394173,47.001251 
	C37.045509,45.429871 38.872852,43.192345 41.188061,42.423038 
	C45.719673,40.917263 46.541054,37.928406 45.998947,33.439121 
	C45.998322,30.624496 45.998322,28.248533 45.998322,25.872572 
	C46.496979,25.802383 46.995640,25.732193 47.494297,25.662004 
	C49.052219,31.508001 45.905773,38.765923 51.981941,43.633263 
z"/>
  <path fill="#10CDF1" opacity="1.000000" stroke="none" d="
M73.212906,46.738564 
	C70.872139,46.972767 68.746956,46.953999 66.240814,46.917202 
	C72.634659,42.901821 79.409462,38.904469 86.549950,34.878853 
	C83.501060,37.961960 80.109756,41.099503 76.657188,44.168114 
	C75.672340,45.043434 74.509628,45.718632 73.212906,46.738564 
z"/>
  <path fill="#2D2765" opacity="1.000000" stroke="none" d="
M89.335220,20.001724 
	C88.109161,18.596441 87.215851,17.186476 86.322540,15.776510 
	C87.420380,15.437412 89.323341,14.592038 89.481621,14.843752 
	C90.326469,16.187296 90.735214,17.805077 91.146957,19.657648 
	C90.555405,19.990541 90.111694,19.993792 89.335220,20.001724 
z"/>
  <path fill="#4D5470" opacity="1.000000" stroke="none" d="
M72.609421,5.175076 
	C72.759293,5.694843 72.466423,6.108299 72.062073,6.749721 
	C69.684723,6.654627 67.418839,6.331567 65.024796,5.654452 
	C67.319984,5.223186 69.743332,5.145976 72.609421,5.175076 
z"/>
  <path fill="#10CDF1" opacity="1.000000" stroke="none" d="
M65.599396,46.865723 
	C65.081635,47.344765 64.226608,47.863102 63.178024,48.168911 
	C63.743683,47.605927 64.502907,47.255470 65.599396,46.865723 
z"/>
  <path fill="#10CDF1" opacity="1.000000" stroke="none" d="
M88.714294,33.198242 
	C88.498444,33.747478 87.990105,34.310173 87.171432,34.893158 
	C87.381340,34.346195 87.901573,33.778946 88.714294,33.198242 
z"/>
  <path fill="#211B57" opacity="1.000000" stroke="none" d="
M105.351555,28.947346 
	C104.527107,27.509811 104.159691,26.099762 103.517982,24.828135 
	C103.275139,24.346897 102.371681,24.228115 101.816216,23.871183 
	C93.998817,18.847847 93.980499,16.814491 101.408569,11.670243 
	C102.824188,10.689871 103.754044,9.008064 105.394852,7.321974 
	C107.906075,6.989411 109.930450,6.984755 111.954826,6.980097 
	C114.205338,9.009328 116.215225,11.434366 118.759186,12.980873 
	C123.287918,15.733943 123.548813,16.949942 119.577744,20.310709 
	C118.488876,21.232222 117.785973,22.609779 116.905952,23.778067 
	C117.299347,24.292833 117.692741,24.807600 118.086136,25.322365 
	C120.942894,23.743088 123.799644,22.163809 127.079048,20.288385 
	C127.668610,19.993013 127.835526,19.993790 128.002441,19.994568 
	C128.335022,21.416691 128.667587,22.838816 129.000977,25.074347 
	C128.328033,30.955130 127.654289,36.022507 126.657257,40.954636 
	C122.878189,38.930813 119.422394,37.042233 115.680191,34.975525 
	C113.265923,33.254284 111.138054,31.711180 109.010193,30.168076 
	C107.906593,29.788694 106.803001,29.409311 105.351555,28.947346 
z"/>
  <path fill="#262363" opacity="1.000000" stroke="none" d="
M126.980545,41.089890 
	C127.654289,36.022507 128.328033,30.955130 129.003021,25.446531 
	C129.004272,25.005310 129.503021,25.001862 129.752426,25.001083 
	C130.341660,29.417377 130.632523,33.839218 131.061905,38.247566 
	C131.149750,39.149384 131.509003,40.420261 132.164688,40.807812 
	C136.818771,43.558605 141.547363,46.193432 146.371063,48.629940 
	C146.806412,48.849842 148.080536,47.409187 148.985443,46.372936 
	C149.447998,46.004902 149.890228,46.003628 150.664093,46.003555 
	C151.759674,46.992699 152.523621,47.980644 153.602371,49.325790 
	C153.611862,50.788212 153.306534,51.893425 153.000366,53.332260 
	C152.997879,54.110687 152.996262,54.555496 152.621002,55.001472 
	C151.499802,55.001453 150.752258,55.000267 149.689209,54.893951 
	C147.936035,53.824261 146.498383,52.859695 144.885437,51.616379 
	C143.128815,50.602371 141.547501,49.867119 139.692764,48.960812 
	C138.637070,48.481922 137.854767,48.174091 137.055634,47.903721 
	C137.038773,47.941185 137.116669,47.967297 137.020935,47.714325 
	C136.625046,47.274490 136.324905,47.087627 136.026382,46.937042 
	C136.028015,46.973324 136.092484,46.939899 135.917511,46.653839 
	C133.809052,45.325630 131.875549,44.283482 129.676666,43.071663 
	C128.601028,42.297958 127.790779,41.693924 126.980545,41.089890 
z"/>
  <path fill="#211C58" opacity="1.000000" stroke="none" d="
M120.017868,5.732519 
	C122.704872,5.332518 125.410896,5.278547 128.559570,5.316472 
	C129.002197,7.674740 129.002197,9.941113 129.002197,12.207486 
	C128.565201,12.516236 128.128204,12.824986 127.691208,13.133737 
	C125.139771,10.782007 122.588333,8.430278 120.017868,5.732519 
z"/>
  <path fill="#211C58" opacity="1.000000" stroke="none" d="
M132.985077,5.746861 
	C135.374634,5.353256 137.751617,5.294225 140.565781,5.326947 
	C141.190948,11.076026 135.580887,8.153329 132.651749,10.419332 
	C132.758667,8.973366 132.865585,7.527400 132.985077,5.746861 
z"/>
  <path fill="#2D2765" opacity="1.000000" stroke="none" d="
M128.381393,19.981834 
	C127.835526,19.993790 127.668610,19.993013 127.251328,19.990520 
	C126.939079,18.476622 126.451935,16.785309 126.983604,15.523160 
	C127.276627,14.827550 129.304962,14.577033 130.503067,14.680504 
	C131.028168,14.725853 132.016876,16.531715 131.786407,16.890810 
	C131.025696,18.076065 129.804657,18.965868 128.381393,19.981834 
z"/>
  <path fill="#4D5470" opacity="1.000000" stroke="none" d="
M112.066269,6.752489 
	C109.930450,6.984755 107.906075,6.989411 105.447586,6.975091 
	C104.976448,6.584963 104.939430,6.213811 104.900894,5.562574 
	C107.322083,5.212790 109.744774,5.143092 112.610184,5.179008 
	C112.761169,5.698040 112.469444,6.111460 112.066269,6.752489 
z"/>
  <path fill="#211C58" opacity="1.000000" stroke="none" d="
M97.557945,5.297435 
	C95.716125,8.026946 93.431076,10.668491 91.146019,13.310036 
	C90.585388,13.062661 90.024757,12.815287 89.464127,12.567912 
	C89.310326,10.446656 89.156532,8.325400 89.000717,5.801502 
	C91.704048,5.335730 94.409378,5.272599 97.557945,5.297435 
z"/>
  <path fill="#1E1953" opacity="1.000000" stroke="none" d="
M26.999950,73.000305 
	C26.999849,70.359657 27.117083,67.711784 26.955191,65.081093 
	C26.859659,63.528786 26.321980,62.003693 25.983141,60.466362 
	C24.310736,60.872513 22.149963,60.762051 21.064030,61.788605 
	C18.529488,64.184540 16.177719,64.021469 13.439371,62.033596 
	C16.433456,61.510990 17.014357,59.484985 17.018591,57.001324 
	C17.457727,57.001232 17.896866,57.001144 19.064121,57.001263 
	C20.855083,56.998924 21.917929,56.996380 23.275455,56.961075 
	C24.050238,56.614937 24.530336,56.301559 25.377075,55.983215 
	C27.162714,55.652889 28.581715,55.327530 30.086180,55.343636 
	C31.114740,57.455860 32.057835,59.226624 32.748894,61.253231 
	C29.096060,66.038902 29.820988,70.994568 30.721973,75.849243 
	C29.294998,74.800926 28.147474,73.900612 26.999950,73.000305 
z"/>
  <path fill="#251F5B" opacity="1.000000" stroke="none" d="
M22.980772,56.993835 
	C21.917929,56.996380 20.855083,56.998924 19.393475,57.001419 
	C19.157471,56.546638 19.181175,55.889328 19.503981,55.667736 
	C23.919056,52.636921 23.444273,50.190945 18.813892,47.448055 
	C20.638376,47.930725 22.462860,48.413391 24.642918,49.378326 
	C24.991566,51.580894 24.984642,53.301193 24.671684,55.077492 
	C23.904024,55.753605 23.442398,56.373722 22.980772,56.993835 
z"/>
  <path fill="#2B2565" opacity="1.000000" stroke="none" d="
M24.977718,55.021492 
	C24.984642,53.301193 24.991566,51.580894 24.999739,49.430733 
	C25.000988,49.000874 25.492556,48.992008 25.738110,48.985584 
	C26.433548,48.983746 26.883434,48.988335 27.670755,48.991348 
	C28.634621,49.456066 29.261051,49.922363 29.954802,50.696671 
	C30.022614,51.446465 30.023108,51.888252 30.018593,52.996292 
	C30.009293,54.109085 30.005003,54.555630 30.000713,55.002171 
	C28.581715,55.327530 27.162714,55.652889 25.370010,55.741562 
	C24.996307,55.504879 24.977718,55.021492 24.977718,55.021492 
z"/>
  <path fill="#251F5B" opacity="1.000000" stroke="none" d="
M16.654602,57.008945 
	C17.014357,59.484985 16.433456,61.510990 13.192684,61.787132 
	C12.554523,61.997513 12.109218,61.999863 11.329863,62.005318 
	C10.996325,61.256695 10.996840,60.504963 10.999559,59.377556 
	C12.764714,58.340115 14.527664,57.678341 16.654602,57.008945 
z"/>
  <path fill="#1D1853" opacity="1.000000" stroke="none" d="
M153.001221,52.998642 
	C153.306534,51.893425 153.611862,50.788212 153.965912,49.340733 
	C156.013031,49.489979 158.011398,49.981483 160.600693,50.618328 
	C161.370804,49.500202 162.667389,47.617691 163.981689,45.370529 
	C170.354187,40.750458 175.403717,45.068676 180.840454,47.410774 
	C182.275497,48.028980 184.155090,47.615242 185.916855,47.334885 
	C186.363266,46.526684 186.723389,46.058960 187.083496,45.591232 
	C187.691620,46.502625 188.299744,47.414017 188.950562,48.651173 
	C188.334595,50.072472 187.675934,51.168007 186.663300,52.681564 
	C182.535995,55.393631 178.735260,57.644066 174.998276,59.995792 
	C172.111588,61.812420 169.582108,62.175713 166.392838,60.088070 
	C162.185043,57.333714 157.487961,55.326851 153.001221,52.998642 
z"/>
  <path fill="#1D1853" opacity="1.000000" stroke="none" d="
M185.120605,41.514061 
	C184.568863,42.106480 183.812286,42.493275 183.055695,42.880066 
	C182.923431,42.477230 182.791153,42.074394 182.658890,41.671558 
	C183.411179,41.550518 184.163483,41.429474 185.120605,41.514061 
z"/>
  <path fill="#241E59" opacity="1.000000" stroke="none" d="
M153.000366,53.332260 
	C157.487961,55.326851 162.185043,57.333714 166.392838,60.088070 
	C169.582108,62.175713 172.111588,61.812420 174.998276,59.995792 
	C178.735260,57.644066 182.535995,55.393631 186.663116,53.051003 
	C187.322296,53.473351 187.627670,53.944279 187.968964,54.702568 
	C183.809799,57.445808 179.661179,59.986111 175.404327,62.329823 
	C172.222855,64.081451 170.513367,66.328453 170.933044,70.214142 
	C171.284119,73.464531 171.001633,76.783348 170.753311,80.541870 
	C170.506927,81.011871 170.019791,81.018227 170.012268,80.549545 
	C170.001495,76.587280 169.818954,73.082031 170.045059,69.603348 
	C170.274292,66.076744 168.816162,64.385391 165.602753,62.862968 
	C161.156387,60.756409 157.175079,57.668163 152.994629,55.000305 
	C152.996262,54.555496 152.997879,54.110687 153.000366,53.332260 
z"/>
  <path fill="#150F41" opacity="1.000000" stroke="none" d="
M152.009476,187.150925 
	C151.846283,187.092743 151.683105,187.034546 151.265060,186.442871 
	C151.008163,181.606979 150.905289,177.300888 151.062744,173.004318 
	C151.112885,171.636490 151.452942,169.539825 152.346420,169.063431 
	C157.792664,166.159546 163.436646,163.626587 169.274384,161.294922 
	C169.782272,166.292755 170.030441,170.965561 170.278610,175.638367 
	C171.012741,171.864883 171.064987,168.094864 170.995514,164.327103 
	C170.943832,161.524139 171.947678,159.848328 175.009781,160.013474 
	C175.009781,160.013474 174.998978,159.998901 175.180023,160.221222 
	C175.908340,160.631317 176.455612,160.819092 177.002899,161.006866 
	C177.937103,161.856674 178.744980,162.998489 179.841568,163.472916 
	C180.905579,163.933258 182.266083,163.708313 183.834534,163.935959 
	C182.052979,167.014603 179.933258,169.941589 177.315247,173.274139 
	C173.509354,176.312408 170.460907,179.404892 166.824646,181.454529 
	C162.817719,183.713120 158.270920,185.013947 153.854614,186.630051 
	C153.440338,186.420532 153.196884,186.513138 152.765366,186.887238 
	C152.343948,187.029343 152.176712,187.090134 152.009476,187.150925 
z"/>
  <path fill="#28225C" opacity="1.000000" stroke="none" d="
M174.964844,159.669830 
	C171.947678,159.848328 170.943832,161.524139 170.995514,164.327103 
	C171.064987,168.094864 171.012741,171.864883 170.278610,175.638367 
	C170.030441,170.965561 169.782272,166.292755 169.229248,160.982910 
	C168.283554,159.563919 167.642715,158.781967 167.006622,157.666504 
	C167.008301,156.888351 167.005264,156.443665 167.223343,155.810974 
	C167.630295,155.083603 167.816147,154.544235 168.331177,153.789017 
	C169.111588,148.049728 169.562805,142.526306 170.260071,137.002991 
	C170.506104,137.003082 170.998169,137.000534 170.998169,137.000534 
	C171.001755,141.127838 170.709412,145.287476 171.154999,149.366486 
	C171.332504,150.991348 173.141907,152.437943 174.610504,153.979095 
	C174.981689,155.770416 174.950790,157.548309 174.964844,159.669830 
z"/>
  <path fill="#28225C" opacity="1.000000" stroke="none" d="
M176.819016,160.775146 
	C176.455612,160.819092 175.908340,160.631317 175.171646,160.217651 
	C175.533188,160.175644 176.084167,160.359528 176.819016,160.775146 
z"/>
  <path fill="#28225C" opacity="1.000000" stroke="none" d="
M175.283905,153.982025 
	C175.465591,153.693695 175.944397,153.376587 176.718323,153.026627 
	C176.535980,153.313614 176.058487,153.633438 175.283905,153.982025 
z"/>
  <path fill="#88A38C" opacity="1.000000" stroke="none" d="
M153.959305,186.731995 
	C158.270920,185.013947 162.817719,183.713120 166.824646,181.454529 
	C170.460907,179.404892 173.509354,176.312408 177.094147,173.518280 
	C177.570511,174.252853 177.769699,175.148834 177.971619,176.502899 
	C176.456787,178.479202 174.939209,179.997406 172.817078,181.753326 
	C169.808029,183.660461 167.403564,185.329910 164.999100,186.999359 
	C164.999100,186.999359 164.548935,187.109558 163.972382,187.111633 
	C162.262848,188.074936 161.129883,189.036179 159.996902,189.997406 
	C159.996902,189.997406 159.526093,190.056137 159.291183,190.087067 
	C157.595978,190.305206 156.135681,190.492416 154.324921,190.803284 
	C153.367172,189.871109 152.759888,188.815308 152.081055,187.455200 
	C152.176712,187.090134 152.343948,187.029343 153.004883,186.928192 
	C153.498596,186.887833 153.959305,186.731995 153.959305,186.731995 
z"/>
  <path fill="#97B89B" opacity="1.000000" stroke="none" d="
M165.371643,187.005249 
	C167.403564,185.329910 169.808029,183.660461 172.579498,181.971161 
	C172.954636,182.121857 172.962784,182.292389 172.976318,182.718689 
	C170.569183,184.320007 168.156677,185.665573 165.371643,187.005249 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M160.375275,190.000305 
	C161.129883,189.036179 162.262848,188.074936 163.745560,187.159058 
	C162.981415,188.137329 161.867523,189.070267 160.375275,190.000305 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M32.961529,184.519302 
	C34.513432,185.251938 36.101200,186.336807 37.829124,187.724197 
	C36.311989,186.974991 34.654694,185.923264 32.961529,184.519302 
z"/>
  <path fill="#A6C7A8" opacity="1.000000" stroke="none" d="
M40.821358,188.714630 
	C41.057564,189.111725 41.046631,189.284241 41.029694,189.715698 
	C40.061966,189.548691 39.100246,189.122772 38.057251,188.367798 
	C38.842052,188.189194 39.708134,188.339630 40.821358,188.714630 
z"/>
  <path fill="#151041" opacity="1.000000" stroke="none" d="
M33.420288,181.009018 
	C31.118252,179.214279 29.179745,177.449142 27.161690,175.007294 
	C27.802437,170.872513 28.897793,167.898193 32.719532,166.404266 
	C35.047958,165.494080 36.955070,163.506088 39.330250,161.968277 
	C40.067562,161.637985 40.526058,161.341629 41.279228,160.997314 
	C42.055931,160.629639 42.537952,160.309906 43.010658,159.994553 
	C43.001350,159.998917 42.988457,160.014877 43.396667,160.037018 
	C44.374901,160.347290 45.418407,160.597214 45.445194,160.929199 
	C46.006535,167.886017 47.078365,174.890320 44.462406,182.114441 
	C46.111801,182.365173 48.041721,182.658554 50.197678,183.143250 
	C50.632019,183.878754 50.840328,184.422943 50.718815,185.046036 
	C49.902431,185.819824 49.415874,186.514709 48.929314,187.209595 
	C43.880814,185.152603 38.832314,183.095627 33.420288,181.009018 
z"/>
  <path fill="#13103C" opacity="1.000000" stroke="none" d="
M49.129894,187.483551 
	C49.415874,186.514709 49.902431,185.819824 51.090736,185.059998 
	C53.848522,186.277145 55.904564,187.559219 57.960602,188.841278 
	C56.418724,188.997314 54.876854,189.153336 53.092056,189.611023 
	C52.849133,189.912674 52.496574,189.948471 52.319702,189.938385 
	C51.205376,189.204712 50.267921,188.481125 49.129894,187.483551 
z"/>
  <path fill="#231E53" opacity="1.000000" stroke="none" d="
M39.051430,162.002213 
	C36.955070,163.506088 35.047958,165.494080 32.719532,166.404266 
	C28.897793,167.898193 27.802437,170.872513 27.016058,174.708618 
	C26.368803,174.932571 25.787636,174.778473 24.960590,174.448700 
	C23.714783,172.863068 22.714853,171.453110 21.375849,169.954468 
	C21.043674,169.570877 20.936575,169.325790 20.524597,169.054626 
	C20.308998,168.810287 20.284273,168.641876 20.607479,168.148315 
	C25.810572,165.879761 30.639923,163.866745 35.541740,162.049164 
	C36.575340,161.665924 37.874588,161.999130 39.051430,162.002213 
z"/>
  <path fill="#151143" opacity="1.000000" stroke="none" d="
M39.330246,161.968277 
	C37.874588,161.999130 36.575340,161.665924 35.541740,162.049164 
	C30.639923,163.866745 25.810572,165.879761 20.581955,167.894257 
	C17.491703,163.224228 14.774900,158.483093 12.260498,153.370209 
	C12.462899,152.998444 12.883494,152.998138 13.246243,152.964386 
	C15.772256,151.620224 17.935518,150.309830 20.310400,149.003784 
	C20.522018,149.008133 20.945307,149.013657 21.164879,148.892456 
	C21.591862,148.513657 21.799273,148.256027 22.003033,147.999207 
	C21.999382,148.000000 22.000385,148.007599 22.445667,148.007843 
	C27.592585,149.007416 32.294224,150.006760 37.167259,151.299194 
	C38.550476,152.067566 39.762291,152.542847 41.160751,153.246246 
	C41.897072,153.650787 42.446743,153.827225 43.037071,154.346497 
	C43.047970,156.464508 43.018215,158.239700 42.988457,160.014877 
	C42.988457,160.014877 43.001350,159.998917 42.710270,160.026001 
	C41.940975,160.383804 41.462765,160.714539 40.984550,161.045258 
	C40.526058,161.341629 40.067562,161.637985 39.330246,161.968277 
z"/>
  <path fill="#161247" opacity="1.000000" stroke="none" d="
M12.883494,152.998138 
	C12.883494,152.998138 12.462899,152.998444 12.252653,152.994171 
	C11.386746,151.225250 10.731085,149.460602 10.306729,147.142441 
	C10.324305,146.067825 10.110574,145.546753 9.896842,145.025665 
	C9.896842,145.025665 9.956642,145.026642 9.940579,145.052063 
	C9.935735,144.883072 9.946952,144.688675 9.966187,144.202240 
	C9.974205,143.910202 10.015595,143.431412 10.047113,143.193237 
	C10.255282,139.540344 10.431934,136.125656 10.382179,132.391632 
	C10.124442,131.288330 10.093113,130.504364 10.330578,129.013519 
	C10.734922,125.535957 10.870473,122.765259 11.335632,119.948151 
	C12.809624,119.382645 13.954006,118.863548 15.372417,118.220161 
	C15.477718,119.495605 15.553028,120.407784 15.645326,121.525726 
	C17.158573,121.338791 18.589504,121.162025 20.342117,121.065010 
	C20.451153,122.142853 20.572802,123.500755 19.960974,124.069214 
	C18.351728,125.564377 16.423401,126.716118 14.622172,128.004654 
	C14.883448,128.387909 15.144723,128.771179 15.405998,129.154434 
	C18.288414,127.739769 21.170832,126.325096 24.335800,124.969376 
	C25.078449,125.352798 25.538544,125.677269 25.996346,126.469276 
	C25.448484,134.109329 28.122530,141.892059 22.000385,148.007599 
	C22.000385,148.007599 21.999382,148.000000 21.786303,148.122528 
	C21.305874,148.453827 21.096569,148.710022 20.945307,149.013657 
	C20.945307,149.013657 20.522018,149.008133 19.949520,149.005783 
	C16.602669,149.343674 13.717491,149.503784 12.883494,152.998138 
z"/>
  <path fill="#18173D" opacity="1.000000" stroke="none" d="
M9.946573,145.348328 
	C10.110574,145.546753 10.324305,146.067825 10.375818,146.772552 
	C10.141169,146.527786 10.068736,146.099380 9.946573,145.348328 
z"/>
  <path fill="#19154B" opacity="1.000000" stroke="none" d="
M20.020433,120.985260 
	C18.589504,121.162025 17.158573,121.338791 15.645326,121.525726 
	C15.553028,120.407784 15.477718,119.495605 15.372417,118.220161 
	C13.954006,118.863548 12.809624,119.382645 11.333572,119.480110 
	C11.005915,110.367035 11.009924,101.675575 11.013933,92.984123 
	C14.751199,94.322815 18.488464,95.661507 22.616646,97.002090 
	C23.450359,97.003235 23.893156,97.002495 24.686447,97.422348 
	C25.349581,104.549706 25.662222,111.256477 25.966572,118.211273 
	C25.958279,118.459290 25.933271,118.954079 25.568665,118.951050 
	C21.790941,117.336678 18.377825,115.725342 14.964708,114.113998 
	C14.788716,114.408112 14.612724,114.702225 14.436731,114.996338 
	C16.297966,116.992645 18.159201,118.988953 20.020433,120.985260 
z"/>
  <path fill="#241F59" opacity="1.000000" stroke="none" d="
M26.666620,73.073944 
	C28.147474,73.900612 29.294998,74.800926 31.067234,75.898697 
	C33.794220,77.731346 35.896500,79.366531 37.999390,81.000854 
	C38.000000,81.000000 38.001736,80.998169 38.001736,80.998169 
	C36.409161,80.727158 34.636604,80.813843 33.256962,80.119652 
	C28.685957,77.819672 24.303837,76.863029 19.857489,80.348297 
	C19.357340,80.740334 18.418194,80.572311 17.682625,80.664001 
	C17.460457,80.254272 17.238289,79.844536 17.016121,79.434807 
	C20.121843,77.339073 23.227568,75.243332 26.666620,73.073944 
z"/>
  <path fill="#231E57" opacity="1.000000" stroke="none" d="
M25.974861,117.963257 
	C25.662222,111.256477 25.349581,104.549706 25.018623,97.421463 
	C26.389441,97.000244 27.778574,97.000496 29.583855,97.000366 
	C30.000000,97.000000 29.998306,96.998169 29.936146,97.369553 
	C29.223167,99.588402 28.107887,101.412102 28.011864,103.287979 
	C27.761082,108.187187 27.956303,113.109215 27.640638,118.015259 
	C26.863348,117.993324 26.419104,117.978294 25.974861,117.963257 
z"/>
  <path fill="#2C2665" opacity="1.000000" stroke="none" d="
M44.023048,88.999084 
	C44.020203,87.931572 44.017357,86.864052 44.238167,85.211288 
	C44.650005,84.095421 44.838192,83.564819 45.268829,83.023735 
	C45.511280,83.013260 45.996952,82.997490 46.334946,83.003380 
	C47.731922,83.338577 48.790909,83.667892 49.908936,84.419838 
	C49.924133,86.263161 49.880295,87.683853 49.628433,89.270447 
	C48.948738,89.959557 48.477066,90.482765 47.675186,91.003044 
	C46.905041,90.994667 46.465111,90.989212 46.018600,90.987976 
	C46.012020,90.992195 46.016209,90.974617 45.953667,90.669357 
	C45.268429,89.909088 44.645737,89.454086 44.023048,88.999084 
z"/>
  <path fill="#241F59" opacity="1.000000" stroke="none" d="
M43.646763,89.010803 
	C44.645737,89.454086 45.268429,89.909088 45.550789,90.675583 
	C41.140610,92.660370 37.070759,94.333656 32.999989,95.753395 
	C32.997955,95.330811 32.996841,95.161774 32.995728,94.992744 
	C36.420647,93.002670 39.845562,91.012589 43.646763,89.010803 
z"/>
  <path fill="#241F59" opacity="1.000000" stroke="none" d="
M45.026379,83.034210 
	C44.838192,83.564819 44.650005,84.095421 44.244114,84.810806 
	C42.055630,83.900475 40.084850,82.805382 38.057899,81.354233 
	C38.001736,80.998169 38.000000,81.000000 38.371056,81.011627 
	C40.836864,81.693573 42.931622,82.363892 45.026379,83.034210 
z"/>
  <path fill="#231E57" opacity="1.000000" stroke="none" d="
M32.651131,95.006577 
	C32.996841,95.161774 32.997955,95.330811 32.770592,95.988525 
	C31.694178,96.650864 30.846241,96.824516 29.998306,96.998169 
	C29.998306,96.998169 30.000000,97.000000 30.000603,97.000641 
	C30.769650,96.340988 31.538090,95.680702 32.651131,95.006577 
z"/>
  <path fill="#18173D" opacity="1.000000" stroke="none" d="
M10.983866,92.708893 
	C11.009924,101.675575 11.005915,110.367035 11.003965,119.526520 
	C10.870473,122.765259 10.734922,125.535957 10.369537,128.623062 
	C10.111703,116.606094 10.083703,104.272720 10.117191,91.475342 
	C10.437052,91.485451 10.695425,91.959549 10.983866,92.708893 
z"/>
  <path fill="#1A154B" opacity="1.000000" stroke="none" d="
M190.590057,104.970917 
	C190.986435,107.368050 190.991180,109.739227 190.675308,112.601517 
	C185.993805,114.158485 190.673447,117.304573 188.998077,118.988373 
	C188.998077,118.988373 188.504562,119.002266 187.958466,118.842331 
	C183.940186,116.788795 180.468002,114.895195 176.997925,113.000793 
	C177.000046,113.000000 177.004562,113.006355 176.835388,112.703964 
	C172.841965,109.861809 170.887024,106.266724 171.053177,101.707664 
	C171.183685,98.127083 171.657181,94.558998 171.988251,90.992172 
	C171.998169,90.998978 171.987061,90.978310 172.389343,90.983833 
	C176.860306,92.661690 180.929016,94.334030 184.997711,96.006363 
	C184.997711,96.006363 185.000610,96.000000 185.124130,96.206299 
	C185.452774,96.669991 185.705276,96.866547 186.005127,97.002266 
	C186.670837,98.442650 187.282181,99.911552 188.018494,101.314903 
	C188.673187,102.562675 189.466370,103.737778 190.590057,104.970917 
z"/>
  <path fill="#2C2663" opacity="1.000000" stroke="none" d="
M170.019791,81.018227 
	C170.019791,81.018227 170.506927,81.011871 170.750412,81.009087 
	C171.901154,83.469604 172.808395,85.932907 173.542877,88.757904 
	C172.909103,89.739159 172.448074,90.358734 171.987061,90.978310 
	C171.987061,90.978310 171.998169,90.998978 171.657547,90.996384 
	C170.875412,90.998306 170.433899,91.002831 169.740479,90.885742 
	C168.994141,90.502975 168.499680,90.241829 167.968903,89.693336 
	C167.623154,88.937195 167.313736,88.468399 167.013214,87.640594 
	C168.021347,85.193802 169.020569,83.106010 170.019791,81.018227 
z"/>
  <path fill="#241E58" opacity="1.000000" stroke="none" d="
M172.389343,90.983833 
	C172.448074,90.358734 172.909103,89.739159 173.675446,89.059334 
	C177.618652,91.100838 181.256546,93.202599 184.946075,95.655365 
	C180.929016,94.334030 176.860306,92.661690 172.389343,90.983833 
z"/>
  <path fill="#241E58" opacity="1.000000" stroke="none" d="
M185.878418,96.796341 
	C185.705276,96.866547 185.452774,96.669991 185.121246,96.206467 
	C185.294998,96.135635 185.547302,96.332321 185.878418,96.796341 
z"/>
  <path fill="#181348" opacity="1.000000" stroke="none" d="
M187.954895,121.031754 
	C187.954895,121.031754 187.994934,121.510918 187.678986,121.901588 
	C182.518814,125.110207 177.736176,128.044800 172.784958,130.660217 
	C171.616272,131.277557 169.839523,131.054398 168.414062,130.806442 
	C165.911819,130.371170 163.464859,129.618073 160.997375,128.999054 
	C161.000000,129.000000 161.002441,129.004440 160.946747,128.647446 
	C158.910156,127.195168 156.929260,126.099892 154.713989,124.892509 
	C154.026871,124.525513 153.574173,124.270607 153.088135,123.643204 
	C153.047928,122.524185 153.041016,121.777657 153.366943,120.968834 
	C155.468918,119.604149 157.238037,118.301773 159.003586,116.999542 
	C159.000000,116.999695 158.998688,117.006966 159.346924,116.956711 
	C161.799286,115.603790 163.903412,114.301125 166.003937,112.998962 
	C166.000320,112.999466 165.997543,113.006805 166.455811,113.006744 
	C170.277557,113.006577 173.641068,113.006470 177.004562,113.006355 
	C177.004562,113.006355 177.000046,113.000000 177.050659,113.344009 
	C180.719162,116.135925 184.337021,118.583839 187.954895,121.031754 
z"/>
  <path fill="#201B53" opacity="1.000000" stroke="none" d="
M160.994751,128.998108 
	C163.464859,129.618073 165.911819,130.371170 168.414062,130.806442 
	C169.839523,131.054398 171.616272,131.277557 172.784958,130.660217 
	C177.736176,128.044800 182.518814,125.110207 187.674057,122.141953 
	C188.988434,124.081406 189.991791,126.171158 190.992065,128.635162 
	C188.280975,126.023750 185.638123,125.851807 182.429367,128.567703 
	C178.992874,131.476349 175.166672,133.924545 171.254364,136.787125 
	C170.998169,137.000534 170.506104,137.003082 170.016479,136.772797 
	C166.682831,134.027725 163.838791,131.512909 160.994751,128.998108 
z"/>
  <path fill="#211C52" opacity="1.000000" stroke="none" d="
M187.968384,120.695465 
	C184.337021,118.583839 180.719162,116.135925 177.048553,113.344803 
	C180.468002,114.895195 183.940186,116.788795 187.711700,118.848648 
	C188.001297,119.462997 187.991577,119.911087 187.968384,120.695465 
z"/>
  <path fill="#1C1750" opacity="1.000000" stroke="none" d="
M189.456284,118.977341 
	C190.673447,117.304573 185.993805,114.158485 190.673218,113.045654 
	C191.113342,114.347328 191.234940,115.695961 191.531555,117.540726 
	C191.843185,118.189384 191.887573,118.365311 191.793610,118.700409 
	C191.136505,118.879562 190.525497,118.922935 189.456284,118.977341 
z"/>
  <path fill="#151042" opacity="1.000000" stroke="none" d="
M111.010658,189.065186 
	C110.848625,188.996307 110.686592,188.927429 110.276840,188.299774 
	C110.693085,180.714920 108.186623,173.378632 111.547325,167.641647 
	C107.136902,165.811554 102.647255,163.948563 98.157608,162.085587 
	C97.990288,162.378723 97.822975,162.671844 97.655663,162.964981 
	C100.104095,164.641663 102.552521,166.318344 104.735298,168.237518 
	C99.324287,166.986893 94.178932,165.493744 89.024353,163.612946 
	C90.338867,160.150299 91.662613,157.075348 93.360184,153.994019 
	C96.417168,152.811386 99.324318,151.975525 101.736862,150.388016 
	C106.766563,147.078369 111.427452,147.164062 116.392433,150.478439 
	C119.072853,152.267761 122.118515,153.509918 125.125122,155.285645 
	C125.528076,156.825043 125.438599,158.353867 126.140869,159.286484 
	C131.479172,166.375824 129.510895,173.640793 126.587639,181.026215 
	C124.496140,182.400497 122.746834,183.712753 120.785324,185.249603 
	C119.708321,185.998520 118.843513,186.522858 117.685333,187.076141 
	C116.903870,187.644089 116.415787,188.183090 115.927689,188.722092 
	C115.927689,188.722092 115.458183,188.879578 114.832977,188.878632 
	C113.142059,188.940186 112.076363,189.002686 111.010658,189.065186 
M115.525063,163.795273 
	C115.691650,164.440552 115.858231,165.085846 116.024818,165.731125 
	C117.620979,164.622314 119.217140,163.513489 120.813301,162.404678 
	C120.579254,162.048141 120.345215,161.691605 120.111168,161.335083 
	C118.769341,162.047089 117.427505,162.759109 115.525063,163.795273 
z"/>
  <path fill="#150F41" opacity="1.000000" stroke="none" d="
M89.033569,164.000610 
	C94.178932,165.493744 99.324287,166.986893 105.118752,168.314819 
	C106.511459,169.811600 107.807205,171.444901 107.895416,173.140991 
	C108.163055,178.287277 107.963509,183.457840 107.945938,188.618958 
	C107.511314,188.716934 107.076683,188.814926 105.947861,188.904587 
	C104.504860,188.949097 103.756050,189.001938 103.007240,189.054764 
	C103.007240,189.054764 102.545029,188.875122 102.212128,188.493851 
	C100.932808,187.758408 99.986397,187.404251 98.866600,186.817108 
	C98.129555,186.066757 97.565895,185.549393 96.936127,184.694611 
	C94.935921,183.228348 93.001823,182.099518 90.867340,180.639130 
	C90.122490,174.871933 89.578026,169.436279 89.033569,164.000610 
z"/>
  <path fill="#130D3C" opacity="1.000000" stroke="none" d="
M117.978706,187.047195 
	C118.843513,186.522858 119.708321,185.998520 121.164444,185.235336 
	C123.488495,184.808990 125.290695,184.846710 126.925728,184.342438 
	C127.790565,184.075714 128.364517,182.865860 129.404877,182.121078 
	C130.826767,182.435440 131.913574,182.710526 133.000381,182.985611 
	C135.219131,184.454727 137.437881,185.923859 139.821747,187.682724 
	C139.986847,187.972473 139.935165,188.360489 139.926697,188.555817 
	C139.918243,188.751129 139.454834,188.893784 139.230133,188.984894 
	C132.641159,189.018814 126.276909,188.961609 119.449722,188.991455 
	C118.986778,189.078476 118.543007,188.894882 118.303986,188.537003 
	C118.036217,187.801819 118.007462,187.424500 117.978706,187.047195 
z"/>
  <path fill="#231D52" opacity="1.000000" stroke="none" d="
M108.293900,188.700745 
	C107.963509,183.457840 108.163055,178.287277 107.895416,173.140991 
	C107.807205,171.444901 106.511459,169.811600 105.384399,168.072311 
	C102.552521,166.318344 100.104095,164.641663 97.655663,162.964981 
	C97.822975,162.671844 97.990288,162.378723 98.157608,162.085587 
	C102.647255,163.948563 107.136902,165.811554 111.547325,167.641647 
	C108.186623,173.378632 110.693085,180.714920 110.040985,188.180939 
	C109.582512,188.674759 109.112190,188.728638 108.293900,188.700745 
z"/>
  <path fill="#7A8B86" opacity="1.000000" stroke="none" d="
M81.378998,190.065521 
	C80.494736,190.085266 80.087120,190.073639 79.374115,190.063293 
	C78.516113,189.904449 77.963509,189.744324 77.578629,189.321777 
	C78.530205,188.950851 79.314049,188.842316 80.557068,188.773926 
	C87.018448,188.781448 93.020660,188.748856 98.994934,188.840378 
	C98.967003,188.964493 98.967773,189.218918 98.967773,189.218918 
	C93.263725,189.490662 87.559685,189.762405 81.378998,190.065521 
z"/>
  <path fill="#2F364E" opacity="1.000000" stroke="none" d="
M99.039986,187.050079 
	C99.986397,187.404251 100.932808,187.758408 101.975677,188.419235 
	C101.297203,188.852112 100.522263,188.978333 99.357544,189.161743 
	C98.967773,189.218918 98.967003,188.964493 98.977585,188.562714 
	C99.005440,187.790665 99.022713,187.420364 99.039986,187.050079 
z"/>
  <path fill="#7A8B86" opacity="1.000000" stroke="none" d="
M111.245552,189.286285 
	C112.076363,189.002686 113.142059,188.940186 114.600540,188.964005 
	C113.822365,189.202667 112.651405,189.355026 111.245552,189.286285 
z"/>
  <path fill="#2F364E" opacity="1.000000" stroke="none" d="
M117.685333,187.076141 
	C118.007462,187.424500 118.036217,187.801819 118.075653,188.462708 
	C117.603241,188.803467 117.120163,188.860657 116.282387,188.819977 
	C116.415787,188.183090 116.903870,187.644089 117.685333,187.076141 
z"/>
  <path fill="#7A8B86" opacity="1.000000" stroke="none" d="
M103.209702,189.267303 
	C103.756050,189.001938 104.504860,188.949097 105.621948,188.981964 
	C105.130882,189.205048 104.271523,189.342453 103.209702,189.267303 
z"/>
  <path fill="#150F41" opacity="1.000000" stroke="none" d="
M65.041214,189.228455 
	C64.581230,189.187286 64.121254,189.146118 63.080601,189.058258 
	C62.338596,188.957901 62.177258,188.904236 61.945030,188.515747 
	C57.939480,186.098694 54.004818,184.016434 49.893970,181.594269 
	C49.470757,174.489319 49.223721,167.724258 49.368202,160.971527 
	C55.166767,163.722672 61.285576,165.658371 65.673599,169.547073 
	C67.793648,171.425842 66.747597,176.971115 66.969185,180.865677 
	C67.119812,183.513123 66.982376,186.176926 66.651993,188.903625 
	C65.900566,189.058685 65.470886,189.143570 65.041214,189.228455 
z"/>
  <path fill="#150F41" opacity="1.000000" stroke="none" d="
M73.006790,189.181091 
	C71.916634,189.146988 70.826485,189.112885 69.381500,189.047333 
	C69.026672,189.015884 69.068840,188.839706 69.048302,188.382980 
	C69.016678,184.001755 69.263931,180.054733 68.924484,176.158844 
	C68.558441,171.957565 69.377548,168.488297 72.998764,166.003998 
	C73.001122,165.999893 73.008812,165.995926 73.340851,166.003082 
	C74.115768,166.013168 74.558655,166.016083 75.070351,166.325378 
	C77.580078,166.963501 80.020988,167.295227 82.729706,167.663345 
	C82.922417,165.958054 83.168785,163.777969 83.449455,161.294266 
	C85.264984,161.984314 86.600388,162.491867 87.949844,163.463837 
	C87.516823,169.710464 89.656624,175.944504 84.637306,181.040649 
	C82.859688,182.402710 81.428864,183.712860 79.999275,185.355515 
	C79.997864,186.131577 79.995201,186.575119 79.610687,187.011948 
	C77.798096,187.588303 76.367371,188.171371 74.936638,188.754440 
	C74.777954,188.810287 74.619263,188.866119 73.978287,188.987289 
	C73.332924,189.095459 73.169853,189.138275 73.006790,189.181091 
z"/>
  <path fill="#211C52" opacity="1.000000" stroke="none" d="
M50.070152,181.934174 
	C54.004818,184.016434 57.939480,186.098694 61.698494,188.601929 
	C61.359100,189.082214 61.195362,189.141510 61.031628,189.200821 
	C60.261429,189.130585 59.491234,189.060349 58.340820,188.915710 
	C55.904564,187.559219 53.848522,186.277145 51.420563,184.981110 
	C50.840328,184.422943 50.632019,183.878754 50.217743,182.888641 
	C50.031235,182.273193 50.050690,182.103683 50.070152,181.934174 
z"/>
  <path fill="#2F364E" opacity="1.000000" stroke="none" d="
M75.265900,188.867615 
	C76.367371,188.171371 77.798096,187.588303 79.624283,187.298019 
	C80.045799,187.971817 80.071846,188.352798 80.097900,188.733795 
	C79.314049,188.842316 78.530205,188.950851 77.356941,189.137100 
	C76.510071,189.136810 76.052620,189.058792 75.265900,188.867615 
z"/>
  <path fill="#7A8B86" opacity="1.000000" stroke="none" d="
M65.283585,189.417206 
	C65.470886,189.143570 65.900566,189.058685 67.000015,188.950378 
	C68.136139,188.897858 68.602493,188.868774 69.068840,188.839691 
	C69.068840,188.839706 69.026672,189.015884 68.974075,189.089569 
	C67.789627,189.310837 66.657784,189.458405 65.283585,189.417206 
z"/>
  <path fill="#7A8B86" opacity="1.000000" stroke="none" d="
M61.196167,189.363541 
	C61.195362,189.141510 61.359100,189.082214 61.769382,188.936737 
	C62.177258,188.904236 62.338596,188.957901 62.736782,189.106171 
	C62.435993,189.309296 61.898354,189.417786 61.196167,189.363541 
z"/>
  <path fill="#7A8B86" opacity="1.000000" stroke="none" d="
M73.116417,189.292526 
	C73.169853,189.138275 73.332924,189.095459 73.746567,189.087189 
	C73.997147,189.121735 73.664062,189.431992 73.664062,189.431992 
	C73.664062,189.431992 73.226044,189.403961 73.116417,189.292526 
z"/>
  <path fill="#150F41" opacity="1.000000" stroke="none" d="
M145.428925,188.097672 
	C141.277267,185.788300 137.497528,183.439484 133.181473,180.726257 
	C128.093079,174.854080 130.432785,168.384918 130.346344,162.303528 
	C130.335754,161.557358 132.730530,160.777023 134.003784,160.005280 
	C133.996948,159.998032 133.981277,159.989532 134.177460,160.214996 
	C134.931580,160.630600 135.489517,160.820724 136.266312,161.008652 
	C136.485168,161.006454 136.922867,161.002167 137.093597,161.299561 
	C140.234741,163.599228 143.264465,165.521072 146.145340,167.644836 
	C147.243057,168.454071 148.783249,169.728897 148.780212,170.787674 
	C148.763840,176.473862 148.324646,182.158829 148.031479,187.844208 
	C147.287933,187.915558 146.544403,187.986893 145.428925,188.097672 
z"/>
  <path fill="#211C51" opacity="1.000000" stroke="none" d="
M148.359467,187.895599 
	C148.324646,182.158829 148.763840,176.473862 148.780212,170.787674 
	C148.783249,169.728897 147.243057,168.454071 146.145340,167.644836 
	C143.264465,165.521072 140.234741,163.599228 137.475693,161.303345 
	C139.604538,161.895325 141.646408,162.583878 143.417114,163.701920 
	C149.811569,167.739304 151.399231,167.616287 157.618073,163.257584 
	C160.539307,161.210144 163.861435,159.734665 167.001877,158.000000 
	C167.642715,158.781967 168.283554,159.563919 168.969543,160.657883 
	C163.436646,163.626587 157.792664,166.159546 152.346420,169.063431 
	C151.452942,169.539825 151.112885,171.636490 151.062744,173.004318 
	C150.905289,177.300888 151.008163,181.606979 151.017227,186.364670 
	C150.245316,187.195633 149.466370,187.571320 148.359467,187.895599 
z"/>
  <path fill="#28225F" opacity="1.000000" stroke="none" d="
M134.010605,160.012527 
	C132.730530,160.777023 130.335754,161.557358 130.346344,162.303528 
	C130.432785,168.384918 128.093079,174.854080 132.830933,180.673035 
	C133.011108,181.429169 133.005508,181.874084 133.000153,182.652313 
	C131.913574,182.710526 130.826767,182.435440 129.097900,182.060150 
	C127.947182,181.628036 127.438507,181.296127 126.929832,180.964203 
	C129.510895,173.640793 131.479172,166.375824 126.140869,159.286484 
	C125.438599,158.353867 125.528076,156.825043 125.127319,155.039612 
	C125.003792,154.506851 125.001747,154.014709 125.403656,153.998077 
	C126.869598,152.451447 128.674576,151.002213 128.851929,149.375534 
	C129.296890,145.293991 129.005524,141.132172 129.261993,137.001602 
	C129.682907,137.000198 129.851334,136.999756 130.017746,137.467285 
	C130.014282,141.995956 130.129074,146.061142 129.972885,150.115906 
	C129.857437,153.113052 131.112381,154.317352 133.965591,154.334686 
	C133.949768,156.455582 133.980179,158.234055 134.010605,160.012527 
z"/>
  <path fill="#20B8F4" opacity="1.000000" stroke="none" d="
M109.008667,30.473663 
	C111.138054,31.711180 113.265923,33.254284 115.484482,35.195694 
	C116.052757,37.061657 116.530350,38.529324 116.591370,39.998009 
	C112.959167,41.323418 109.300125,42.061600 106.617546,44.090710 
	C100.491005,48.724831 94.842422,53.990826 88.656975,59.051090 
	C79.416794,66.936386 70.575195,74.836067 61.566086,82.539856 
	C60.089481,83.802513 57.875381,84.202713 56.001564,84.600693 
	C55.999382,83.130409 55.997776,82.060959 55.996170,80.991508 
	C55.997097,80.243782 55.998020,79.496063 56.382427,78.372574 
	C57.872543,77.743195 59.278427,77.837875 60.040428,77.183159 
	C69.764687,68.827965 79.412712,60.383625 89.045952,51.923054 
	C94.604248,47.041374 100.177277,42.171028 105.574623,37.115116 
	C107.033379,35.748634 107.875740,33.724140 109.001022,32.001678 
	C109.003067,31.594204 109.005112,31.186729 109.008667,30.473663 
z"/>
  <path fill="#1DBEF5" opacity="1.000000" stroke="none" d="
M108.634209,32.054012 
	C107.875740,33.724140 107.033379,35.748634 105.574623,37.115116 
	C100.177277,42.171028 94.604248,47.041374 89.045952,51.923054 
	C79.412712,60.383625 69.764687,68.827965 60.040428,77.183159 
	C59.278427,77.837875 57.872543,77.743195 56.383865,77.998711 
	C56.002373,75.959808 56.002922,73.919014 56.005302,71.441162 
	C60.329510,68.506012 65.139305,66.580040 68.877113,63.395748 
	C77.828773,55.769714 86.276718,47.552376 94.925461,39.570969 
	C95.291649,39.233036 95.635628,38.870701 95.984467,38.514362 
	C100.784531,33.611065 101.916321,33.020184 108.634209,32.054012 
z"/>
  <path fill="#1DBEF5" opacity="1.000000" stroke="none" d="
M95.910606,31.894821 
	C96.216713,31.927485 96.400314,32.084057 96.583923,32.240623 
	C96.476517,32.348755 96.369110,32.456890 96.261703,32.565025 
	C96.103844,32.382927 95.945976,32.200829 95.910606,31.894821 
z"/>
  <path fill="#211C58" opacity="1.000000" stroke="none" d="
M84.812408,10.667976 
	C83.872406,10.173122 83.241760,9.581824 82.611122,8.990527 
	C83.142914,8.711385 83.674713,8.432240 84.206505,8.153096 
	C84.511589,8.959241 84.816681,9.765386 84.812408,10.667976 
z"/>
  <path fill="#27215E" opacity="1.000000" stroke="none" d="
M34.695999,47.059937 
	C34.542065,47.624229 34.079987,48.249683 33.309570,48.935051 
	C33.463436,48.370342 33.925644,47.745724 34.695999,47.059937 
z"/>
  <path fill="#201A55" opacity="1.000000" stroke="none" d="
M30.086180,55.343636 
	C30.005003,54.555630 30.009293,54.109085 30.024284,53.327644 
	C35.201309,52.133259 38.658531,53.986362 39.984020,59.872826 
	C40.001774,60.663033 40.002193,60.830765 39.715481,60.845451 
	C37.285873,60.794067 35.143402,60.895725 33.000931,60.997383 
	C32.057835,59.226624 31.114740,57.455860 30.086180,55.343636 
z"/>
  <path fill="#26205D" opacity="1.000000" stroke="none" d="
M40.002617,60.998493 
	C40.002193,60.830765 40.001774,60.663033 40.000450,60.243607 
	C43.008381,60.656639 46.017223,61.321369 49.475273,62.325363 
	C49.892860,63.124809 49.861244,63.584991 49.520744,64.272522 
	C48.850376,69.874672 48.479221,75.248970 48.199787,80.628036 
	C48.194435,80.731018 49.271595,80.890236 49.908760,81.391998 
	C49.932522,82.506248 49.891209,83.251724 49.849899,83.997200 
	C48.790909,83.667892 47.731922,83.338577 46.404503,82.591797 
	C46.421665,78.611664 46.543983,75.026566 47.030102,71.491486 
	C47.811356,65.810173 45.490253,62.389919 40.002617,60.998493 
z"/>
  <path fill="#1BB1D6" opacity="1.000000" stroke="none" d="
M49.829628,64.045174 
	C49.861244,63.584991 49.892860,63.124809 49.861305,62.323154 
	C49.876656,61.539097 49.955185,61.096516 50.108505,60.324444 
	C50.459503,64.026093 50.735718,68.057220 51.010345,73.012344 
	C51.014053,78.293312 51.019348,82.650284 51.017303,87.340927 
	C51.012051,88.119812 51.014133,88.565010 50.808296,89.002853 
	C50.600376,88.995491 50.185875,88.959007 50.112885,89.029892 
	C50.039898,89.100769 49.836452,89.104538 49.836452,89.104538 
	C49.880295,87.683853 49.924133,86.263161 49.908936,84.419838 
	C49.891209,83.251724 49.932522,82.506248 49.970558,80.925911 
	C49.921398,74.742424 49.875511,69.393799 49.829628,64.045174 
z"/>
  <path fill="#1CBBF8" opacity="1.000000" stroke="none" d="
M51.024643,87.007256 
	C51.019348,82.650284 51.014053,78.293312 51.018761,73.472778 
	C57.358810,72.542938 53.843037,78.024612 55.741623,80.690353 
	C55.997776,82.060959 55.999382,83.130409 56.000748,85.000641 
	C56.001053,86.868225 56.001595,87.935028 56.000977,89.428749 
	C55.671616,92.232094 55.343414,94.608521 55.011017,96.534012 
	C55.001904,94.250870 54.892754,92.411644 55.015686,90.588066 
	C55.216888,87.603394 53.627724,86.780823 51.024643,87.007256 
z"/>
  <path fill="#2AAAF4" opacity="1.000000" stroke="none" d="
M117.007935,39.996986 
	C116.530350,38.529324 116.052757,37.061657 115.770889,35.373825 
	C119.422394,37.042233 122.878189,38.930813 126.657257,40.954639 
	C127.790779,41.693924 128.601028,42.297958 129.510284,43.372269 
	C126.043434,46.426991 122.398743,48.910782 118.934090,51.624420 
	C115.525246,54.294338 112.299004,57.197399 108.903229,59.654510 
	C107.541664,58.873806 106.269501,58.436752 104.784332,57.777599 
	C106.891129,54.618935 109.031830,51.513920 111.586342,48.798138 
	C113.698853,46.552265 116.475647,44.937702 118.635475,42.728065 
	C120.801041,40.512554 118.950813,40.088432 117.007935,39.996986 
z"/>
  <path fill="#1C1751" opacity="1.000000" stroke="none" d="
M170.012268,80.549545 
	C169.020569,83.106010 168.021347,85.193802 166.702240,87.785683 
	C163.921494,90.194481 161.460617,92.099182 158.999878,94.001938 
	C159.000000,94.000000 159.003830,94.000000 158.611725,94.001663 
	C156.194946,94.331894 154.170258,94.660454 152.083481,94.607872 
	C152.288589,92.509819 152.555786,90.792915 152.872620,88.626602 
	C152.845703,85.775986 152.769165,83.374771 152.732285,80.510284 
	C152.684128,75.027916 152.596313,70.008827 152.590607,64.695450 
	C152.654373,63.995167 152.636002,63.589180 152.661835,62.934639 
	C152.510025,62.421867 152.314041,62.157654 152.077789,61.565315 
	C151.695801,60.481369 151.354050,59.725552 150.975632,58.716614 
	C150.890213,58.300102 150.841461,58.136711 150.801498,57.723526 
	C150.635391,57.167355 150.378220,56.966091 150.037521,56.557823 
	C150.025757,55.830162 150.015228,55.414623 150.004700,54.999081 
	C150.752258,55.000267 151.499802,55.001453 152.620987,55.001472 
	C157.175079,57.668163 161.156387,60.756409 165.602753,62.862968 
	C168.816162,64.385391 170.274292,66.076744 170.045059,69.603348 
	C169.818954,73.082031 170.001495,76.587280 170.012268,80.549545 
M163.930298,84.394905 
	C164.472260,83.767868 165.014236,83.140831 165.556213,82.513802 
	C164.314468,82.053978 163.072723,81.594147 161.830994,81.134315 
	C161.667953,81.516174 161.504913,81.898026 161.341873,82.279884 
	C162.001160,82.895126 162.660431,83.510368 163.930298,84.394905 
z"/>
  <path fill="#3598F5" opacity="1.000000" stroke="none" d="
M139.966171,49.131866 
	C141.547501,49.867119 143.128815,50.602371 144.666672,51.886623 
	C140.627106,55.578758 136.504990,58.576885 132.671982,61.907700 
	C129.162872,64.957054 125.824883,68.237556 122.699699,71.678009 
	C121.409798,73.098022 120.872253,75.201454 119.653000,76.904037 
	C119.050438,75.516609 118.898293,74.182930 118.489754,72.933067 
	C118.153961,71.905792 117.513718,70.978020 116.955109,69.664886 
	C116.399155,68.163361 115.896507,67.003105 115.356361,65.756264 
	C116.618408,65.172432 117.929138,64.957657 118.612450,64.186760 
	C123.222588,58.985695 127.628693,53.602554 132.286896,48.446442 
	C133.106766,47.538933 134.801682,47.421955 136.092484,46.939899 
	C136.092484,46.939899 136.028015,46.973324 136.156189,47.163750 
	C136.561798,47.558552 136.839233,47.762924 137.116669,47.967300 
	C137.116669,47.967297 137.038773,47.941185 137.088486,48.219666 
	C138.080856,48.709385 139.023514,48.920624 139.966171,49.131866 
z"/>
  <path fill="#3B8FF4" opacity="1.000000" stroke="none" d="
M119.992523,76.994049 
	C120.872253,75.201454 121.409798,73.098022 122.699699,71.678009 
	C125.824883,68.237556 129.162872,64.957054 132.671982,61.907700 
	C136.504990,58.576885 140.627106,55.578758 144.841949,52.165375 
	C146.498383,52.859695 147.936035,53.824261 149.689209,54.893951 
	C150.015228,55.414623 150.025757,55.830162 150.115540,56.771568 
	C150.337723,57.572601 150.537018,57.797894 150.792694,57.973316 
	C150.841461,58.136711 150.890213,58.300102 150.965591,59.095596 
	C150.993439,60.485802 150.994629,61.243908 150.631836,61.985245 
	C147.585770,60.602962 145.110077,59.415314 142.315613,62.174183 
	C136.465866,67.949387 130.308365,73.412056 124.423386,79.152885 
	C122.649948,80.882889 121.418243,80.743782 119.999939,78.666222 
	C119.997025,77.885902 119.994774,77.439980 119.992523,76.994049 
z"/>
  <path fill="#2FA0F4" opacity="1.000000" stroke="none" d="
M135.917511,46.653839 
	C134.801682,47.421955 133.106766,47.538933 132.286896,48.446442 
	C127.628693,53.602554 123.222588,58.985695 118.612450,64.186760 
	C117.929138,64.957657 116.618408,65.172432 115.356361,65.756264 
	C115.896507,67.003105 116.399155,68.163361 116.952393,69.913147 
	C117.002991,70.502663 116.999084,70.999390 116.665955,70.927078 
	C115.132027,70.226410 113.931229,69.598045 112.427979,68.846581 
	C110.733025,66.867020 109.340523,65.010559 107.965363,62.807163 
	C108.319344,61.639538 108.655991,60.818851 108.992645,59.998161 
	C112.299004,57.197399 115.525246,54.294338 118.934090,51.624420 
	C122.398743,48.910782 126.043434,46.426991 129.775665,43.541939 
	C131.875549,44.283482 133.809052,45.325630 135.917511,46.653839 
z"/>
  <path fill="#2FA0F4" opacity="1.000000" stroke="none" d="
M139.692764,48.960808 
	C139.023514,48.920624 138.080856,48.709385 137.105347,48.182205 
	C137.854767,48.174091 138.637070,48.481922 139.692764,48.960808 
z"/>
  <path fill="#2FA0F4" opacity="1.000000" stroke="none" d="
M137.020935,47.714325 
	C136.839233,47.762924 136.561798,47.558552 136.154556,47.127472 
	C136.324905,47.087627 136.625046,47.274490 137.020935,47.714325 
z"/>
  <path fill="#1C1750" opacity="1.000000" stroke="none" d="
M39.715481,60.845451 
	C45.490253,62.389919 47.811356,65.810173 47.030102,71.491486 
	C46.543983,75.026566 46.421665,78.611664 46.066513,82.585907 
	C45.996952,82.997490 45.511280,83.013260 45.268829,83.023735 
	C42.931622,82.363892 40.836864,81.693573 38.370441,81.012482 
	C35.896500,79.366531 33.794220,77.731346 31.346684,76.046707 
	C29.820988,70.994568 29.096060,66.038902 32.748894,61.253235 
	C35.143402,60.895725 37.285873,60.794067 39.715481,60.845451 
z"/>
  <path fill="#1C1750" opacity="1.000000" stroke="none" d="
M24.671684,55.077492 
	C24.977718,55.021492 24.996307,55.504879 25.003372,55.746529 
	C24.530336,56.301559 24.050238,56.614937 23.275455,56.961075 
	C23.442398,56.373722 23.904024,55.753605 24.671684,55.077492 
z"/>
  <path fill="#211C51" opacity="1.000000" stroke="none" d="
M153.854614,186.630051 
	C153.959305,186.731995 153.498596,186.887833 153.259079,186.846863 
	C153.196884,186.513138 153.440338,186.420532 153.854614,186.630051 
z"/>
  <path fill="#161246" opacity="1.000000" stroke="none" d="
M160.997375,128.999054 
	C163.838791,131.512909 166.682831,134.027725 169.770447,136.772705 
	C169.562805,142.526306 169.111588,148.049728 167.982437,153.731964 
	C161.877991,151.257797 156.451492,148.624802 151.020630,145.524353 
	C151.010254,138.704300 151.004211,132.351685 151.228210,125.819679 
	C152.012665,125.098755 152.567062,124.557228 153.121460,124.015701 
	C153.574173,124.270607 154.026871,124.525513 154.892334,125.178154 
	C157.204208,126.718742 159.103317,127.861595 161.002441,129.004440 
	C161.002441,129.004440 161.000000,129.000000 160.997375,128.999054 
z"/>
  <path fill="#141043" opacity="1.000000" stroke="none" d="
M134.003784,160.005280 
	C133.980179,158.234055 133.949768,156.455582 133.958038,154.339020 
	C133.996719,154.000916 133.985550,154.010727 134.321289,154.004745 
	C135.441757,153.664185 136.226501,153.329605 137.006470,152.996613 
	C137.001724,152.998199 136.999084,153.006805 137.355469,152.956253 
	C139.019943,152.236526 140.365112,151.630417 141.629684,150.887177 
	C146.938049,147.767273 152.112717,146.494644 157.653519,150.681351 
	C160.489761,152.824448 163.868607,154.249451 167.002228,155.998993 
	C167.005264,156.443665 167.008301,156.888351 167.006622,157.666504 
	C163.861435,159.734665 160.539307,161.210144 157.618073,163.257584 
	C151.399231,167.616287 149.811569,167.739304 143.417114,163.701920 
	C141.646408,162.583878 139.604538,161.895325 137.304962,161.005951 
	C136.922867,161.002167 136.485168,161.006454 136.071045,160.780029 
	C135.098389,160.365585 134.539825,160.177551 133.981277,159.989532 
	C133.981277,159.989532 133.996948,159.998032 134.003784,160.005280 
z"/>
  <path fill="#211C51" opacity="1.000000" stroke="none" d="
M167.223328,155.810974 
	C163.868607,154.249451 160.489761,152.824448 157.653519,150.681351 
	C152.112717,146.494644 146.938049,147.767273 141.629684,150.887177 
	C140.365112,151.630417 139.019943,152.236526 137.408417,152.608948 
	C141.062881,150.205933 145.020767,148.099686 149.319656,145.995575 
	C150.115433,145.995743 150.570206,145.993790 151.024979,145.991821 
	C156.451492,148.624802 161.877991,151.257797 167.653259,153.947830 
	C167.816147,154.544235 167.630295,155.083603 167.223328,155.810974 
z"/>
  <path fill="#2A245E" opacity="1.000000" stroke="none" d="
M49.893967,181.594284 
	C50.050690,182.103683 50.031235,182.273193 49.991711,182.697327 
	C48.041721,182.658554 46.111801,182.365173 44.462406,182.114441 
	C47.078365,174.890320 46.006535,167.886017 45.445194,160.929199 
	C45.418407,160.597214 44.374901,160.347290 43.396667,160.037018 
	C43.018215,158.239700 43.047970,156.464508 43.038841,154.344666 
	C42.999958,154.000000 43.000004,154.000000 43.395844,153.984711 
	C49.401398,152.607162 46.042896,148.031464 47.249107,145.004425 
	C47.493958,145.005203 47.983696,145.012955 47.986233,145.441315 
	C48.657146,148.583023 49.325523,151.296402 50.030411,154.297485 
	C50.373993,155.055756 50.681057,155.526276 50.983597,156.330627 
	C50.981873,157.109543 50.984673,157.554657 50.713215,158.155304 
	C49.951534,159.193649 49.464111,160.076416 48.976685,160.959198 
	C49.223721,167.724258 49.470757,174.489319 49.893967,181.594284 
z"/>
  <path fill="#2A245E" opacity="1.000000" stroke="none" d="
M41.279228,160.997314 
	C41.462765,160.714539 41.940975,160.383804 42.719582,160.021637 
	C42.537952,160.309906 42.055931,160.629639 41.279228,160.997314 
z"/>
  <path fill="#252059" opacity="1.000000" stroke="none" d="
M22.445667,148.007843 
	C28.122530,141.892059 25.448484,134.109329 26.251320,126.352493 
	C27.007790,125.513634 27.506992,125.259087 28.001495,125.431030 
	C27.805145,126.999062 27.559464,128.134552 27.430605,129.283142 
	C26.591829,136.759781 25.441919,144.323853 34.430477,148.244354 
	C35.487095,148.705215 36.154793,150.057770 37.001369,150.998535 
	C36.999950,151.000122 36.995861,151.006104 36.995861,151.006104 
	C32.294224,150.006760 27.592585,149.007416 22.445667,148.007843 
z"/>
  <path fill="#252059" opacity="1.000000" stroke="none" d="
M13.246243,152.964386 
	C13.717491,149.503784 16.602669,149.343674 19.737902,149.001434 
	C17.935518,150.309830 15.772256,151.620224 13.246243,152.964386 
z"/>
  <path fill="#252059" opacity="1.000000" stroke="none" d="
M40.974106,153.018127 
	C39.762291,152.542847 38.550476,152.067566 37.167259,151.299194 
	C36.995861,151.006104 36.999950,151.000122 37.346451,151.003387 
	C38.796963,151.663345 39.900974,152.320023 41.000599,152.988770 
	C40.996212,153.000824 40.974110,153.018127 40.974106,153.018127 
z"/>
  <path fill="#2A245E" opacity="1.000000" stroke="none" d="
M42.998184,154.001831 
	C42.446743,153.827225 41.897072,153.650787 41.160755,153.246246 
	C40.974110,153.018127 40.996212,153.000824 41.290970,153.028137 
	C42.057156,153.370300 42.528580,153.685150 43.000004,154.000000 
	C43.000004,154.000000 42.999958,154.000000 42.998184,154.001831 
z"/>
  <path fill="#252059" opacity="1.000000" stroke="none" d="
M21.164879,148.892456 
	C21.096569,148.710022 21.305874,148.453827 21.789951,148.121735 
	C21.799273,148.256027 21.591862,148.513657 21.164879,148.892456 
z"/>
  <path fill="#231E57" opacity="1.000000" stroke="none" d="
M20.342117,121.065010 
	C18.159201,118.988953 16.297966,116.992645 14.436731,114.996338 
	C14.612724,114.702225 14.788716,114.408112 14.964708,114.113998 
	C18.377825,115.725342 21.790941,117.336678 25.537483,119.307205 
	C25.265024,121.414398 24.659134,123.162415 24.053246,124.910423 
	C21.170832,126.325096 18.288414,127.739769 15.405998,129.154434 
	C15.144723,128.771179 14.883448,128.387909 14.622172,128.004654 
	C16.423401,126.716118 18.351728,125.564377 19.960974,124.069214 
	C20.572802,123.500755 20.451153,122.142853 20.342117,121.065010 
z"/>
  <path fill="#2C2664" opacity="1.000000" stroke="none" d="
M24.335800,124.969376 
	C24.659134,123.162415 25.265024,121.414398 25.902092,119.310234 
	C25.933271,118.954079 25.958279,118.459290 25.966570,118.211273 
	C26.419104,117.978294 26.863348,117.993324 27.727427,118.340454 
	C29.098375,119.113014 30.049486,119.553482 30.993069,120.234314 
	C30.985542,120.474686 30.962358,120.955101 30.724140,121.217072 
	C30.319773,122.640366 30.153622,123.801697 29.657166,124.967163 
	C28.886639,124.982391 28.446419,124.993469 28.006195,125.004547 
	C27.506992,125.259087 27.007790,125.513634 26.253613,125.884949 
	C25.538544,125.677269 25.078449,125.352798 24.335800,124.969376 
z"/>
  <path fill="#1A154B" opacity="1.000000" stroke="none" d="
M31.000599,119.993950 
	C30.049486,119.553482 29.098375,119.113014 28.060474,118.347343 
	C27.956303,113.109215 27.761082,108.187187 28.011864,103.287979 
	C28.107887,101.412102 29.223167,99.588402 29.936146,97.369553 
	C30.846241,96.824516 31.694178,96.650864 32.771511,96.242081 
	C37.070759,94.333656 41.140610,92.660370 45.613335,90.980850 
	C46.016209,90.974617 46.012020,90.992195 46.011040,91.427834 
	C46.191891,93.640785 46.228363,95.447563 46.581562,97.190140 
	C47.880966,103.601006 47.132317,109.234406 40.647991,113.051117 
	C37.194374,115.399078 34.097488,117.696518 31.000599,119.993950 
z"/>
  <path fill="#241F59" opacity="1.000000" stroke="none" d="
M41.004719,113.000587 
	C47.132317,109.234406 47.880966,103.601006 46.581562,97.190140 
	C46.228363,95.447563 46.191891,93.640785 46.017616,91.423615 
	C46.465111,90.989212 46.905041,90.994667 47.674122,91.467461 
	C48.602814,97.624809 49.202358,103.314819 49.886726,109.345444 
	C50.336479,110.771133 50.701412,111.856201 50.607964,112.958359 
	C47.099342,112.982346 44.049103,112.989258 40.999363,112.998123 
	C40.999859,113.000069 41.004719,113.000587 41.004719,113.000587 
z"/>
  <path fill="#1A1550" opacity="1.000000" stroke="none" d="
M49.801903,109.004829 
	C49.202358,103.314819 48.602814,97.624809 48.004333,91.470383 
	C48.477066,90.482765 48.948738,89.959557 49.628433,89.270447 
	C49.836452,89.104538 50.039898,89.100769 50.069614,89.469101 
	C50.146030,91.893456 50.192726,93.949471 50.158543,96.327255 
	C50.109421,97.088028 50.141178,97.527039 50.101250,98.340767 
	C50.069901,99.474953 50.110237,100.234428 50.084976,101.434761 
	C49.946888,104.252029 49.874397,106.628426 49.801903,109.004829 
z"/>
  <path fill="#241E58" opacity="1.000000" stroke="none" d="
M176.835388,112.703964 
	C173.641068,113.006470 170.277557,113.006577 166.546570,112.653000 
	C167.153107,110.406052 168.733673,108.589020 168.983047,106.604691 
	C169.631485,101.444786 169.695312,96.211411 169.992386,91.007355 
	C170.433899,91.002831 170.875412,90.998306 171.647614,90.989578 
	C171.657181,94.558998 171.183685,98.127083 171.053177,101.707664 
	C170.887024,106.266724 172.841965,109.861809 176.835388,112.703964 
z"/>
  <path fill="#1A154B" opacity="1.000000" stroke="none" d="
M169.740479,90.885742 
	C169.695312,96.211411 169.631485,101.444786 168.983047,106.604691 
	C168.733673,108.589020 167.153107,110.406052 166.088318,112.653061 
	C165.997543,113.006805 166.000320,112.999466 165.608917,112.999039 
	C163.144577,114.334724 161.071640,115.670845 158.998688,117.006966 
	C158.998688,117.006966 159.000000,116.999695 158.641296,117.006569 
	C156.506546,117.702049 154.730515,118.390656 152.598419,118.958206 
	C151.829193,116.898819 151.416016,114.960510 151.061020,112.617455 
	C151.346542,109.488869 151.573898,106.765030 151.866241,103.605362 
	C152.017242,101.119965 152.103271,99.070404 152.568848,97.016357 
	C154.966888,96.007927 156.985352,95.003960 159.003830,94.000000 
	C159.003830,94.000000 159.000000,94.000000 159.382782,93.998627 
	C162.512115,92.658394 165.258682,91.319542 168.005234,89.980682 
	C168.499680,90.241829 168.994141,90.502975 169.740479,90.885742 
z"/>
  <path fill="#221D57" opacity="1.000000" stroke="none" d="
M167.968903,89.693344 
	C165.258682,91.319542 162.512115,92.658394 159.382660,94.000565 
	C161.460617,92.099182 163.921494,90.194481 166.693329,88.144699 
	C167.313736,88.468399 167.623154,88.937195 167.968903,89.693344 
z"/>
  <path fill="#2A2666" opacity="1.000000" stroke="none" d="
M151.002853,113.022186 
	C151.416016,114.960510 151.829193,116.898819 152.614105,119.282211 
	C153.001923,120.161896 153.018005,120.596519 153.034103,121.031136 
	C153.041016,121.777657 153.047928,122.524185 153.088135,123.643204 
	C152.567062,124.557228 152.012665,125.098755 150.897446,125.817596 
	C149.895767,125.992523 149.454895,125.990143 148.889175,125.780777 
	C148.565460,125.312813 148.320541,125.106522 147.985046,124.668427 
	C147.617218,123.918900 147.293884,123.455879 146.930725,122.676567 
	C146.270721,121.266937 145.650543,120.173599 145.187408,118.785324 
	C147.230576,116.667656 149.116714,114.844925 151.002853,113.022186 
z"/>
  <path fill="#241E58" opacity="1.000000" stroke="none" d="
M159.346924,116.956711 
	C161.071640,115.670845 163.144577,114.334724 165.612549,112.998535 
	C163.903412,114.301125 161.799286,115.603790 159.346924,116.956711 
z"/>
  <path fill="#201B53" opacity="1.000000" stroke="none" d="
M160.946747,128.647446 
	C159.103317,127.861595 157.204208,126.718742 155.126740,125.290253 
	C156.929260,126.099892 158.910156,127.195168 160.946747,128.647446 
z"/>
  <path fill="#241E58" opacity="1.000000" stroke="none" d="
M153.366943,120.968834 
	C153.018005,120.596519 153.001923,120.161896 152.970154,119.403275 
	C154.730515,118.390656 156.506546,117.702049 158.644867,117.006416 
	C157.238037,118.301773 155.468918,119.604149 153.366943,120.968834 
z"/>
  <path fill="#2A2460" opacity="1.000000" stroke="none" d="
M84.984100,180.988708 
	C89.656624,175.944504 87.516823,169.710464 87.922928,163.121033 
	C86.577980,159.249222 85.273994,156.184616 84.193428,152.988159 
	C84.618523,152.583542 84.820198,152.310791 85.340736,151.976746 
	C86.731087,151.207550 87.802582,150.499619 88.910126,150.177307 
	C90.294930,151.713684 91.643677,152.864456 92.996979,154.009613 
	C93.001526,154.003998 92.986359,154.000397 92.986359,154.000397 
	C91.662613,157.075348 90.338867,160.150299 89.024353,163.612946 
	C89.578026,169.436279 90.122490,174.871933 90.659622,180.867874 
	C90.082527,181.643097 89.512764,181.858047 88.607330,182.113312 
	C87.182556,182.429749 86.093452,182.705902 85.003586,182.649963 
	C84.996590,181.874817 84.990341,181.431763 84.984100,180.988708 
z"/>
  <path fill="#211C53" opacity="1.000000" stroke="none" d="
M125.001747,154.014709 
	C125.001747,154.014709 125.003792,154.506851 125.001587,154.752899 
	C122.118515,153.509918 119.072853,152.267761 116.392433,150.478439 
	C111.427452,147.164062 106.766563,147.078369 101.736862,150.388016 
	C99.324318,151.975525 96.417168,152.811386 93.360184,153.994019 
	C92.986359,154.000397 93.001526,154.003998 93.146927,153.694275 
	C94.699623,152.333023 96.035187,151.163834 97.528458,150.253296 
	C101.161385,148.038101 104.867516,145.942963 108.546326,143.798218 
	C111.177223,145.240234 114.793472,147.076233 118.253944,149.169724 
	C120.615814,150.598587 122.760147,152.387039 125.001747,154.014709 
z"/>
  <path fill="#1F1A50" opacity="1.000000" stroke="none" d="
M126.587639,181.026215 
	C127.438507,181.296127 127.947182,181.628036 128.762817,182.020874 
	C128.364517,182.865860 127.790565,184.075714 126.925728,184.342438 
	C125.290695,184.846710 123.488495,184.808990 121.376648,185.010757 
	C122.746834,183.712753 124.496140,182.400497 126.587639,181.026215 
z"/>
  <path fill="#231D52" opacity="1.000000" stroke="none" d="
M115.805367,163.633209 
	C117.427505,162.759109 118.769341,162.047089 120.111168,161.335083 
	C120.345215,161.691605 120.579254,162.048141 120.813301,162.404678 
	C119.217140,163.513489 117.620979,164.622314 116.024818,165.731125 
	C115.858231,165.085846 115.691650,164.440552 115.805367,163.633209 
z"/>
  <path fill="#130D3B" opacity="1.000000" stroke="none" d="
M85.004349,182.982056 
	C86.093452,182.705902 87.182556,182.429749 88.640251,182.451385 
	C91.673309,183.510117 94.337769,184.271072 97.002228,185.032043 
	C97.565895,185.549393 98.129555,186.066757 98.866600,186.817108 
	C99.022713,187.420364 99.005440,187.790665 99.005524,188.438599 
	C93.020660,188.748856 87.018448,188.781448 80.557068,188.773926 
	C80.071846,188.352798 80.045799,187.971817 80.006149,187.304749 
	C79.995201,186.575119 79.997864,186.131577 80.353951,185.339172 
	C82.139702,184.320892 83.572021,183.651474 85.004349,182.982056 
z"/>
  <path fill="#1E194F" opacity="1.000000" stroke="none" d="
M96.936119,184.694611 
	C94.337769,184.271072 91.673309,183.510117 88.975922,182.411072 
	C89.512764,181.858047 90.082527,181.643097 90.860016,181.199402 
	C93.001823,182.099518 94.935921,183.228348 96.936119,184.694611 
z"/>
  <path fill="#221C51" opacity="1.000000" stroke="none" d="
M49.368202,160.971527 
	C49.464111,160.076416 49.951534,159.193649 51.061710,158.207642 
	C53.236088,159.029312 54.792625,159.946091 56.338432,160.880615 
	C61.464207,163.979477 66.211548,168.301193 72.996414,166.008118 
	C69.377548,168.488297 68.558441,171.957565 68.924484,176.158844 
	C69.263931,180.054733 69.016678,184.001755 69.048302,188.382965 
	C68.602493,188.868774 68.136139,188.897858 67.321777,188.880188 
	C66.982376,186.176926 67.119812,183.513123 66.969185,180.865677 
	C66.747597,176.971115 67.793648,171.425842 65.673599,169.547073 
	C61.285576,165.658371 55.166767,163.722672 49.368202,160.971527 
z"/>
  <path fill="#151043" opacity="1.000000" stroke="none" d="
M72.998764,166.003998 
	C66.211548,168.301193 61.464207,163.979477 56.338432,160.880615 
	C54.792625,159.946091 53.236088,159.029312 51.335972,158.052094 
	C50.984673,157.554657 50.981873,157.109543 51.332287,156.279388 
	C54.415981,154.600830 57.146461,153.307343 60.026947,152.330658 
	C64.982864,160.288681 71.243408,161.125778 78.463211,155.044632 
	C79.867332,154.630692 80.919128,154.217514 82.247787,153.798126 
	C83.006447,153.567932 83.488228,153.343979 83.970009,153.120010 
	C85.273994,156.184616 86.577980,159.249222 87.908875,162.656616 
	C86.600388,162.491867 85.264984,161.984314 83.449455,161.294266 
	C83.168785,163.777969 82.922417,165.958054 82.729706,167.663345 
	C80.020988,167.295227 77.580078,166.963501 75.280487,166.069839 
	C77.073700,164.318405 78.725586,163.128906 80.377472,161.939407 
	C79.993912,161.483368 79.610344,161.027328 79.226776,160.571304 
	C77.154121,162.379501 75.081467,164.187714 73.008812,165.995926 
	C73.008812,165.995926 73.001122,165.999893 72.998764,166.003998 
z"/>
  <path fill="#221C51" opacity="1.000000" stroke="none" d="
M73.340851,166.003082 
	C75.081467,164.187714 77.154121,162.379501 79.226776,160.571304 
	C79.610344,161.027328 79.993912,161.483368 80.377472,161.939407 
	C78.725586,163.128906 77.073700,164.318405 75.211670,165.763458 
	C74.558655,166.016083 74.115768,166.013168 73.340851,166.003082 
z"/>
  <path fill="#1E194F" opacity="1.000000" stroke="none" d="
M85.003586,182.649963 
	C83.572021,183.651474 82.139702,184.320892 80.352707,185.006653 
	C81.428864,183.712860 82.859688,182.402710 84.637306,181.040649 
	C84.990341,181.431763 84.996590,181.874817 85.003586,182.649963 
z"/>
  <path fill="#28225F" opacity="1.000000" stroke="none" d="
M134.177460,160.214996 
	C134.539825,160.177551 135.098389,160.365585 135.852203,160.782227 
	C135.489517,160.820724 134.931580,160.630600 134.177460,160.214996 
z"/>
  <path fill="#161246" opacity="1.000000" stroke="none" d="
M125.403656,153.998077 
	C122.760147,152.387039 120.615814,150.598587 118.253944,149.169724 
	C114.793472,147.076233 111.177223,145.240234 108.546326,143.798218 
	C104.867516,145.942963 101.161385,148.038101 97.528458,150.253296 
	C96.035187,151.163834 94.699623,152.333023 93.142372,153.699890 
	C91.643677,152.864456 90.294930,151.713684 89.031158,149.952728 
	C89.409172,149.175430 89.702202,149.008347 90.315247,148.799850 
	C91.772095,147.847443 92.908920,146.936417 94.405075,145.988892 
	C98.843185,143.905624 102.921959,141.858856 107.334091,139.746689 
	C113.107231,136.759033 118.547005,133.836777 124.162445,131.233582 
	C125.927505,133.341614 130.008484,132.994919 129.009476,137.002548 
	C129.005524,141.132172 129.296890,145.293991 128.851929,149.375534 
	C128.674576,151.002213 126.869598,152.451447 125.403656,153.998077 
z"/>
  <path fill="#161246" opacity="1.000000" stroke="none" d="
M148.029556,124.954941 
	C148.320541,125.106522 148.565460,125.312813 148.882858,126.250526 
	C148.993805,133.282654 148.986221,139.638046 148.978653,145.993439 
	C145.020767,148.099686 141.062881,150.205933 137.052032,152.659485 
	C136.999084,153.006805 137.001724,152.998199 136.671463,153.005524 
	C135.555984,153.345459 134.770767,153.678101 133.985550,154.010742 
	C133.985550,154.010727 133.996719,154.000916 134.004272,153.996597 
	C131.112381,154.317352 129.857437,153.113052 129.972885,150.115906 
	C130.129074,146.061142 130.014282,141.995956 130.257507,137.228912 
	C132.668365,134.013092 134.837479,131.503571 137.003021,128.997162 
	C136.999451,129.000275 136.993347,129.005081 137.380096,129.003525 
	C141.187744,127.652954 144.608658,126.303947 148.029556,124.954941 
z"/>
  <path fill="#221E59" opacity="1.000000" stroke="none" d="
M137.006592,128.994049 
	C134.837479,131.503571 132.668365,134.013092 130.259491,136.760956 
	C129.851334,136.999756 129.682907,137.000198 129.261993,137.001602 
	C130.008484,132.994919 125.927505,133.341614 124.281082,130.935730 
	C125.158363,129.934387 126.092659,129.549957 127.092598,129.508179 
	C128.873947,130.264145 130.624924,131.105789 132.295227,130.968155 
	C133.908951,130.835205 135.439499,129.692947 137.006592,128.994049 
z"/>
  <path fill="#25B0F5" opacity="1.000000" stroke="none" d="
M116.591370,39.998009 
	C118.950813,40.088432 120.801041,40.512554 118.635475,42.728065 
	C116.475647,44.937702 113.698853,46.552265 111.586342,48.798138 
	C109.031830,51.513920 106.891129,54.618935 104.708466,58.108349 
	C103.896912,59.105526 102.948235,59.549854 101.797226,59.774193 
	C100.730759,59.702942 99.866615,59.851681 98.756317,60.041756 
	C98.673668,61.342258 98.837158,62.601421 98.621613,63.938564 
	C91.848457,64.881020 89.630905,69.728424 87.595016,74.754456 
	C83.335480,72.849411 85.091454,76.819244 83.647621,78.053909 
	C78.286407,81.477524 73.064339,84.580101 68.341599,88.314194 
	C64.620308,91.256477 61.530056,94.992912 58.128937,98.345596 
	C56.059879,100.385170 55.036655,99.796692 55.000423,97.000343 
	C55.002804,96.996887 55.015213,96.984947 55.015213,96.984947 
	C55.343414,94.608521 55.671616,92.232094 56.413177,89.428123 
	C58.981342,88.167732 61.582638,87.840630 63.206833,86.406731 
	C67.982559,82.190598 72.349594,77.513756 76.918312,73.060036 
	C79.500710,70.542633 81.794655,67.343086 84.892723,65.845551 
	C88.238213,64.228424 89.412071,62.363052 88.999695,59.000153 
	C94.842422,53.990826 100.491005,48.724831 106.617546,44.090710 
	C109.300125,42.061600 112.959167,41.323418 116.591370,39.998009 
z"/>
  <path fill="#22B5F4" opacity="1.000000" stroke="none" d="
M88.656975,59.051094 
	C89.412071,62.363052 88.238213,64.228424 84.892723,65.845551 
	C81.794655,67.343086 79.500710,70.542633 76.918312,73.060036 
	C72.349594,77.513756 67.982559,82.190598 63.206833,86.406731 
	C61.582638,87.840630 58.981342,88.167732 56.414333,89.001205 
	C56.001595,87.935028 56.001053,86.868225 56.001324,85.401474 
	C57.875381,84.202713 60.089481,83.802513 61.566086,82.539856 
	C70.575195,74.836067 79.416794,66.936386 88.656975,59.051094 
z"/>
  <path fill="#1A1654" opacity="1.000000" stroke="none" d="
M49.520744,64.272522 
	C49.875511,69.393799 49.921398,74.742424 49.905487,80.557129 
	C49.271595,80.890236 48.194435,80.731018 48.199787,80.628036 
	C48.479221,75.248970 48.850376,69.874672 49.520744,64.272522 
z"/>
  <path fill="#25B0F5" opacity="1.000000" stroke="none" d="
M50.150574,100.993896 
	C50.110237,100.234428 50.069901,99.474953 50.277809,98.210426 
	C50.739071,97.496864 50.901756,97.254562 51.264160,96.687683 
	C51.348213,93.934677 51.182217,91.472450 51.016220,89.010216 
	C51.014133,88.565010 51.012051,88.119812 51.017303,87.340927 
	C53.627724,86.780823 55.216888,87.603394 55.015686,90.588066 
	C54.892754,92.411644 55.001904,94.250870 55.011017,96.534012 
	C55.015213,96.984947 55.002804,96.996887 54.747208,97.294464 
	C54.132309,99.844284 53.773010,102.096519 53.388721,104.505409 
	C52.023018,103.024414 51.086796,102.009155 50.150574,100.993896 
z"/>
  <path fill="#1CBBF8" opacity="1.000000" stroke="none" d="
M50.808296,89.002853 
	C51.182217,91.472450 51.348213,93.934677 51.169998,96.499283 
	C50.680603,96.353493 50.485149,96.154770 50.239422,96.005493 
	C50.192726,93.949471 50.146030,91.893456 50.142601,89.398224 
	C50.185875,88.959007 50.600376,88.995491 50.808296,89.002853 
z"/>
  <path fill="#2BA5EB" opacity="1.000000" stroke="none" d="
M99.000656,63.860588 
	C98.837158,62.601421 98.673668,61.342258 99.130920,60.041698 
	C100.500969,59.998268 101.250259,59.996227 101.999550,59.994186 
	C102.948235,59.549854 103.896912,59.105526 104.921463,58.330444 
	C106.269501,58.436752 107.541664,58.873806 108.903236,59.654510 
	C108.655991,60.818851 108.319344,61.639538 107.551079,62.756123 
	C104.413193,63.321541 101.706924,63.591064 99.000656,63.860588 
z"/>
  <path fill="#4F70F2" opacity="1.000000" stroke="none" d="
M152.822983,89.076012 
	C152.555786,90.792915 152.288589,92.509819 151.998840,94.857674 
	C151.924988,95.656776 151.873688,95.824928 151.507019,96.001831 
	C150.460907,96.340378 149.730148,96.670197 148.602203,97.000031 
	C146.391312,97.583817 144.116013,97.662155 142.836502,98.830780 
	C132.012619,108.716537 121.345543,118.774849 110.683868,128.836945 
	C105.026672,134.176010 99.549576,139.751556 90.837349,139.290054 
	C90.239235,139.258362 89.613304,139.751541 88.696045,139.814682 
	C87.927849,138.086243 87.463921,136.543732 87.333054,135.000931 
	C88.110207,135.001236 88.554291,135.001831 89.102859,135.357651 
	C92.089806,138.423553 94.907051,136.953217 97.184837,135.078766 
	C101.594498,131.449982 105.708427,127.459320 109.910408,123.581245 
	C116.561996,117.442368 123.172279,111.258705 129.827896,105.124222 
	C131.980606,103.140068 134.132111,101.136864 136.439514,99.342064 
	C141.142899,95.683578 144.291000,89.815720 151.256561,88.988388 
	C151.675034,88.986900 151.842422,88.986046 152.213089,89.007874 
	C152.416382,89.030556 152.822983,89.076012 152.822983,89.076012 
z"/>
  <path fill="#4088F3" opacity="1.000000" stroke="none" d="
M120.000610,79.000610 
	C121.418243,80.743782 122.649948,80.882889 124.423386,79.152885 
	C130.308365,73.412056 136.465866,67.949387 142.315613,62.174183 
	C145.110077,59.415314 147.585770,60.602962 150.743439,62.186287 
	C151.393906,62.661957 151.613556,62.873291 152.060242,63.087814 
	C152.242508,63.137527 152.617615,63.183193 152.617615,63.183193 
	C152.636002,63.589180 152.654373,63.995167 152.332291,64.783401 
	C151.662048,65.777512 151.332245,66.389366 150.597198,67.001358 
	C146.225006,65.845352 145.995697,69.924271 144.090088,71.534081 
	C135.661118,78.654655 127.567276,86.173897 119.089287,93.233162 
	C116.879822,95.072899 113.723152,95.775055 111.000732,96.664948 
	C111.001213,95.883751 111.002487,95.437302 111.363663,94.884171 
	C112.957771,89.809509 115.723145,85.823196 119.370422,82.297371 
	C120.028160,81.661537 119.812851,80.122604 120.000610,79.000610 
z"/>
  <path fill="#4E7BE7" opacity="1.000000" stroke="none" d="
M151.002441,67.001221 
	C151.332245,66.389366 151.662048,65.777512 152.250153,65.077698 
	C152.596313,70.008827 152.684128,75.027916 152.532867,80.845665 
	C152.199142,84.091286 152.104462,86.538239 152.009796,88.985199 
	C151.842422,88.986046 151.675034,88.986900 151.255875,88.545425 
	C151.002930,85.734688 151.001770,83.366280 151.000854,80.581184 
	C151.000320,78.775558 150.999557,77.386604 150.999634,75.547943 
	C151.001129,72.399231 151.001785,69.700226 151.002441,67.001221 
z"/>
  <path fill="#221D57" opacity="1.000000" stroke="none" d="
M163.625000,84.260254 
	C162.660431,83.510368 162.001160,82.895126 161.341873,82.279884 
	C161.504913,81.898026 161.667953,81.516174 161.830994,81.134315 
	C163.072723,81.594147 164.314468,82.053978 165.556213,82.513794 
	C165.014236,83.140831 164.472260,83.767868 163.625000,84.260254 
z"/>
  <path fill="#221D57" opacity="1.000000" stroke="none" d="
M151.822372,95.993088 
	C151.873688,95.824928 151.924988,95.656776 152.060928,95.238823 
	C154.170258,94.660454 156.194946,94.331894 158.611725,94.001663 
	C156.985352,95.003960 154.966888,96.007927 152.485367,96.756439 
	C151.955673,96.331688 151.889023,96.162384 151.822372,95.993088 
z"/>
  <path fill="#3256BA" opacity="1.000000" stroke="none" d="
M152.213089,89.007874 
	C152.104462,86.538239 152.199142,84.091286 152.493225,81.308945 
	C152.769165,83.374771 152.845703,85.775986 152.872620,88.626602 
	C152.822983,89.076012 152.416382,89.030556 152.213089,89.007874 
z"/>
  <path fill="#4E7BE7" opacity="1.000000" stroke="none" d="
M151.877960,63.038105 
	C151.613556,62.873291 151.393906,62.661957 151.107437,62.203056 
	C150.994629,61.243908 150.993439,60.485802 151.002274,59.348717 
	C151.354050,59.725552 151.695801,60.481369 152.019394,61.851799 
	C151.960159,62.656975 151.919052,62.847542 151.877960,63.038105 
z"/>
  <path fill="#4088F3" opacity="1.000000" stroke="none" d="
M150.801498,57.723526 
	C150.537018,57.797894 150.337723,57.572601 150.116776,57.083691 
	C150.378220,56.966091 150.635391,57.167355 150.801498,57.723526 
z"/>
  <path fill="#3256BA" opacity="1.000000" stroke="none" d="
M152.060242,63.087814 
	C151.919052,62.847542 151.960159,62.656975 152.059647,62.179924 
	C152.314041,62.157654 152.510025,62.421867 152.661819,62.934639 
	C152.617615,63.183193 152.242508,63.137527 152.060242,63.087814 
z"/>
  <path fill="#3A90F5" opacity="1.000000" stroke="none" d="
M119.999939,78.666222 
	C119.812851,80.122604 120.028160,81.661537 119.370422,82.297371 
	C115.723145,85.823196 112.957771,89.809509 111.362793,94.432022 
	C110.986603,91.359383 110.971169,88.632210 111.115036,85.576080 
	C115.732834,81.989098 113.274971,77.100029 114.495056,72.986313 
	C115.551392,72.314941 116.275238,71.657166 116.999084,70.999390 
	C116.999084,70.999390 117.002991,70.502663 117.005699,70.254402 
	C117.513718,70.978020 118.153961,71.905792 118.489754,72.933067 
	C118.898293,74.182930 119.050438,75.516609 119.653000,76.904037 
	C119.994774,77.439980 119.997025,77.885902 119.999939,78.666222 
z"/>
  <path fill="#FCFEFD" opacity="1.000000" stroke="none" d="
M114.162560,72.999901 
	C113.274971,77.100029 115.732834,81.989098 110.799324,85.721069 
	C109.433830,87.169487 107.804871,88.124886 107.779129,89.121666 
	C107.659767,93.744507 107.985100,98.378838 108.075348,103.363861 
	C107.640656,105.085258 107.281815,106.451836 106.619659,107.876236 
	C105.872528,108.283165 105.428711,108.632271 104.601105,109.016022 
	C102.490334,109.316101 100.763344,109.581528 98.844177,109.545021 
	C93.358391,106.862183 95.608383,101.914429 94.890785,97.552628 
	C95.030922,92.329437 96.157036,87.136215 90.056496,84.416840 
	C89.290947,81.012085 88.551018,77.983612 87.811089,74.955139 
	C89.630905,69.728424 91.848457,64.881020 98.621613,63.938560 
	C101.706924,63.591064 104.413193,63.321541 107.533737,63.103058 
	C109.340523,65.010559 110.733025,66.867020 112.607132,69.170609 
	C113.446678,70.745117 113.804619,71.872513 114.162560,72.999901 
z"/>
  <path fill="#3598F5" opacity="1.000000" stroke="none" d="
M114.495056,72.986313 
	C113.804619,71.872513 113.446678,70.745117 112.909584,69.293701 
	C113.931229,69.598045 115.132027,70.226410 116.665955,70.927078 
	C116.275238,71.657166 115.551392,72.314941 114.495056,72.986313 
z"/>
  <path fill="#231E55" opacity="1.000000" stroke="none" d="
M149.319656,145.995575 
	C148.986221,139.638046 148.993805,133.282654 149.007706,126.457504 
	C149.454895,125.990143 149.895767,125.992523 150.667404,125.996994 
	C151.004211,132.351685 151.010254,138.704300 151.020630,145.524368 
	C150.570206,145.993790 150.115433,145.995743 149.319656,145.995575 
z"/>
  <path fill="#28225F" opacity="1.000000" stroke="none" d="
M134.321289,154.004761 
	C134.770767,153.678101 135.555984,153.345459 136.676208,153.003937 
	C136.226501,153.329605 135.441757,153.664185 134.321289,154.004761 
z"/>
  <path fill="#171246" opacity="1.000000" stroke="none" d="
M28.001497,125.431030 
	C28.446419,124.993469 28.886639,124.982391 29.895523,125.220482 
	C32.442585,126.612297 34.314625,128.027557 36.418575,128.848389 
	C43.847904,131.746796 48.099102,136.586502 47.004257,145.003632 
	C46.042896,148.031464 49.401398,152.607162 43.395844,153.984711 
	C42.528580,153.685150 42.057156,153.370300 41.295357,153.016083 
	C39.900974,152.320023 38.796963,151.663345 37.347870,151.001801 
	C36.154793,150.057770 35.487095,148.705215 34.430477,148.244354 
	C25.441919,144.323853 26.591829,136.759781 27.430605,129.283142 
	C27.559464,128.134552 27.805145,126.999062 28.001497,125.431030 
z"/>
  <path fill="#161246" opacity="1.000000" stroke="none" d="
M49.993896,154.009766 
	C49.325523,151.296402 48.657146,148.583023 47.993423,144.999817 
	C48.030735,133.532455 48.786224,132.566360 59.884697,129.450424 
	C60.014526,132.260178 60.081730,134.629272 60.089497,137.439301 
	C59.960369,140.252823 59.890678,142.625443 59.614044,145.278687 
	C58.721611,151.107758 53.671009,151.793777 49.993896,154.009766 
z"/>
  <path fill="#201B53" opacity="1.000000" stroke="none" d="
M59.822067,129.009781 
	C48.786224,132.566360 48.030735,133.532455 47.990891,144.571457 
	C47.983696,145.012955 47.493958,145.005203 47.249107,145.004425 
	C48.099102,136.586502 43.847904,131.746796 36.418575,128.848389 
	C34.314625,128.027557 32.442585,126.612297 30.225828,125.216339 
	C30.153622,123.801697 30.319773,122.640366 30.734272,121.229134 
	C30.982620,120.979225 31.000017,120.999084 31.070217,121.334251 
	C34.425697,123.782471 37.710976,125.895523 41.122406,128.212799 
	C41.451626,128.672623 41.700886,128.869858 42.215836,129.241653 
	C43.622391,129.985046 44.809437,130.495529 46.222980,131.230820 
	C48.299389,130.636475 50.149303,129.817322 52.315258,128.957932 
	C53.421043,128.278870 54.210785,127.640038 55.346016,126.993744 
	C56.794388,126.323891 57.897266,125.661514 59.207573,124.997665 
	C59.415001,124.996193 59.829842,124.991783 59.898277,125.390244 
	C59.918499,126.862404 59.870281,127.936089 59.822067,129.009781 
z"/>
  <path fill="#221C51" opacity="1.000000" stroke="none" d="
M50.030415,154.297485 
	C53.671009,151.793777 58.721611,151.107758 59.676384,145.713135 
	C59.922764,147.915924 59.899853,149.964890 59.876942,152.013840 
	C57.146461,153.307343 54.415981,154.600830 51.336811,155.945572 
	C50.681057,155.526276 50.373993,155.055756 50.030415,154.297485 
z"/>
  <path fill="#221D54" opacity="1.000000" stroke="none" d="
M30.993073,120.234314 
	C34.097488,117.696518 37.194374,115.399078 40.647991,113.051117 
	C41.004719,113.000587 40.999859,113.000069 40.946190,113.344139 
	C37.595024,116.125168 34.297520,118.562126 31.000017,120.999084 
	C31.000017,120.999084 30.982620,120.979225 30.972488,120.967163 
	C30.962358,120.955101 30.985542,120.474686 30.993073,120.234314 
z"/>
  <path fill="#2BA8F5" opacity="1.000000" stroke="none" d="
M50.084976,101.434761 
	C51.086796,102.009155 52.023018,103.024414 53.388721,104.505409 
	C53.773010,102.096519 54.132309,99.844284 54.744827,97.297928 
	C55.036655,99.796692 56.059879,100.385170 58.128937,98.345596 
	C61.530056,94.992912 64.620308,91.256477 68.341599,88.314194 
	C73.064339,84.580101 78.286407,81.477524 83.649216,78.300476 
	C84.005272,78.498329 84.006104,78.991608 84.039368,79.282104 
	C84.380440,80.047020 84.688255,80.521439 84.945564,81.340660 
	C84.596214,82.269287 84.425941,82.986481 83.979324,83.417023 
	C76.857391,90.282684 69.795715,97.216660 62.483677,103.875206 
	C60.656532,105.539055 57.997002,106.288818 55.335960,107.656044 
	C55.484821,109.084702 55.740360,111.537170 55.997448,113.994698 
	C55.998997,113.999748 55.990433,113.999649 55.856792,114.100090 
	C55.543331,114.535988 55.633236,114.802864 56.132687,115.308594 
	C56.495831,116.476204 56.719158,117.336395 56.704254,118.168533 
	C56.466026,118.140495 55.994141,118.226524 55.760551,118.134422 
	C55.363724,118.005264 55.200485,117.968216 54.911697,117.637177 
	C53.806198,116.227219 52.826244,115.111229 51.854507,113.739479 
	C51.589863,113.297318 51.317001,113.110924 51.035576,112.944427 
	C51.027004,112.964340 51.066349,112.941277 51.066345,112.941277 
	C50.701412,111.856201 50.336479,110.771133 49.886723,109.345444 
	C49.874397,106.628426 49.946888,104.252029 50.084976,101.434761 
z"/>
  <path fill="#181448" opacity="1.000000" stroke="none" d="
M51.846287,113.995247 
	C52.826244,115.111229 53.806198,116.227219 54.741688,117.934647 
	C49.496746,121.540863 54.743099,124.181770 55.000534,127.001221 
	C54.210785,127.640038 53.421043,128.278870 52.237610,128.616699 
	C50.562618,126.210472 49.281311,124.105232 48.257980,121.954445 
	C48.813087,121.630783 49.110222,121.352684 49.407360,121.074585 
	C49.220943,120.917183 49.034523,120.759781 48.848103,120.602386 
	C48.565399,121.068260 48.282700,121.534126 47.604851,122.002083 
	C43.317066,122.120728 40.582378,123.435562 40.996254,128.008575 
	C37.710976,125.895523 34.425697,123.782471 31.070217,121.334251 
	C34.297520,118.562126 37.595024,116.125168 40.945694,113.342194 
	C44.049103,112.989258 47.099342,112.982346 50.607964,112.958359 
	C51.066349,112.941277 51.027004,112.964340 51.118767,113.156853 
	C51.374088,113.612259 51.586006,113.827553 51.846287,113.995247 
z"/>
  <path fill="#1BB1D6" opacity="1.000000" stroke="none" d="
M50.158543,96.327255 
	C50.485149,96.154770 50.680603,96.353493 50.919945,96.790054 
	C50.901756,97.254562 50.739071,97.496864 50.349495,97.835709 
	C50.141178,97.527039 50.109421,97.088028 50.158543,96.327255 
z"/>
  <path fill="#5565F1" opacity="1.000000" stroke="none" d="
M151.507019,96.001831 
	C151.889023,96.162384 151.955673,96.331688 152.105804,96.760918 
	C152.103271,99.070404 152.017242,101.119965 151.591248,103.800026 
	C148.652817,108.267639 147.298798,112.912674 142.116806,114.845978 
	C138.436264,116.219124 135.751236,119.345238 135.684784,124.054749 
	C132.589645,125.855782 129.808304,127.510651 127.026947,129.165527 
	C126.092659,129.549957 125.158363,129.934387 124.105423,130.616669 
	C118.547005,133.836777 113.107231,136.759033 107.353836,139.397705 
	C108.894676,137.398880 110.876221,135.797684 112.555969,133.925674 
	C113.564224,132.802017 114.101425,131.255722 115.183273,129.296387 
	C121.408821,130.509918 123.996277,123.851089 128.219162,120.170288 
	C132.887024,116.101639 136.683792,111.046417 141.042267,106.599571 
	C141.955246,105.668098 143.663025,105.515648 145.103790,105.138184 
	C145.203033,105.272148 145.652084,105.341431 145.652084,105.341431 
	C145.652084,105.341431 145.998917,105.004242 146.144897,104.680489 
	C147.193710,101.904488 148.096542,99.452248 148.999390,97.000000 
	C149.730148,96.670197 150.460907,96.340378 151.507019,96.001831 
z"/>
  <path fill="#5B61EE" opacity="1.000000" stroke="none" d="
M135.998550,123.908592 
	C135.751236,119.345238 138.436264,116.219124 142.116806,114.845978 
	C147.298798,112.912674 148.652817,108.267639 151.526245,104.235855 
	C151.573898,106.765030 151.346542,109.488869 151.061020,112.617447 
	C149.116714,114.844925 147.230576,116.667656 144.858566,118.881500 
	C141.581314,120.817932 138.789932,122.363266 135.998550,123.908592 
z"/>
  <path fill="#161346" opacity="1.000000" stroke="none" d="
M135.684784,124.054756 
	C138.789932,122.363266 141.581314,120.817932 144.701538,119.176422 
	C145.650543,120.173599 146.270721,121.266937 146.580307,122.729889 
	C143.177597,125.068024 140.085464,127.036552 136.993347,129.005081 
	C136.993347,129.005081 136.999451,129.000275 137.003021,128.997162 
	C135.439499,129.692947 133.908951,130.835205 132.295227,130.968155 
	C130.624924,131.105789 128.873947,130.264145 127.092598,129.508179 
	C129.808304,127.510651 132.589645,125.855782 135.684784,124.054756 
z"/>
  <path fill="#201D57" opacity="1.000000" stroke="none" d="
M137.380096,129.003525 
	C140.085464,127.036552 143.177597,125.068024 146.620148,123.046173 
	C147.293884,123.455879 147.617218,123.918900 147.985046,124.668427 
	C144.608658,126.303947 141.187744,127.652954 137.380096,129.003525 
z"/>
  <path fill="#3F88F2" opacity="1.000000" stroke="none" d="
M94.825821,97.998566 
	C95.608383,101.914429 93.358391,106.862183 98.975883,109.786743 
	C99.224388,110.886093 99.355003,111.723747 99.041145,111.953079 
	C96.427620,113.862671 93.554710,115.450768 91.097198,117.533638 
	C85.419029,122.346176 82.159225,130.705948 71.208870,128.909851 
	C73.021332,132.105942 73.929337,134.111511 75.194283,135.858673 
	C78.437805,140.338699 81.898804,144.661896 85.110298,149.163757 
	C85.553322,149.784790 85.074127,151.063690 85.021881,152.038025 
	C84.820198,152.310791 84.618523,152.583542 84.193428,152.988159 
	C83.488228,153.343979 83.006447,153.567932 82.118484,153.628113 
	C81.512444,153.254669 81.277771,153.096710 81.069794,152.679153 
	C81.590530,151.540512 82.049767,150.713181 82.440453,150.009338 
	C80.933380,148.715790 79.331390,147.768829 78.312973,146.390640 
	C74.436829,141.145233 70.607185,135.852249 67.071152,130.376221 
	C65.899521,128.561798 65.664673,126.142464 65.334396,123.999260 
	C66.111092,123.998314 66.554916,123.997803 67.340179,124.150253 
	C69.812065,124.004364 72.382431,124.358948 73.986801,123.278763 
	C78.076752,120.525093 81.636742,116.998497 85.602867,114.041504 
	C88.070053,112.202049 90.592560,110.647423 90.068710,106.684433 
	C90.755089,105.241653 91.375275,104.119400 91.996841,102.618515 
	C92.555359,100.569183 90.390282,97.083626 94.825821,97.998566 
z"/>
  <path fill="#4580F1" opacity="1.000000" stroke="none" d="
M85.340736,151.976746 
	C85.074127,151.063690 85.553322,149.784790 85.110298,149.163757 
	C81.898804,144.661896 78.437805,140.338699 75.194283,135.858673 
	C73.929337,134.111511 73.021332,132.105942 71.208870,128.909851 
	C82.159225,130.705948 85.419029,122.346176 91.097198,117.533638 
	C93.554710,115.450768 96.427620,113.862671 99.041145,111.953079 
	C99.355003,111.723747 99.224388,110.886093 99.168076,110.088684 
	C100.763344,109.581528 102.490334,109.316101 104.605431,109.414139 
	C104.174263,111.839378 103.803070,114.280556 102.444176,115.885422 
	C99.439903,119.433472 95.921043,122.543343 92.645195,125.864616 
	C89.268677,129.287949 86.234749,133.256897 80.465065,132.215240 
	C79.834656,132.101440 78.989388,133.177811 78.266991,133.685837 
	C79.534843,136.023300 80.316650,138.315002 81.801155,139.980301 
	C83.546288,141.937973 85.901253,143.352036 87.994217,145.334625 
	C87.999123,146.111130 88.001587,146.554840 88.191177,147.220963 
	C88.918533,147.628693 89.458748,147.814041 89.998260,148.209854 
	C89.997559,148.420319 89.995232,148.841248 89.995232,148.841248 
	C89.702202,149.008347 89.409172,149.175430 88.995102,149.567108 
	C87.802582,150.499619 86.731087,151.207550 85.340736,151.976746 
z"/>
  <path fill="#2AA6F3" opacity="1.000000" stroke="none" d="
M60.026947,152.330658 
	C59.899853,149.964890 59.922764,147.915924 59.883327,145.432510 
	C59.890678,142.625443 59.960369,140.252823 60.429897,137.553955 
	C61.418255,139.022659 62.006779,140.817642 62.805576,143.253967 
	C62.948418,141.176041 63.048641,139.718079 63.148865,138.260117 
	C63.368736,138.262024 63.588608,138.263916 63.808475,138.265823 
	C63.874290,138.843063 63.940102,139.420319 64.003418,140.424057 
	C64.036621,145.515106 69.206573,151.812393 74.213120,153.246735 
	C75.665016,154.003662 76.887947,154.524536 78.110886,155.045410 
	C71.243408,161.125778 64.982864,160.288681 60.026947,152.330658 
z"/>
  <path fill="#3895F4" opacity="1.000000" stroke="none" d="
M78.463211,155.044632 
	C76.887947,154.524536 75.665016,154.003662 74.161522,152.868713 
	C73.587509,150.502869 73.294060,148.751129 73.342567,147.050644 
	C76.125778,149.064758 78.567032,151.027603 81.008286,152.990463 
	C81.277771,153.096710 81.512444,153.254669 81.841614,153.634338 
	C80.919128,154.217514 79.867332,154.630692 78.463211,155.044632 
z"/>
  <path fill="#526BF1" opacity="1.000000" stroke="none" d="
M145.004547,105.004211 
	C143.663025,105.515648 141.955246,105.668098 141.042267,106.599571 
	C136.683792,111.046417 132.887024,116.101639 128.219162,120.170288 
	C123.996277,123.851089 121.408821,130.509918 115.183273,129.296387 
	C114.101425,131.255722 113.564224,132.802017 112.555969,133.925674 
	C110.876221,135.797684 108.894676,137.398880 107.020477,139.463104 
	C102.921959,141.858856 98.843185,143.905624 94.157768,145.755035 
	C92.034187,143.705338 90.517242,141.852966 89.000305,140.000610 
	C89.613304,139.751541 90.239235,139.258362 90.837349,139.290054 
	C99.549576,139.751556 105.026672,134.176010 110.683868,128.836945 
	C121.345543,118.774849 132.012619,108.716537 142.836502,98.830780 
	C144.116013,97.662155 146.391312,97.583817 148.602203,97.000031 
	C148.096542,99.452248 147.193710,101.904488 145.896301,104.679962 
	C145.501755,105.003197 145.004547,105.004211 145.004547,105.004211 
z"/>
  <path fill="#4B74F1" opacity="1.000000" stroke="none" d="
M88.696045,139.814682 
	C90.517242,141.852966 92.034187,143.705338 93.798431,145.791550 
	C92.908920,146.936417 91.772095,147.847443 90.315247,148.799850 
	C89.995232,148.841248 89.997559,148.420319 89.810715,147.987900 
	C89.083923,147.369843 88.543983,147.184204 88.004044,146.998566 
	C88.001587,146.554840 87.999123,146.111130 87.945175,144.988556 
	C86.564262,142.458450 85.043823,140.712601 83.950249,138.731186 
	C82.314911,135.768173 83.104134,134.895081 87.000000,135.001221 
	C87.463921,136.543732 87.927849,138.086243 88.696045,139.814682 
z"/>
  <path fill="#30A1F4" opacity="1.000000" stroke="none" d="
M84.006104,78.991608 
	C84.006104,78.991608 84.005272,78.498329 84.003677,78.251755 
	C85.091454,76.819244 83.335480,72.849411 87.595016,74.754456 
	C88.551018,77.983612 89.290947,81.012085 90.007050,84.754761 
	C90.626007,87.994919 91.268784,90.520866 91.911560,93.046822 
	C91.555687,93.175323 91.199821,93.303818 90.843956,93.432320 
	C90.262383,92.400917 89.680817,91.369514 88.979294,90.125389 
	C82.202621,96.133034 75.411629,101.618752 69.292709,107.772705 
	C65.447319,111.640129 61.613125,114.428749 55.995899,113.989647 
	C55.740360,111.537170 55.484821,109.084702 55.335960,107.656044 
	C57.997002,106.288818 60.656532,105.539055 62.483677,103.875206 
	C69.795715,97.216660 76.857391,90.282684 83.979324,83.417023 
	C84.425941,82.986481 84.596214,82.269287 84.912430,81.050522 
	C84.621910,79.940926 84.314011,79.466270 84.006104,78.991608 
z"/>
  <path fill="#2AAAF4" opacity="1.000000" stroke="none" d="
M101.797226,59.774193 
	C101.250259,59.996227 100.500969,59.998268 99.377075,60.000362 
	C99.866615,59.851681 100.730759,59.702942 101.797226,59.774193 
z"/>
  <path fill="#487AF2" opacity="1.000000" stroke="none" d="
M87.333061,135.000931 
	C83.104134,134.895081 82.314911,135.768173 83.950249,138.731186 
	C85.043823,140.712601 86.564262,142.458450 87.942719,144.655777 
	C85.901253,143.352036 83.546288,141.937973 81.801155,139.980301 
	C80.316650,138.315002 79.534843,136.023300 78.266991,133.685837 
	C78.989388,133.177811 79.834656,132.101440 80.465065,132.215240 
	C86.234749,133.256897 89.268677,129.287949 92.645195,125.864616 
	C95.921043,122.543343 99.439903,119.433472 102.444176,115.885422 
	C103.803070,114.280556 104.174263,111.839378 104.989212,109.379486 
	C105.428711,108.632271 105.872528,108.283165 106.647278,108.222610 
	C107.504639,111.615929 108.426689,110.526718 110.033241,109.046974 
	C115.990585,103.559860 122.009949,98.127983 128.217621,92.927956 
	C135.228317,87.055237 142.623230,81.606773 147.575790,73.358109 
	C148.556427,74.114296 149.777618,75.055977 150.998810,75.997658 
	C150.999557,77.386604 151.000320,78.775558 150.641541,80.598053 
	C148.686127,82.354828 147.067581,83.651810 145.498199,85.005791 
	C138.087402,91.399376 130.552841,97.657951 123.320465,104.247902 
	C112.776520,113.855286 102.467400,123.720116 92.008408,133.421555 
	C91.206352,134.165527 90.010948,134.485428 88.998375,135.002441 
	C88.554291,135.001831 88.110207,135.001236 87.333061,135.000931 
z"/>
  <path fill="#4C75F2" opacity="1.000000" stroke="none" d="
M89.102859,135.357651 
	C90.010948,134.485428 91.206352,134.165527 92.008408,133.421555 
	C102.467400,123.720116 112.776520,113.855286 123.320465,104.247902 
	C130.552841,97.657951 138.087402,91.399376 145.498199,85.005791 
	C147.067581,83.651810 148.686127,82.354828 150.641312,81.014732 
	C151.001770,83.366280 151.002930,85.734688 151.004791,88.546059 
	C144.291000,89.815720 141.142899,95.683578 136.439514,99.342064 
	C134.132111,101.136864 131.980606,103.140068 129.827896,105.124222 
	C123.172279,111.258705 116.561996,117.442368 109.910408,123.581245 
	C105.708427,127.459320 101.594498,131.449982 97.184837,135.078766 
	C94.907051,136.953217 92.089806,138.423553 89.102859,135.357651 
z"/>
  <path fill="#4481F3" opacity="1.000000" stroke="none" d="
M150.999634,75.547943 
	C149.777618,75.055977 148.556427,74.114296 147.575790,73.358109 
	C142.623230,81.606773 135.228317,87.055237 128.217621,92.927956 
	C122.009949,98.127983 115.990585,103.559860 110.033241,109.046974 
	C108.426689,110.526718 107.504639,111.615929 106.950592,108.164787 
	C107.281815,106.451836 107.640656,105.085258 108.454048,103.332146 
	C109.606239,100.963638 110.303886,98.981667 111.001526,96.999695 
	C113.723152,95.775055 116.879822,95.072899 119.089287,93.233162 
	C127.567276,86.173897 135.661118,78.654655 144.090088,71.534081 
	C145.995697,69.924271 146.225006,65.845352 150.597198,67.001358 
	C151.001785,69.700226 151.001129,72.399231 150.999634,75.547943 
z"/>
  <path fill="#3E8EEC" opacity="1.000000" stroke="none" d="
M111.000732,96.664948 
	C110.303886,98.981667 109.606239,100.963638 108.529907,102.977325 
	C107.985100,98.378838 107.659767,93.744507 107.779129,89.121666 
	C107.804871,88.124886 109.433830,87.169487 110.640015,86.050034 
	C110.971169,88.632210 110.986603,91.359383 111.002899,94.538696 
	C111.002487,95.437302 111.001213,95.883751 111.000732,96.664948 
z"/>
  <path fill="#3598F4" opacity="1.000000" stroke="none" d="
M55.997448,113.994698 
	C61.613125,114.428749 65.447319,111.640129 69.292709,107.772705 
	C75.411629,101.618752 82.202621,96.133034 88.979294,90.125389 
	C89.680817,91.369514 90.262383,92.400917 90.843956,93.432320 
	C91.199821,93.303818 91.555687,93.175323 91.911560,93.046822 
	C91.268784,90.520866 90.626007,87.994919 90.032669,85.131042 
	C96.157036,87.136215 95.030922,92.329437 94.890785,97.552628 
	C90.390282,97.083626 92.555359,100.569183 91.671532,102.536758 
	C90.541061,101.710518 89.737282,100.587418 88.722916,99.170082 
	C82.568527,104.516823 76.476707,109.708481 70.514641,115.045105 
	C68.506737,116.842384 66.828369,119.007820 64.624542,121.003922 
	C63.500000,121.002106 62.750305,121.001358 61.857937,120.699211 
	C60.455772,119.985107 59.196281,119.572411 57.706074,119.074570 
	C57.168381,118.812088 56.990757,118.547806 56.942486,118.196579 
	C56.719158,117.336395 56.495831,116.476204 56.133621,115.058212 
	C55.993305,114.333488 55.991871,114.166573 55.990433,113.999649 
	C55.990433,113.999649 55.998997,113.999748 55.997448,113.994698 
z"/>
  <path fill="#3895F4" opacity="1.000000" stroke="none" d="
M57.936787,119.159714 
	C59.196281,119.572411 60.455772,119.985107 61.857773,121.133820 
	C61.269924,129.742569 66.505684,134.741653 70.700981,140.314423 
	C71.888893,141.892365 72.255501,144.088562 72.657021,145.946976 
	C69.545479,143.927673 66.775696,141.962616 64.005920,139.997559 
	C63.940102,139.420319 63.874290,138.843063 63.808475,138.265823 
	C63.588608,138.263916 63.368736,138.262024 63.148865,138.260117 
	C63.048641,139.718079 62.948418,141.176041 62.805576,143.253967 
	C62.006779,140.817642 61.418255,139.022659 60.489334,137.113037 
	C60.081730,134.629272 60.014526,132.260178 59.884697,129.450424 
	C59.870281,127.936089 59.918499,126.862404 59.960129,125.007172 
	C59.634636,122.868919 59.315727,121.512192 58.762630,120.077911 
	C58.528442,120.000351 58.042469,119.915062 58.008713,119.727249 
	C57.974960,119.539436 57.936787,119.159714 57.936787,119.159714 
z"/>
  <path fill="#161246" opacity="1.000000" stroke="none" d="
M41.122406,128.212799 
	C40.582378,123.435562 43.317066,122.120728 47.604855,122.002083 
	C49.281311,124.105232 50.562618,126.210472 51.921570,128.656937 
	C50.149303,129.817322 48.299389,130.636475 46.207596,130.871887 
	C45.415730,127.463005 43.923782,127.560295 41.996330,129.008728 
	C41.700886,128.869858 41.451626,128.672623 41.122406,128.212799 
z"/>
  <path fill="#161246" opacity="1.000000" stroke="none" d="
M58.042469,119.915062 
	C58.042469,119.915062 58.528442,120.000351 58.763573,120.481209 
	C58.999180,122.307755 58.999660,123.653442 59.000145,124.999130 
	C57.897266,125.661514 56.794388,126.323891 55.346020,126.993744 
	C54.743099,124.181770 49.496746,121.540863 54.867233,118.228622 
	C55.200485,117.968216 55.363724,118.005264 55.724575,118.414574 
	C55.946388,119.398079 55.970596,120.009331 55.994804,120.620583 
	C56.677361,120.385414 57.359917,120.150238 58.042469,119.915062 
z"/>
  <path fill="#181448" opacity="1.000000" stroke="none" d="
M42.215836,129.241653 
	C43.923782,127.560295 45.415730,127.463005 45.981102,130.647064 
	C44.809437,130.495529 43.622391,129.985046 42.215836,129.241653 
z"/>
  <path fill="#181448" opacity="1.000000" stroke="none" d="
M59.207573,124.997665 
	C58.999660,123.653442 58.999180,122.307755 58.997757,120.558769 
	C59.315727,121.512192 59.634636,122.868919 59.891693,124.608711 
	C59.829842,124.991783 59.415001,124.996193 59.207573,124.997665 
z"/>
  <path fill="#181448" opacity="1.000000" stroke="none" d="
M58.008713,119.727249 
	C57.359917,120.150238 56.677361,120.385414 55.994804,120.620583 
	C55.970596,120.009331 55.946388,119.398079 55.958160,118.506676 
	C55.994141,118.226524 56.466026,118.140495 56.704254,118.168533 
	C56.990757,118.547806 57.168381,118.812088 57.706074,119.074570 
	C57.936787,119.159714 57.974960,119.539436 58.008713,119.727249 
z"/>
  <path fill="#25B0F5" opacity="1.000000" stroke="none" d="
M84.039368,79.282104 
	C84.314011,79.466270 84.621910,79.940926 84.962952,80.705727 
	C84.688255,80.521439 84.380440,80.047020 84.039368,79.282104 
z"/>
  <path fill="#30A1F4" opacity="1.000000" stroke="none" d="
M55.856792,114.100090 
	C55.991871,114.166573 55.993305,114.333488 55.993805,114.750793 
	C55.633236,114.802864 55.543331,114.535988 55.856792,114.100090 
z"/>
  <path fill="#241F59" opacity="1.000000" stroke="none" d="
M51.854507,113.739479 
	C51.586006,113.827553 51.374088,113.612259 51.127335,113.136948 
	C51.317001,113.110924 51.589863,113.297318 51.854507,113.739479 
z"/>
  <path fill="#161246" opacity="1.000000" stroke="none" d="
M48.257977,121.954445 
	C48.282700,121.534126 48.565399,121.068260 48.848103,120.602386 
	C49.034523,120.759781 49.220943,120.917183 49.407360,121.074585 
	C49.110222,121.352684 48.813087,121.630783 48.257977,121.954445 
z"/>
  <path fill="#5B61EE" opacity="1.000000" stroke="none" d="
M145.103790,105.138184 
	C145.004547,105.004211 145.501755,105.003197 145.750336,105.003723 
	C145.998917,105.004242 145.652084,105.341431 145.652084,105.341431 
	C145.652084,105.341431 145.203033,105.272148 145.103790,105.138184 
z"/>
  <path fill="#3893F3" opacity="1.000000" stroke="none" d="
M64.999390,121.004990 
	C66.828369,119.007820 68.506737,116.842384 70.514641,115.045105 
	C76.476707,109.708481 82.568527,104.516823 88.722916,99.170082 
	C89.737282,100.587418 90.541061,101.710518 91.670151,102.915382 
	C91.375275,104.119400 90.755089,105.241653 89.765152,106.551689 
	C88.297386,106.818100 86.828613,106.465897 86.158936,107.042236 
	C79.695427,112.604713 73.366287,118.323318 66.998741,123.997299 
	C66.554916,123.997803 66.111092,123.998314 65.334023,123.624863 
	C65.000313,122.502266 64.999847,121.753632 64.999390,121.004990 
z"/>
  <path fill="#3B8FF3" opacity="1.000000" stroke="none" d="
M67.340179,124.150253 
	C73.366287,118.323318 79.695427,112.604713 86.158936,107.042236 
	C86.828613,106.465897 88.297386,106.818100 89.698959,106.872208 
	C90.592560,110.647423 88.070053,112.202049 85.602867,114.041504 
	C81.636742,116.998497 78.076752,120.525093 73.986801,123.278763 
	C72.382431,124.358948 69.812065,124.004364 67.340179,124.150253 
z"/>
  <path fill="#3B8FF3" opacity="1.000000" stroke="none" d="
M64.624542,121.003922 
	C64.999847,121.753632 65.000313,122.502266 65.001152,123.625305 
	C65.664673,126.142464 65.899521,128.561798 67.071152,130.376221 
	C70.607185,135.852249 74.436829,141.145233 78.312973,146.390640 
	C79.331390,147.768829 80.933380,148.715790 82.440453,150.009338 
	C82.049767,150.713181 81.590530,151.540512 81.069794,152.679153 
	C78.567032,151.027603 76.125778,149.064758 73.342110,146.801102 
	C72.999695,146.500305 72.998779,146.001221 72.998779,146.001221 
	C72.255501,144.088562 71.888893,141.892365 70.700981,140.314423 
	C66.505684,134.741653 61.269924,129.742569 62.000450,121.435211 
	C62.750305,121.001358 63.500000,121.002106 64.624542,121.003922 
z"/>
  <path fill="#487AF2" opacity="1.000000" stroke="none" d="
M88.191177,147.220963 
	C88.543983,147.184204 89.083923,147.369843 89.811417,147.777435 
	C89.458748,147.814041 88.918533,147.628693 88.191177,147.220963 
z"/>
  <path fill="#339CF4" opacity="1.000000" stroke="none" d="
M72.657021,145.946976 
	C72.998779,146.001221 72.999695,146.500305 73.000153,146.749847 
	C73.294060,148.751129 73.587509,150.502869 73.932564,152.632645 
	C69.206573,151.812393 64.036621,145.515106 64.003426,140.424057 
	C66.775696,141.962616 69.545479,143.927673 72.657021,145.946976 
z"/>
</svg>

  )
}

const Container = styled.div<{ clickable?: boolean }>`
  position: relative;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'auto')};
  display: flex;
  justify-content: center;
  align-items: center;
`

type NavIconProps = SVGProps & {
  clickable?: boolean
  onClick?: () => void
}

export const NavIcon = ({ clickable, onClick, ...props }: NavIconProps) => (
  <Container clickable={clickable}>
    {HolidayUniIcon(props) !== null ? <HolidayUniIcon {...props} /> : <Logo onClick={onClick} />}
  </Container>
)
